(function() {
/* =============================================================================
 * PATCH — Internal San Jose (Ryan) — re-applied 2026-09-06
 * -----------------------------------------------------------------------------
 * Thinkspace vendor code below. San Jose did not author this bundle.
 * This is the newer vendor build that Thinkspace shipped to the live theme,
 * with our patches re-applied on top. The vendor upload had wiped all of them.
 *
 * Pendant only (rings unchanged) — customizable pendants hide the Band step and
 * omit the finger-band mesh, but the vendor still defaults a selected_band, so
 * band price leaked into the total / _addons_price:
 *   1) Do not add band price into the total
 *   2) Do not keep a default selected_band (init + re-sync)
 *   3) Do not emit a band_style line-item prop
 *
 * Rings + pendants:
 *   4) Always expose the controller on the host element as __w / __wiz so theme
 *      enhancers (sj-gemstone-enhancer stone patterns, etc.) can set
 *      gemstone_colors without driving the Group color popovers.
 *      Vendor only attaches these under IS_DEV_ENV / ?_debug=1.
 *
 * Re-apply after any Thinkspace asset upgrade that overwrites this file.
 * Search markers: "SJ patch".
 * =============================================================================
 */
var ff = Object.defineProperty;
var hf = Object.getPrototypeOf;
var pf = Reflect.get;
var sc = (e) => {
  throw TypeError(e);
};
var vf = (e, t, n) => t in e ? ff(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var it = (e, t, n) => vf(e, typeof t != "symbol" ? t + "" : t, n), Aa = (e, t, n) => t.has(e) || sc("Cannot " + n);
var f = (e, t, n) => (Aa(e, t, "read from private field"), n ? n.call(e) : t.get(e)), N = (e, t, n) => t.has(e) ? sc("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), vt = (e, t, n, r) => (Aa(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), ce = (e, t, n) => (Aa(e, t, "access private method"), n);
var ac = (e, t, n) => pf(hf(e), n, t);
var $i = Array.isArray, gf = Array.prototype.indexOf, wl = Array.from, mf = Object.defineProperty, Ar = Object.getOwnPropertyDescriptor, _f = Object.getOwnPropertyDescriptors, uu = Object.prototype, wf = Array.prototype, bl = Object.getPrototypeOf, lc = Object.isExtensible;
function Wo(e) {
  return typeof e == "function";
}
const Re = () => {
};
function du(e) {
  for (var t = 0; t < e.length; t++)
    e[t]();
}
function qn(e, t, n = !1) {
  return e === void 0 ? n ? (
    /** @type {() => V} */
    t()
  ) : (
    /** @type {V} */
    t
  ) : e;
}
function ka(e, t) {
  if (Array.isArray(e))
    return e;
  if (!(Symbol.iterator in e))
    return Array.from(e);
  const n = [];
  for (const r of e)
    if (n.push(r), n.length === t) break;
  return n;
}
const In = 2, fu = 4, da = 8, yl = 16, fr = 32, Qr = 64, As = 128, bn = 256, ks = 512, cn = 1024, Kn = 2048, Ir = 4096, ar = 8192, fa = 16384, bf = 32768, ts = 65536, yf = 1 << 19, hu = 1 << 20, ja = 1 << 21, kr = Symbol("$state"), pu = Symbol("legacy props"), xf = Symbol("");
function vu(e) {
  return e === this.v;
}
function Sf(e, t) {
  return e != e ? t == t : e !== t || e !== null && typeof e == "object" || typeof e == "function";
}
function Cf(e, t) {
  return e !== t;
}
function xl(e) {
  return !Sf(e, this.v);
}
function Af(e) {
  throw new Error("https://svelte.dev/e/effect_in_teardown");
}
function kf() {
  throw new Error("https://svelte.dev/e/effect_in_unowned_derived");
}
function Ef(e) {
  throw new Error("https://svelte.dev/e/effect_orphan");
}
function Of() {
  throw new Error("https://svelte.dev/e/effect_update_depth_exceeded");
}
function Tf(e) {
  throw new Error("https://svelte.dev/e/props_invalid_value");
}
function Pf() {
  throw new Error("https://svelte.dev/e/state_descriptors_fixed");
}
function If() {
  throw new Error("https://svelte.dev/e/state_prototype_fixed");
}
function Nf() {
  throw new Error("https://svelte.dev/e/state_unsafe_mutation");
}
let gu = !1;
const Sl = 1, Cl = 2, mu = 4, Rf = 8, Ff = 16, Lf = 1, Mf = 4, zf = 8, Df = 16, Bf = 1, Vf = 2, on = Symbol(), jf = "http://www.w3.org/1999/xhtml", _u = "@attach", Wf = [];
function Uf(e, t = !1) {
  return ws(e, /* @__PURE__ */ new Map(), "", Wf);
}
function ws(e, t, n, r, o = null) {
  if (typeof e == "object" && e !== null) {
    var i = t.get(e);
    if (i !== void 0) return i;
    if (e instanceof Map) return (
      /** @type {Snapshot<T>} */
      new Map(e)
    );
    if (e instanceof Set) return (
      /** @type {Snapshot<T>} */
      new Set(e)
    );
    if ($i(e)) {
      var s = (
        /** @type {Snapshot<any>} */
        Array(e.length)
      );
      t.set(e, s), o !== null && t.set(o, s);
      for (var d = 0; d < e.length; d += 1) {
        var a = e[d];
        d in e && (s[d] = ws(a, t, n, r));
      }
      return s;
    }
    if (bl(e) === uu) {
      s = {}, t.set(e, s), o !== null && t.set(o, s);
      for (var c in e)
        s[c] = ws(e[c], t, n, r);
      return s;
    }
    if (e instanceof Date)
      return (
        /** @type {Snapshot<T>} */
        structuredClone(e)
      );
    if (typeof /** @type {T & { toJSON?: any } } */
    e.toJSON == "function")
      return ws(
        /** @type {T & { toJSON(): any } } */
        e.toJSON(),
        t,
        n,
        r,
        // Associate the instance with the toJSON clone
        e
      );
  }
  if (e instanceof EventTarget)
    return (
      /** @type {Snapshot<T>} */
      e
    );
  try {
    return (
      /** @type {Snapshot<T>} */
      structuredClone(e)
    );
  } catch {
    return (
      /** @type {Snapshot<T>} */
      e
    );
  }
}
function wu(e) {
  throw new Error("https://svelte.dev/e/lifecycle_outside_component");
}
let je = null;
function cc(e) {
  je = e;
}
function uc(e) {
  return (
    /** @type {T} */
    ha().get(e)
  );
}
function qf(e, t) {
  return ha().set(e, t), t;
}
function Kf(e) {
  return ha().has(e);
}
function Gf() {
  return ha();
}
function Kt(e, t = !1, n) {
  var r = je = {
    p: je,
    c: null,
    d: !1,
    e: null,
    m: !1,
    s: e,
    x: null,
    l: null
  };
  Pu(() => {
    r.d = !0;
  });
}
function Gt(e) {
  const t = je;
  if (t !== null) {
    const s = t.e;
    if (s !== null) {
      var n = se, r = $t;
      t.e = null;
      try {
        for (var o = 0; o < s.length; o++) {
          var i = s[o];
          Or(i.effect), Hn(i.reaction), Mo(i.fn);
        }
      } finally {
        Or(n), Hn(r);
      }
    }
    je = t.p, t.m = !0;
  }
  return (
    /** @type {T} */
    {}
  );
}
function bu() {
  return !gu;
}
function ha(e) {
  return je === null && wu(), je.c ?? (je.c = new Map(Hf(je) || void 0));
}
function Hf(e) {
  let t = e.p;
  for (; t !== null; ) {
    const n = t.c;
    if (n !== null)
      return n;
    t = t.p;
  }
  return null;
}
function Xt(e) {
  if (typeof e != "object" || e === null || kr in e)
    return e;
  const t = bl(e);
  if (t !== uu && t !== wf)
    return e;
  var n = /* @__PURE__ */ new Map(), r = $i(e), o = /* @__PURE__ */ ct(0), i = $t, s = (d) => {
    var a = $t;
    Hn(i);
    var c = d();
    return Hn(a), c;
  };
  return r && n.set("length", /* @__PURE__ */ ct(
    /** @type {any[]} */
    e.length
  )), new Proxy(
    /** @type {any} */
    e,
    {
      defineProperty(d, a, c) {
        (!("value" in c) || c.configurable === !1 || c.enumerable === !1 || c.writable === !1) && Pf();
        var g = n.get(a);
        return g === void 0 ? (g = s(() => /* @__PURE__ */ ct(c.value)), n.set(a, g)) : z(
          g,
          s(() => Xt(c.value))
        ), !0;
      },
      deleteProperty(d, a) {
        var c = n.get(a);
        if (c === void 0)
          a in d && (n.set(
            a,
            s(() => /* @__PURE__ */ ct(on))
          ), Ea(o));
        else {
          if (r && typeof a == "string") {
            var g = (
              /** @type {Source<number>} */
              n.get("length")
            ), h = Number(a);
            Number.isInteger(h) && h < g.v && z(g, h);
          }
          z(c, on), Ea(o);
        }
        return !0;
      },
      get(d, a, c) {
        var _;
        if (a === kr)
          return e;
        var g = n.get(a), h = a in d;
        if (g === void 0 && (!h || (_ = Ar(d, a)) != null && _.writable) && (g = s(() => /* @__PURE__ */ ct(Xt(h ? d[a] : on))), n.set(a, g)), g !== void 0) {
          var p = l(g);
          return p === on ? void 0 : p;
        }
        return Reflect.get(d, a, c);
      },
      getOwnPropertyDescriptor(d, a) {
        var c = Reflect.getOwnPropertyDescriptor(d, a);
        if (c && "value" in c) {
          var g = n.get(a);
          g && (c.value = l(g));
        } else if (c === void 0) {
          var h = n.get(a), p = h == null ? void 0 : h.v;
          if (h !== void 0 && p !== on)
            return {
              enumerable: !0,
              configurable: !0,
              value: p,
              writable: !0
            };
        }
        return c;
      },
      has(d, a) {
        var p;
        if (a === kr)
          return !0;
        var c = n.get(a), g = c !== void 0 && c.v !== on || Reflect.has(d, a);
        if (c !== void 0 || se !== null && (!g || (p = Ar(d, a)) != null && p.writable)) {
          c === void 0 && (c = s(() => /* @__PURE__ */ ct(g ? Xt(d[a]) : on)), n.set(a, c));
          var h = l(c);
          if (h === on)
            return !1;
        }
        return g;
      },
      set(d, a, c, g) {
        var R;
        var h = n.get(a), p = a in d;
        if (r && a === "length")
          for (var _ = c; _ < /** @type {Source<number>} */
          h.v; _ += 1) {
            var w = n.get(_ + "");
            w !== void 0 ? z(w, on) : _ in d && (w = s(() => /* @__PURE__ */ ct(on)), n.set(_ + "", w));
          }
        h === void 0 ? (!p || (R = Ar(d, a)) != null && R.writable) && (h = s(() => /* @__PURE__ */ ct(void 0)), z(
          h,
          s(() => Xt(c))
        ), n.set(a, h)) : (p = h.v !== on, z(
          h,
          s(() => Xt(c))
        ));
        var x = Reflect.getOwnPropertyDescriptor(d, a);
        if (x != null && x.set && x.set.call(g, c), !p) {
          if (r && typeof a == "string") {
            var k = (
              /** @type {Source<number>} */
              n.get("length")
            ), y = Number(a);
            Number.isInteger(y) && y >= k.v && z(k, y + 1);
          }
          Ea(o);
        }
        return !0;
      },
      ownKeys(d) {
        l(o);
        var a = Reflect.ownKeys(d).filter((h) => {
          var p = n.get(h);
          return p === void 0 || p.v !== on;
        });
        for (var [c, g] of n)
          g.v !== on && !(c in d) && a.push(c);
        return a;
      },
      setPrototypeOf() {
        If();
      }
    }
  );
}
function Ea(e, t = 1) {
  z(e, e.v + t);
}
function dc(e) {
  try {
    if (e !== null && typeof e == "object" && kr in e)
      return e[kr];
  } catch {
  }
  return e;
}
function Yf(e, t) {
  return Object.is(dc(e), dc(t));
}
// @__NO_SIDE_EFFECTS__
function es(e) {
  var t = In | Kn, n = $t !== null && $t.f & In ? (
    /** @type {Derived} */
    $t
  ) : null;
  return se === null || n !== null && n.f & bn ? t |= bn : se.f |= hu, {
    ctx: je,
    deps: null,
    effects: null,
    equals: vu,
    f: t,
    fn: e,
    reactions: null,
    rv: 0,
    v: (
      /** @type {V} */
      null
    ),
    wv: 0,
    parent: n ?? se
  };
}
// @__NO_SIDE_EFFECTS__
function L(e) {
  const t = /* @__PURE__ */ es(e);
  return Du(t), t;
}
// @__NO_SIDE_EFFECTS__
function cr(e) {
  const t = /* @__PURE__ */ es(e);
  return t.equals = xl, t;
}
function yu(e) {
  var t = e.effects;
  if (t !== null) {
    e.effects = null;
    for (var n = 0; n < t.length; n += 1)
      Sn(
        /** @type {Effect} */
        t[n]
      );
  }
}
function Xf(e) {
  for (var t = e.parent; t !== null; ) {
    if (!(t.f & In))
      return (
        /** @type {Effect} */
        t
      );
    t = t.parent;
  }
  return null;
}
function xu(e) {
  var t, n = se;
  Or(Xf(e));
  try {
    yu(e), t = Wu(e);
  } finally {
    Or(n);
  }
  return t;
}
function Su(e) {
  var t = xu(e);
  if (e.equals(t) || (e.v = t, e.wv = Vu()), !zo) {
    var n = (Cr || e.f & bn) && e.deps !== null ? Ir : cn;
    Nn(e, n);
  }
}
const ni = /* @__PURE__ */ new Map();
function Tn(e, t) {
  var n = {
    f: 0,
    // TODO ideally we could skip this altogether, but it causes type errors
    v: e,
    reactions: null,
    equals: vu,
    rv: 0,
    wv: 0
  };
  return n;
}
// @__NO_SIDE_EFFECTS__
function ct(e, t) {
  const n = Tn(e);
  return Du(n), n;
}
// @__NO_SIDE_EFFECTS__
function Cu(e, t = !1) {
  const n = Tn(e);
  return t || (n.equals = xl), n;
}
function z(e, t, n = !1) {
  $t !== null && !Pn && bu() && $t.f & (In | yl) && !(ln != null && ln.includes(e)) && Nf();
  let r = n ? Xt(t) : t;
  return Wa(e, r);
}
function Wa(e, t) {
  if (!e.equals(t)) {
    var n = e.v;
    zo ? ni.set(e, t) : ni.set(e, n), e.v = t, e.f & In && (e.f & Kn && xu(
      /** @type {Derived} */
      e
    ), Nn(e, e.f & bn ? Ir : cn)), e.wv = Vu(), Au(e, Kn), se !== null && se.f & cn && !(se.f & (fr | Qr)) && (kn === null ? ah([e]) : kn.push(e));
  }
  return t;
}
function fc(e, t = 1) {
  var n = l(e), r = t === 1 ? n++ : n--;
  return z(e, n), r;
}
function Au(e, t) {
  var n = e.reactions;
  if (n !== null)
    for (var r = n.length, o = 0; o < r; o++) {
      var i = n[o], s = i.f;
      s & Kn || (Nn(i, t), s & (cn | bn) && (s & In ? Au(
        /** @type {Derived} */
        i,
        Ir
      ) : _a(
        /** @type {Effect} */
        i
      )));
    }
}
function Zf() {
  console.warn("https://svelte.dev/e/select_multiple_invalid_value");
}
let Jf = !1;
var hc, ku, Eu, Ou;
function Qf() {
  if (hc === void 0) {
    hc = window, ku = /Firefox/.test(navigator.userAgent);
    var e = Element.prototype, t = Node.prototype, n = Text.prototype;
    Eu = Ar(t, "firstChild").get, Ou = Ar(t, "nextSibling").get, lc(e) && (e.__click = void 0, e.__className = void 0, e.__attributes = null, e.__style = void 0, e.__e = void 0), lc(n) && (n.__t = void 0);
  }
}
function pa(e = "") {
  return document.createTextNode(e);
}
// @__NO_SIDE_EFFECTS__
function jn(e) {
  return Eu.call(e);
}
// @__NO_SIDE_EFFECTS__
function va(e) {
  return Ou.call(e);
}
function C(e, t) {
  return /* @__PURE__ */ jn(e);
}
function rt(e, t) {
  {
    var n = (
      /** @type {DocumentFragment} */
      /* @__PURE__ */ jn(
        /** @type {Node} */
        e
      )
    );
    return n instanceof Comment && n.data === "" ? /* @__PURE__ */ va(n) : n;
  }
}
function F(e, t = 1, n = !1) {
  let r = e;
  for (; t--; )
    r = /** @type {TemplateNode} */
    /* @__PURE__ */ va(r);
  return r;
}
function $f(e) {
  e.textContent = "";
}
function Tu(e) {
  se === null && $t === null && Ef(), $t !== null && $t.f & bn && se === null && kf(), zo && Af();
}
function th(e, t) {
  var n = t.last;
  n === null ? t.last = t.first = e : (n.next = e, e.prev = n, t.last = e);
}
function $r(e, t, n, r = !0) {
  var o = se, i = {
    ctx: je,
    deps: null,
    nodes_start: null,
    nodes_end: null,
    f: e | Kn,
    first: null,
    fn: t,
    last: null,
    next: null,
    parent: o,
    prev: null,
    teardown: null,
    transitions: null,
    wv: 0
  };
  if (n)
    try {
      kl(i), i.f |= bf;
    } catch (a) {
      throw Sn(i), a;
    }
  else t !== null && _a(i);
  var s = n && i.deps === null && i.first === null && i.nodes_start === null && i.teardown === null && (i.f & (hu | As)) === 0;
  if (!s && r && (o !== null && th(i, o), $t !== null && $t.f & In)) {
    var d = (
      /** @type {Derived} */
      $t
    );
    (d.effects ?? (d.effects = [])).push(i);
  }
  return i;
}
function eh() {
  return $t !== null && !Pn;
}
function Pu(e) {
  const t = $r(da, null, !1);
  return Nn(t, cn), t.teardown = e, t;
}
function Ie(e) {
  Tu();
  var t = se !== null && (se.f & fr) !== 0 && je !== null && !je.m;
  if (t) {
    var n = (
      /** @type {ComponentContext} */
      je
    );
    (n.e ?? (n.e = [])).push({
      fn: e,
      effect: se,
      reaction: $t
    });
  } else {
    var r = Mo(e);
    return r;
  }
}
function _n(e) {
  return Tu(), ns(e);
}
function nh(e) {
  const t = $r(Qr, e, !0);
  return () => {
    Sn(t);
  };
}
function rh(e) {
  const t = $r(Qr, e, !0);
  return (n = {}) => new Promise((r) => {
    n.outro ? Io(t, () => {
      Sn(t), r(void 0);
    }) : (Sn(t), r(void 0));
  });
}
function Mo(e) {
  return $r(fu, e, !1);
}
function ns(e) {
  return $r(da, e, !0);
}
function q(e, t = [], n = es) {
  const r = t.map(n);
  return Nr(() => e(...r.map(l)));
}
function Nr(e, t = 0) {
  return $r(da | yl | t, e, !0);
}
function Gn(e, t = !0) {
  return $r(da | fr, e, !0, t);
}
function Iu(e) {
  var t = e.teardown;
  if (t !== null) {
    const n = zo, r = $t;
    pc(!0), Hn(null);
    try {
      t.call(null);
    } finally {
      pc(n), Hn(r);
    }
  }
}
function Nu(e, t = !1) {
  var n = e.first;
  for (e.first = e.last = null; n !== null; ) {
    var r = n.next;
    n.f & Qr ? n.parent = null : Sn(n, t), n = r;
  }
}
function oh(e) {
  for (var t = e.first; t !== null; ) {
    var n = t.next;
    t.f & fr || Sn(t), t = n;
  }
}
function Sn(e, t = !0) {
  var n = !1;
  (t || e.f & yf) && e.nodes_start !== null && (Ru(
    e.nodes_start,
    /** @type {TemplateNode} */
    e.nodes_end
  ), n = !0), Nu(e, t && !n), Is(e, 0), Nn(e, fa);
  var r = e.transitions;
  if (r !== null)
    for (const i of r)
      i.stop();
  Iu(e);
  var o = e.parent;
  o !== null && o.first !== null && Fu(e), e.next = e.prev = e.teardown = e.ctx = e.deps = e.fn = e.nodes_start = e.nodes_end = null;
}
function Ru(e, t) {
  for (; e !== null; ) {
    var n = e === t ? null : (
      /** @type {TemplateNode} */
      /* @__PURE__ */ va(e)
    );
    e.remove(), e = n;
  }
}
function Fu(e) {
  var t = e.parent, n = e.prev, r = e.next;
  n !== null && (n.next = r), r !== null && (r.prev = n), t !== null && (t.first === e && (t.first = r), t.last === e && (t.last = n));
}
function Io(e, t) {
  var n = [];
  Al(e, n, !0), Lu(n, () => {
    Sn(e), t && t();
  });
}
function Lu(e, t) {
  var n = e.length;
  if (n > 0) {
    var r = () => --n || t();
    for (var o of e)
      o.out(r);
  } else
    t();
}
function Al(e, t, n) {
  if (!(e.f & ar)) {
    if (e.f ^= ar, e.transitions !== null)
      for (const s of e.transitions)
        (s.is_global || n) && t.push(s);
    for (var r = e.first; r !== null; ) {
      var o = r.next, i = (r.f & ts) !== 0 || (r.f & fr) !== 0;
      Al(r, t, i ? n : !1), r = o;
    }
  }
}
function Es(e) {
  Mu(e, !0);
}
function Mu(e, t) {
  if (e.f & ar) {
    e.f ^= ar, e.f & cn || (e.f ^= cn), rs(e) && (Nn(e, Kn), _a(e));
    for (var n = e.first; n !== null; ) {
      var r = n.next, o = (n.f & ts) !== 0 || (n.f & fr) !== 0;
      Mu(n, o ? t : !1), n = r;
    }
    if (e.transitions !== null)
      for (const i of e.transitions)
        (i.is_global || t) && i.in();
  }
}
let ri = [], Ua = [];
function zu() {
  var e = ri;
  ri = [], du(e);
}
function ih() {
  var e = Ua;
  Ua = [], du(e);
}
function ga(e) {
  ri.length === 0 && queueMicrotask(zu), ri.push(e);
}
function sh() {
  ri.length > 0 && zu(), Ua.length > 0 && ih();
}
let bs = !1, Os = !1, Ts = null, Zr = !1, zo = !1;
function pc(e) {
  zo = e;
}
let Zo = [];
let $t = null, Pn = !1;
function Hn(e) {
  $t = e;
}
let se = null;
function Or(e) {
  se = e;
}
let ln = null;
function Du(e) {
  $t !== null && $t.f & ja && (ln === null ? ln = [e] : ln.push(e));
}
let an = null, mn = 0, kn = null;
function ah(e) {
  kn = e;
}
let Bu = 1, Ps = 0, Cr = !1;
function Vu() {
  return ++Bu;
}
function rs(e) {
  var h;
  var t = e.f;
  if (t & Kn)
    return !0;
  if (t & Ir) {
    var n = e.deps, r = (t & bn) !== 0;
    if (n !== null) {
      var o, i, s = (t & ks) !== 0, d = r && se !== null && !Cr, a = n.length;
      if (s || d) {
        var c = (
          /** @type {Derived} */
          e
        ), g = c.parent;
        for (o = 0; o < a; o++)
          i = n[o], (s || !((h = i == null ? void 0 : i.reactions) != null && h.includes(c))) && (i.reactions ?? (i.reactions = [])).push(c);
        s && (c.f ^= ks), d && g !== null && !(g.f & bn) && (c.f ^= bn);
      }
      for (o = 0; o < a; o++)
        if (i = n[o], rs(
          /** @type {Derived} */
          i
        ) && Su(
          /** @type {Derived} */
          i
        ), i.wv > e.wv)
          return !0;
    }
    (!r || se !== null && !Cr) && Nn(e, cn);
  }
  return !1;
}
function lh(e, t) {
  for (var n = t; n !== null; ) {
    if (n.f & As)
      try {
        n.fn(e);
        return;
      } catch {
        n.f ^= As;
      }
    n = n.parent;
  }
  throw bs = !1, e;
}
function vc(e) {
  return (e.f & fa) === 0 && (e.parent === null || (e.parent.f & As) === 0);
}
function ma(e, t, n, r) {
  if (bs) {
    if (n === null && (bs = !1), vc(t))
      throw e;
    return;
  }
  if (n !== null && (bs = !0), lh(e, t), vc(t))
    throw e;
}
function ju(e, t, n = !0) {
  var r = e.reactions;
  if (r !== null)
    for (var o = 0; o < r.length; o++) {
      var i = r[o];
      ln != null && ln.includes(e) || (i.f & In ? ju(
        /** @type {Derived} */
        i,
        t,
        !1
      ) : t === i && (n ? Nn(i, Kn) : i.f & cn && Nn(i, Ir), _a(
        /** @type {Effect} */
        i
      )));
    }
}
function Wu(e) {
  var _;
  var t = an, n = mn, r = kn, o = $t, i = Cr, s = ln, d = je, a = Pn, c = e.f;
  an = /** @type {null | Value[]} */
  null, mn = 0, kn = null, Cr = (c & bn) !== 0 && (Pn || !Zr || $t === null), $t = c & (fr | Qr) ? null : e, ln = null, cc(e.ctx), Pn = !1, Ps++, e.f |= ja;
  try {
    var g = (
      /** @type {Function} */
      (0, e.fn)()
    ), h = e.deps;
    if (an !== null) {
      var p;
      if (Is(e, mn), h !== null && mn > 0)
        for (h.length = mn + an.length, p = 0; p < an.length; p++)
          h[mn + p] = an[p];
      else
        e.deps = h = an;
      if (!Cr)
        for (p = mn; p < h.length; p++)
          ((_ = h[p]).reactions ?? (_.reactions = [])).push(e);
    } else h !== null && mn < h.length && (Is(e, mn), h.length = mn);
    if (bu() && kn !== null && !Pn && h !== null && !(e.f & (In | Ir | Kn)))
      for (p = 0; p < /** @type {Source[]} */
      kn.length; p++)
        ju(
          kn[p],
          /** @type {Effect} */
          e
        );
    return o !== null && o !== e && (Ps++, kn !== null && (r === null ? r = kn : r.push(.../** @type {Source[]} */
    kn))), g;
  } finally {
    an = t, mn = n, kn = r, $t = o, Cr = i, ln = s, cc(d), Pn = a, e.f ^= ja;
  }
}
function ch(e, t) {
  let n = t.reactions;
  if (n !== null) {
    var r = gf.call(n, e);
    if (r !== -1) {
      var o = n.length - 1;
      o === 0 ? n = t.reactions = null : (n[r] = n[o], n.pop());
    }
  }
  n === null && t.f & In && // Destroying a child effect while updating a parent effect can cause a dependency to appear
  // to be unused, when in fact it is used by the currently-updating parent. Checking `new_deps`
  // allows us to skip the expensive work of disconnecting and immediately reconnecting it
  (an === null || !an.includes(t)) && (Nn(t, Ir), t.f & (bn | ks) || (t.f ^= ks), yu(
    /** @type {Derived} **/
    t
  ), Is(
    /** @type {Derived} **/
    t,
    0
  ));
}
function Is(e, t) {
  var n = e.deps;
  if (n !== null)
    for (var r = t; r < n.length; r++)
      ch(e, n[r]);
}
function kl(e) {
  var t = e.f;
  if (!(t & fa)) {
    Nn(e, cn);
    var n = se, r = je, o = Zr;
    se = e, Zr = !0;
    try {
      t & yl ? oh(e) : Nu(e), Iu(e);
      var i = Wu(e);
      e.teardown = typeof i == "function" ? i : null, e.wv = Bu;
      var s = e.deps, d;
    } catch (a) {
      ma(a, e, n, r || e.ctx);
    } finally {
      Zr = o, se = n;
    }
  }
}
function uh() {
  try {
    Of();
  } catch (e) {
    if (Ts !== null)
      ma(e, Ts, null);
    else
      throw e;
  }
}
function Uu() {
  var e = Zr;
  try {
    var t = 0;
    for (Zr = !0; Zo.length > 0; ) {
      t++ > 1e3 && uh();
      var n = Zo, r = n.length;
      Zo = [];
      for (var o = 0; o < r; o++) {
        var i = fh(n[o]);
        dh(i);
      }
      ni.clear();
    }
  } finally {
    Os = !1, Zr = e, Ts = null;
  }
}
function dh(e) {
  var t = e.length;
  if (t !== 0)
    for (var n = 0; n < t; n++) {
      var r = e[n];
      if (!(r.f & (fa | ar)))
        try {
          rs(r) && (kl(r), r.deps === null && r.first === null && r.nodes_start === null && (r.teardown === null ? Fu(r) : r.fn = null));
        } catch (o) {
          ma(o, r, null, r.ctx);
        }
    }
}
function _a(e) {
  Os || (Os = !0, queueMicrotask(Uu));
  for (var t = Ts = e; t.parent !== null; ) {
    t = t.parent;
    var n = t.f;
    if (n & (Qr | fr)) {
      if (!(n & cn)) return;
      t.f ^= cn;
    }
  }
  Zo.push(t);
}
function fh(e) {
  for (var t = [], n = e; n !== null; ) {
    var r = n.f, o = (r & (fr | Qr)) !== 0, i = o && (r & cn) !== 0;
    if (!i && !(r & ar)) {
      if (r & fu)
        t.push(n);
      else if (o)
        n.f ^= cn;
      else
        try {
          rs(n) && kl(n);
        } catch (a) {
          ma(a, n, null, n.ctx);
        }
      var s = n.first;
      if (s !== null) {
        n = s;
        continue;
      }
    }
    var d = n.parent;
    for (n = n.next; n === null && d !== null; )
      n = d.next, d = d.parent;
  }
  return t;
}
function hh(e) {
  for (var t; ; ) {
    if (sh(), Zo.length === 0)
      return (
        /** @type {T} */
        t
      );
    Os = !0, Uu();
  }
}
async function lo() {
  await Promise.resolve(), hh();
}
function l(e) {
  var t = e.f, n = (t & In) !== 0;
  if ($t !== null && !Pn) {
    if (!(ln != null && ln.includes(e))) {
      var r = $t.deps;
      e.rv < Ps && (e.rv = Ps, an === null && r !== null && r[mn] === e ? mn++ : an === null ? an = [e] : (!Cr || !an.includes(e)) && an.push(e));
    }
  } else if (n && /** @type {Derived} */
  e.deps === null && /** @type {Derived} */
  e.effects === null) {
    var o = (
      /** @type {Derived} */
      e
    ), i = o.parent;
    i !== null && !(i.f & bn) && (o.f ^= bn);
  }
  return n && (o = /** @type {Derived} */
  e, rs(o) && Su(o)), zo && ni.has(e) ? ni.get(e) : e.v;
}
function oe(e) {
  var t = Pn;
  try {
    return Pn = !0, e();
  } finally {
    Pn = t;
  }
}
const ph = ~(Kn | Ir | cn);
function Nn(e, t) {
  e.f = e.f & ph | t;
}
function vh() {
  return Symbol(_u);
}
function gh(e) {
  return e.endsWith("capture") && e !== "gotpointercapture" && e !== "lostpointercapture";
}
const mh = [
  "beforeinput",
  "click",
  "change",
  "dblclick",
  "contextmenu",
  "focusin",
  "focusout",
  "input",
  "keydown",
  "keyup",
  "mousedown",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "pointerdown",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "touchend",
  "touchmove",
  "touchstart"
];
function _h(e) {
  return mh.includes(e);
}
const wh = {
  // no `class: 'className'` because we handle that separately
  formnovalidate: "formNoValidate",
  ismap: "isMap",
  nomodule: "noModule",
  playsinline: "playsInline",
  readonly: "readOnly",
  defaultvalue: "defaultValue",
  defaultchecked: "defaultChecked",
  srcobject: "srcObject",
  novalidate: "noValidate",
  allowfullscreen: "allowFullscreen",
  disablepictureinpicture: "disablePictureInPicture",
  disableremoteplayback: "disableRemotePlayback"
};
function bh(e) {
  return e = e.toLowerCase(), wh[e] ?? e;
}
const yh = ["touchstart", "touchmove"];
function xh(e) {
  return yh.includes(e);
}
function qu(e, t) {
  if (t) {
    const n = document.body;
    e.autofocus = !0, ga(() => {
      document.activeElement === n && e.focus();
    });
  }
}
let gc = !1;
function Sh() {
  gc || (gc = !0, document.addEventListener(
    "reset",
    (e) => {
      Promise.resolve().then(() => {
        var t;
        if (!e.defaultPrevented)
          for (
            const n of
            /**@type {HTMLFormElement} */
            e.target.elements
          )
            (t = n.__on_r) == null || t.call(n);
      });
    },
    // In the capture phase to guarantee we get noticed of it (no possiblity of stopPropagation)
    { capture: !0 }
  ));
}
function Ku(e) {
  var t = $t, n = se;
  Hn(null), Or(null);
  try {
    return e();
  } finally {
    Hn(t), Or(n);
  }
}
function El(e, t, n, r = n) {
  e.addEventListener(t, () => Ku(n));
  const o = e.__on_r;
  o ? e.__on_r = () => {
    o(), r(!0);
  } : e.__on_r = () => r(!0), Sh();
}
const Gu = /* @__PURE__ */ new Set(), qa = /* @__PURE__ */ new Set();
function Ol(e, t, n, r = {}) {
  function o(i) {
    if (r.capture || Yo.call(t, i), !i.cancelBubble)
      return Ku(() => n == null ? void 0 : n.call(this, i));
  }
  return e.startsWith("pointer") || e.startsWith("touch") || e === "wheel" ? ga(() => {
    t.addEventListener(e, o, r);
  }) : t.addEventListener(e, o, r), o;
}
function yn(e, t, n, r = {}) {
  var o = Ol(t, e, n, r);
  return () => {
    e.removeEventListener(t, o, r);
  };
}
function Jo(e, t, n, r, o) {
  var i = { capture: r, passive: o }, s = Ol(e, t, n, i);
  (t === document.body || // @ts-ignore
  t === window || // @ts-ignore
  t === document || // Firefox has quirky behavior, it can happen that we still get "canplay" events when the element is already removed
  t instanceof HTMLMediaElement) && Pu(() => {
    t.removeEventListener(e, s, i);
  });
}
function Xn(e) {
  for (var t = 0; t < e.length; t++)
    Gu.add(e[t]);
  for (var n of qa)
    n(e);
}
function Yo(e) {
  var R;
  var t = this, n = (
    /** @type {Node} */
    t.ownerDocument
  ), r = e.type, o = ((R = e.composedPath) == null ? void 0 : R.call(e)) || [], i = (
    /** @type {null | Element} */
    o[0] || e.target
  ), s = 0, d = e.__root;
  if (d) {
    var a = o.indexOf(d);
    if (a !== -1 && (t === document || t === /** @type {any} */
    window)) {
      e.__root = t;
      return;
    }
    var c = o.indexOf(t);
    if (c === -1)
      return;
    a <= c && (s = a);
  }
  if (i = /** @type {Element} */
  o[s] || e.target, i !== t) {
    mf(e, "currentTarget", {
      configurable: !0,
      get() {
        return i || n;
      }
    });
    var g = $t, h = se;
    Hn(null), Or(null);
    try {
      for (var p, _ = []; i !== null; ) {
        var w = i.assignedSlot || i.parentNode || /** @type {any} */
        i.host || null;
        try {
          var x = i["__" + r];
          if (x != null && (!/** @type {any} */
          i.disabled || // DOM could've been updated already by the time this is reached, so we check this as well
          // -> the target could not have been disabled because it emits the event in the first place
          e.target === i))
            if ($i(x)) {
              var [k, ...y] = x;
              k.apply(i, [e, ...y]);
            } else
              x.call(i, e);
        } catch (A) {
          p ? _.push(A) : p = A;
        }
        if (e.cancelBubble || w === t || w === null)
          break;
        i = w;
      }
      if (p) {
        for (let A of _)
          queueMicrotask(() => {
            throw A;
          });
        throw p;
      }
    } finally {
      e.__root = t, delete e.currentTarget, Hn(g), Or(h);
    }
  }
}
function Tl(e) {
  var t = document.createElement("template");
  return t.innerHTML = e.replaceAll("<!>", "<!---->"), t.content;
}
function No(e, t) {
  var n = (
    /** @type {Effect} */
    se
  );
  n.nodes_start === null && (n.nodes_start = e, n.nodes_end = t);
}
// @__NO_SIDE_EFFECTS__
function j(e, t) {
  var n = (t & Bf) !== 0, r = (t & Vf) !== 0, o, i = !e.startsWith("<!>");
  return () => {
    o === void 0 && (o = Tl(i ? e : "<!>" + e), n || (o = /** @type {Node} */
    /* @__PURE__ */ jn(o)));
    var s = (
      /** @type {TemplateNode} */
      r || ku ? document.importNode(o, !0) : o.cloneNode(!0)
    );
    if (n) {
      var d = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ jn(s)
      ), a = (
        /** @type {TemplateNode} */
        s.lastChild
      );
      No(d, a);
    } else
      No(s, s);
    return s;
  };
}
// @__NO_SIDE_EFFECTS__
function Ch(e, t, n = "svg") {
  var r = !e.startsWith("<!>"), o = `<${n}>${r ? e : "<!>" + e}</${n}>`, i;
  return () => {
    if (!i) {
      var s = (
        /** @type {DocumentFragment} */
        Tl(o)
      ), d = (
        /** @type {Element} */
        /* @__PURE__ */ jn(s)
      );
      i = /** @type {Element} */
      /* @__PURE__ */ jn(d);
    }
    var a = (
      /** @type {TemplateNode} */
      i.cloneNode(!0)
    );
    return No(a, a), a;
  };
}
// @__NO_SIDE_EFFECTS__
function to(e, t) {
  return /* @__PURE__ */ Ch(e, t, "svg");
}
function Oa(e = "") {
  {
    var t = pa(e + "");
    return No(t, t), t;
  }
}
function _t() {
  var e = document.createDocumentFragment(), t = document.createComment(""), n = pa();
  return e.append(t, n), No(t, n), e;
}
function O(e, t) {
  e !== null && e.before(
    /** @type {Node} */
    t
  );
}
function Hu() {
  var e;
  return (e = window.__svelte ?? (window.__svelte = {})).uid ?? (e.uid = 1), `c${window.__svelte.uid++}`;
}
function et(e, t) {
  var n = t == null ? "" : typeof t == "object" ? t + "" : t;
  n !== (e.__t ?? (e.__t = e.nodeValue)) && (e.__t = n, e.nodeValue = n + "");
}
function Yu(e, t) {
  return Ah(e, t);
}
const no = /* @__PURE__ */ new Map();
function Ah(e, { target: t, anchor: n, props: r = {}, events: o, context: i, intro: s = !0 }) {
  Qf();
  var d = /* @__PURE__ */ new Set(), a = (h) => {
    for (var p = 0; p < h.length; p++) {
      var _ = h[p];
      if (!d.has(_)) {
        d.add(_);
        var w = xh(_);
        t.addEventListener(_, Yo, { passive: w });
        var x = no.get(_);
        x === void 0 ? (document.addEventListener(_, Yo, { passive: w }), no.set(_, 1)) : no.set(_, x + 1);
      }
    }
  };
  a(wl(Gu)), qa.add(a);
  var c = void 0, g = rh(() => {
    var h = n ?? t.appendChild(pa());
    return Gn(() => {
      if (i) {
        Kt({});
        var p = (
          /** @type {ComponentContext} */
          je
        );
        p.c = i;
      }
      o && (r.$$events = o), c = e(h, r) || {}, i && Gt();
    }), () => {
      var w;
      for (var p of d) {
        t.removeEventListener(p, Yo);
        var _ = (
          /** @type {number} */
          no.get(p)
        );
        --_ === 0 ? (document.removeEventListener(p, Yo), no.delete(p)) : no.set(p, _);
      }
      qa.delete(a), h !== n && ((w = h.parentNode) == null || w.removeChild(h));
    };
  });
  return Ka.set(c, g), c;
}
let Ka = /* @__PURE__ */ new WeakMap();
function kh(e, t) {
  const n = Ka.get(e);
  return n ? (Ka.delete(e), n(t)) : Promise.resolve();
}
function U(e, t, [n, r] = [0, 0]) {
  var o = e, i = null, s = null, d = on, a = n > 0 ? ts : 0, c = !1;
  const g = (p, _ = !0) => {
    c = !0, h(_, p);
  }, h = (p, _) => {
    d !== (d = p) && (d ? (i ? Es(i) : _ && (i = Gn(() => _(o))), s && Io(s, () => {
      s = null;
    })) : (s ? Es(s) : _ && (s = Gn(() => _(o, [n + 1, r]))), i && Io(i, () => {
      i = null;
    })));
  };
  Nr(() => {
    c = !1, t(g), c || h(null, null);
  }, a);
}
function Eh(e, t, n) {
  var r = e, o = on, i, s = Cf;
  Nr(() => {
    s(o, o = t()) && (i && Io(i), i = Gn(() => n(r)));
  });
}
function sn(e, t) {
  return t;
}
function Oh(e, t, n, r) {
  for (var o = [], i = t.length, s = 0; s < i; s++)
    Al(t[s].e, o, !0);
  var d = i > 0 && o.length === 0 && n !== null;
  if (d) {
    var a = (
      /** @type {Element} */
      /** @type {Element} */
      n.parentNode
    );
    $f(a), a.append(
      /** @type {Element} */
      n
    ), r.clear(), vr(e, t[0].prev, t[i - 1].next);
  }
  Lu(o, () => {
    for (var c = 0; c < i; c++) {
      var g = t[c];
      d || (r.delete(g.k), vr(e, g.prev, g.next)), Sn(g.e, !d);
    }
  });
}
function we(e, t, n, r, o, i = null) {
  var s = e, d = { flags: t, items: /* @__PURE__ */ new Map(), first: null }, a = (t & mu) !== 0;
  if (a) {
    var c = (
      /** @type {Element} */
      e
    );
    s = c.appendChild(pa());
  }
  var g = null, h = !1, p = /* @__PURE__ */ cr(() => {
    var _ = n();
    return $i(_) ? _ : _ == null ? [] : wl(_);
  });
  Nr(() => {
    var _ = l(p), w = _.length;
    h && w === 0 || (h = w === 0, Th(_, d, s, o, t, r, n), i !== null && (w === 0 ? g ? Es(g) : g = Gn(() => i(s)) : g !== null && Io(g, () => {
      g = null;
    })), l(p));
  });
}
function Th(e, t, n, r, o, i, s) {
  var K, Y, Z, ot;
  var d = (o & Rf) !== 0, a = (o & (Sl | Cl)) !== 0, c = e.length, g = t.items, h = t.first, p = h, _, w = null, x, k = [], y = [], R, A, S, u;
  if (d)
    for (u = 0; u < c; u += 1)
      R = e[u], A = i(R, u), S = g.get(A), S !== void 0 && ((K = S.a) == null || K.measure(), (x ?? (x = /* @__PURE__ */ new Set())).add(S));
  for (u = 0; u < c; u += 1) {
    if (R = e[u], A = i(R, u), S = g.get(A), S === void 0) {
      var T = p ? (
        /** @type {TemplateNode} */
        p.e.nodes_start
      ) : n;
      w = Ih(
        T,
        t,
        w,
        w === null ? t.first : w.next,
        R,
        A,
        u,
        r,
        o,
        s
      ), g.set(A, w), k = [], y = [], p = w.next;
      continue;
    }
    if (a && Ph(S, R, u, o), S.e.f & ar && (Es(S.e), d && ((Y = S.a) == null || Y.unfix(), (x ?? (x = /* @__PURE__ */ new Set())).delete(S))), S !== p) {
      if (_ !== void 0 && _.has(S)) {
        if (k.length < y.length) {
          var I = y[0], b;
          w = I.prev;
          var wt = k[0], Pt = k[k.length - 1];
          for (b = 0; b < k.length; b += 1)
            mc(k[b], I, n);
          for (b = 0; b < y.length; b += 1)
            _.delete(y[b]);
          vr(t, wt.prev, Pt.next), vr(t, w, wt), vr(t, Pt, I), p = I, w = Pt, u -= 1, k = [], y = [];
        } else
          _.delete(S), mc(S, p, n), vr(t, S.prev, S.next), vr(t, S, w === null ? t.first : w.next), vr(t, w, S), w = S;
        continue;
      }
      for (k = [], y = []; p !== null && p.k !== A; )
        p.e.f & ar || (_ ?? (_ = /* @__PURE__ */ new Set())).add(p), y.push(p), p = p.next;
      if (p === null)
        continue;
      S = p;
    }
    k.push(S), w = S, p = S.next;
  }
  if (p !== null || _ !== void 0) {
    for (var ut = _ === void 0 ? [] : wl(_); p !== null; )
      p.e.f & ar || ut.push(p), p = p.next;
    var E = ut.length;
    if (E > 0) {
      var V = o & mu && c === 0 ? n : null;
      if (d) {
        for (u = 0; u < E; u += 1)
          (Z = ut[u].a) == null || Z.measure();
        for (u = 0; u < E; u += 1)
          (ot = ut[u].a) == null || ot.fix();
      }
      Oh(t, ut, V, g);
    }
  }
  d && ga(() => {
    var P;
    if (x !== void 0)
      for (S of x)
        (P = S.a) == null || P.apply();
  }), se.first = t.first && t.first.e, se.last = w && w.e;
}
function Ph(e, t, n, r) {
  r & Sl && Wa(e.v, t), r & Cl ? Wa(
    /** @type {Value<number>} */
    e.i,
    n
  ) : e.i = n;
}
function Ih(e, t, n, r, o, i, s, d, a, c) {
  var g = (a & Sl) !== 0, h = (a & Ff) === 0, p = g ? h ? /* @__PURE__ */ Cu(o) : Tn(o) : o, _ = a & Cl ? Tn(s) : s, w = {
    i: _,
    v: p,
    k: i,
    a: null,
    // @ts-expect-error
    e: null,
    prev: n,
    next: r
  };
  try {
    return w.e = Gn(() => d(e, p, _, c), Jf), w.e.prev = n && n.e, w.e.next = r && r.e, n === null ? t.first = w : (n.next = w, n.e.next = w.e), r !== null && (r.prev = w, r.e.prev = w.e), w;
  } finally {
  }
}
function mc(e, t, n) {
  for (var r = e.next ? (
    /** @type {TemplateNode} */
    e.next.e.nodes_start
  ) : n, o = t ? (
    /** @type {TemplateNode} */
    t.e.nodes_start
  ) : n, i = (
    /** @type {TemplateNode} */
    e.e.nodes_start
  ); i !== r; ) {
    var s = (
      /** @type {TemplateNode} */
      /* @__PURE__ */ va(i)
    );
    o.before(i), i = s;
  }
}
function vr(e, t, n) {
  t === null ? e.first = n : (t.next = n, t.e.next = n && n.e), n !== null && (n.prev = t, n.e.prev = t && t.e);
}
function Nh(e, t, n = !1, r = !1, o = !1) {
  var i = e, s = "";
  q(() => {
    var d = (
      /** @type {Effect} */
      se
    );
    if (s !== (s = t() ?? "") && (d.nodes_start !== null && (Ru(
      d.nodes_start,
      /** @type {TemplateNode} */
      d.nodes_end
    ), d.nodes_start = d.nodes_end = null), s !== "")) {
      var a = s + "";
      n ? a = `<svg>${a}</svg>` : r && (a = `<math>${a}</math>`);
      var c = Tl(a);
      if ((n || r) && (c = /** @type {Element} */
      /* @__PURE__ */ jn(c)), No(
        /** @type {TemplateNode} */
        /* @__PURE__ */ jn(c),
        /** @type {TemplateNode} */
        c.lastChild
      ), n || r)
        for (; /* @__PURE__ */ jn(c); )
          i.before(
            /** @type {Node} */
            /* @__PURE__ */ jn(c)
          );
      else
        i.before(c);
    }
  });
}
function ie(e, t, ...n) {
  var r = e, o = Re, i;
  Nr(() => {
    o !== (o = t()) && (i && (Sn(i), i = null), i = Gn(() => (
      /** @type {SnippetFn} */
      o(r, ...n)
    )));
  }, ts);
}
function Ur(e, t, n) {
  var r = e, o, i;
  Nr(() => {
    o !== (o = t()) && (i && (Io(i), i = null), o && (i = Gn(() => n(r, o))));
  }, ts);
}
function Xu(e, t) {
  var n = void 0, r;
  Nr(() => {
    n !== (n = t()) && (r && (Sn(r), r = null), n && (r = Gn(() => {
      Mo(() => (
        /** @type {(node: Element) => void} */
        n(e)
      ));
    })));
  });
}
function Zu(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = Zu(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Qo() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = Zu(e)) && (r && (r += " "), r += t);
  return r;
}
function os(e) {
  return typeof e == "object" ? Qo(e) : e ?? "";
}
const _c = [...` 	
\r\f \v\uFEFF`];
function Rh(e, t, n) {
  var r = e == null ? "" : "" + e;
  if (t && (r = r ? r + " " + t : t), n) {
    for (var o in n)
      if (n[o])
        r = r ? r + " " + o : o;
      else if (r.length)
        for (var i = o.length, s = 0; (s = r.indexOf(o, s)) >= 0; ) {
          var d = s + i;
          (s === 0 || _c.includes(r[s - 1])) && (d === r.length || _c.includes(r[d])) ? r = (s === 0 ? "" : r.substring(0, s)) + r.substring(d + 1) : s = d;
        }
  }
  return r === "" ? null : r;
}
function wc(e, t = !1) {
  var n = t ? " !important;" : ";", r = "";
  for (var o in e) {
    var i = e[o];
    i != null && i !== "" && (r += " " + o + ": " + i + n);
  }
  return r;
}
function Ta(e) {
  return e[0] !== "-" || e[1] !== "-" ? e.toLowerCase() : e;
}
function Fh(e, t) {
  if (t) {
    var n = "", r, o;
    if (Array.isArray(t) ? (r = t[0], o = t[1]) : r = t, e) {
      e = String(e).replaceAll(/\s*\/\*.*?\*\/\s*/g, "").trim();
      var i = !1, s = 0, d = !1, a = [];
      r && a.push(...Object.keys(r).map(Ta)), o && a.push(...Object.keys(o).map(Ta));
      var c = 0, g = -1;
      const x = e.length;
      for (var h = 0; h < x; h++) {
        var p = e[h];
        if (d ? p === "/" && e[h - 1] === "*" && (d = !1) : i ? i === p && (i = !1) : p === "/" && e[h + 1] === "*" ? d = !0 : p === '"' || p === "'" ? i = p : p === "(" ? s++ : p === ")" && s--, !d && i === !1 && s === 0) {
          if (p === ":" && g === -1)
            g = h;
          else if (p === ";" || h === x - 1) {
            if (g !== -1) {
              var _ = Ta(e.substring(c, g).trim());
              if (!a.includes(_)) {
                p !== ";" && h++;
                var w = e.substring(c, h).trim();
                n += " " + w + ";";
              }
            }
            c = h + 1, g = -1;
          }
        }
      }
    }
    return r && (n += wc(r)), o && (n += wc(o, !0)), n = n.trim(), n === "" ? null : n;
  }
  return e == null ? null : String(e);
}
function qt(e, t, n, r, o, i) {
  var s = e.__className;
  if (s !== n || s === void 0) {
    var d = Rh(n, r, i);
    d == null ? e.removeAttribute("class") : t ? e.className = d : e.setAttribute("class", d), e.__className = n;
  } else if (i && o !== i)
    for (var a in i) {
      var c = !!i[a];
      (o == null || c !== !!o[a]) && e.classList.toggle(a, c);
    }
  return i;
}
function Pa(e, t = {}, n, r) {
  for (var o in n) {
    var i = n[o];
    t[o] !== i && (n[o] == null ? e.style.removeProperty(o) : e.style.setProperty(o, i, r));
  }
}
function Br(e, t, n, r) {
  var o = e.__style;
  if (o !== t) {
    var i = Fh(t, r);
    i == null ? e.removeAttribute("style") : e.style.cssText = i, e.__style = t;
  } else r && (Array.isArray(r) ? (Pa(e, n == null ? void 0 : n[0], r[0]), Pa(e, n == null ? void 0 : n[1], r[1], "important")) : Pa(e, n, r));
  return r;
}
function oi(e, t, n) {
  if (e.multiple) {
    if (t == null)
      return;
    if (!$i(t))
      return Zf();
    for (var r of e.options)
      r.selected = t.includes($o(r));
    return;
  }
  for (r of e.options) {
    var o = $o(r);
    if (Yf(o, t)) {
      r.selected = !0;
      return;
    }
  }
  (!n || t !== void 0) && (e.selectedIndex = -1);
}
function Pl(e, t) {
  let n = !0;
  Mo(() => {
    t && oi(e, oe(t), n), n = !1;
    var r = new MutationObserver(() => {
      var o = e.__value;
      oi(e, o);
    });
    return r.observe(e, {
      // Listen to option element changes
      childList: !0,
      subtree: !0,
      // because of <optgroup>
      // Listen to option element value attribute changes
      // (doesn't get notified of select value changes,
      // because that property is not reflected as an attribute)
      attributes: !0,
      attributeFilter: ["value"]
    }), () => {
      r.disconnect();
    };
  });
}
function Lh(e, t, n = t) {
  var r = !0;
  El(e, "change", (o) => {
    var i = o ? "[selected]" : ":checked", s;
    if (e.multiple)
      s = [].map.call(e.querySelectorAll(i), $o);
    else {
      var d = e.querySelector(i) ?? // will fall back to first non-disabled option if no option is selected
      e.querySelector("option:not([disabled])");
      s = d && $o(d);
    }
    n(s);
  }), Mo(() => {
    var o = t();
    if (oi(e, o, r), r && o === void 0) {
      var i = e.querySelector(":checked");
      i !== null && (o = $o(i), n(o));
    }
    e.__value = o, r = !1;
  }), Pl(e);
}
function $o(e) {
  return "__value" in e ? e.__value : e.value;
}
const Uo = Symbol("class"), qo = Symbol("style"), Ju = Symbol("is custom element"), Qu = Symbol("is html");
function ge(e, t) {
  var n = wa(e);
  n.value === (n.value = // treat null and undefined the same for the initial value
  t ?? void 0) || // @ts-expect-error
  // `progress` elements always need their value set when it's `0`
  e.value === t && (t !== 0 || e.nodeName !== "PROGRESS") || (e.value = t ?? "");
}
function Mh(e, t) {
  var n = wa(e);
  n.checked !== (n.checked = // treat null and undefined the same for the initial value
  t ?? void 0) && (e.checked = t);
}
function er(e, t) {
  t ? e.hasAttribute("selected") || e.setAttribute("selected", "") : e.removeAttribute("selected");
}
function B(e, t, n, r) {
  var o = wa(e);
  o[t] !== (o[t] = n) && (t === "loading" && (e[xf] = n), n == null ? e.removeAttribute(t) : typeof n != "string" && $u(e).includes(t) ? e[t] = n : e.setAttribute(t, n));
}
function zh(e, t, n, r, o = !1) {
  var i = wa(e), s = i[Ju], d = !i[Qu], a = t || {}, c = e.tagName === "OPTION";
  for (var g in t)
    g in n || (n[g] = null);
  n.class ? n.class = os(n.class) : n[Uo] && (n.class = null), n[qo] && (n.style ?? (n.style = null));
  var h = $u(e);
  for (const A in n) {
    let S = n[A];
    if (c && A === "value" && S == null) {
      e.value = e.__value = "", a[A] = S;
      continue;
    }
    if (A === "class") {
      var p = e.namespaceURI === "http://www.w3.org/1999/xhtml";
      qt(e, p, S, r, t == null ? void 0 : t[Uo], n[Uo]), a[A] = S, a[Uo] = n[Uo];
      continue;
    }
    if (A === "style") {
      Br(e, S, t == null ? void 0 : t[qo], n[qo]), a[A] = S, a[qo] = n[qo];
      continue;
    }
    var _ = a[A];
    if (S !== _) {
      a[A] = S;
      var w = A[0] + A[1];
      if (w !== "$$")
        if (w === "on") {
          const u = {}, T = "$$" + A;
          let I = A.slice(2);
          var x = _h(I);
          if (gh(I) && (I = I.slice(0, -7), u.capture = !0), !x && _) {
            if (S != null) continue;
            e.removeEventListener(I, a[T], u), a[T] = null;
          }
          if (S != null)
            if (x)
              e[`__${I}`] = S, Xn([I]);
            else {
              let b = function(wt) {
                a[A].call(this, wt);
              };
              var R = b;
              a[T] = Ol(I, e, b, u);
            }
          else x && (e[`__${I}`] = void 0);
        } else if (A === "style")
          B(e, A, S);
        else if (A === "autofocus")
          qu(
            /** @type {HTMLElement} */
            e,
            !!S
          );
        else if (!s && (A === "__value" || A === "value" && S != null))
          e.value = e.__value = S;
        else if (A === "selected" && c)
          er(
            /** @type {HTMLOptionElement} */
            e,
            S
          );
        else {
          var k = A;
          d || (k = bh(k));
          var y = k === "defaultValue" || k === "defaultChecked";
          if (S == null && !s && !y)
            if (i[A] = null, k === "value" || k === "checked") {
              let u = (
                /** @type {HTMLInputElement} */
                e
              );
              const T = t === void 0;
              if (k === "value") {
                let I = u.defaultValue;
                u.removeAttribute(k), u.defaultValue = I, u.value = u.__value = T ? I : null;
              } else {
                let I = u.defaultChecked;
                u.removeAttribute(k), u.defaultChecked = I, u.checked = T ? I : !1;
              }
            } else
              e.removeAttribute(A);
          else y || h.includes(k) && (s || typeof S != "string") ? e[k] = S : typeof S != "function" && B(e, k, S);
        }
    }
  }
  return a;
}
function ao(e, t, n = [], r, o = !1, i = es) {
  const s = n.map(i);
  var d = void 0, a = {}, c = e.nodeName === "SELECT", g = !1;
  Nr(() => {
    var h = t(...s.map(l));
    zh(e, d, h, r, o), g && c && "value" in h && oi(
      /** @type {HTMLSelectElement} */
      e,
      h.value,
      !1
    );
    for (let _ of Object.getOwnPropertySymbols(a))
      h[_] || Sn(a[_]);
    for (let _ of Object.getOwnPropertySymbols(h)) {
      var p = h[_];
      _.description === _u && (!d || p !== d[_]) && (a[_] && Sn(a[_]), a[_] = Gn(() => Xu(e, () => p)));
    }
    d = h;
  }), c && Pl(
    /** @type {HTMLSelectElement} */
    e,
    () => (
      /** @type {Record<string | symbol, any>} */
      d.value
    )
  ), g = !0;
}
function wa(e) {
  return (
    /** @type {Record<string | symbol, unknown>} **/
    // @ts-expect-error
    e.__attributes ?? (e.__attributes = {
      [Ju]: e.nodeName.includes("-"),
      [Qu]: e.namespaceURI === jf
    })
  );
}
var bc = /* @__PURE__ */ new Map();
function $u(e) {
  var t = bc.get(e.nodeName);
  if (t) return t;
  bc.set(e.nodeName, t = []);
  for (var n, r = e, o = Element.prototype; o !== r; ) {
    n = _f(r);
    for (var i in n)
      n[i].set && t.push(i);
    r = bl(r);
  }
  return t;
}
function td(e, t, n = t) {
  El(e, "input", (r) => {
    var o = r ? e.defaultValue : e.value;
    if (o = Ia(e) ? Na(o) : o, n(o), o !== (o = t())) {
      var i = e.selectionStart, s = e.selectionEnd;
      e.value = o ?? "", s !== null && (e.selectionStart = i, e.selectionEnd = Math.min(s, e.value.length));
    }
  }), // If we are hydrating and the value has since changed,
  // then use the updated value from the input instead.
  // If defaultValue is set, then value == defaultValue
  // TODO Svelte 6: remove input.value check and set to empty string?
  oe(t) == null && e.value && n(Ia(e) ? Na(e.value) : e.value), ns(() => {
    var r = t();
    Ia(e) && r === Na(e.value) || e.type === "date" && !r && !e.value || r !== e.value && (e.value = r ?? "");
  });
}
function Dh(e, t, n = t) {
  El(e, "change", (r) => {
    var o = r ? e.defaultChecked : e.checked;
    n(o);
  }), // If we are hydrating and the value has since changed,
  // then use the update value from the input instead.
  // If defaultChecked is set, then checked == defaultChecked
  oe(t) == null && n(e.checked), ns(() => {
    var r = t();
    e.checked = !!r;
  });
}
function Ia(e) {
  var t = e.type;
  return t === "number" || t === "range";
}
function Na(e) {
  return e === "" ? null : +e;
}
function yc(e, t) {
  return e === t || (e == null ? void 0 : e[kr]) === t;
}
function co(e = {}, t, n, r) {
  return Mo(() => {
    var o, i;
    return ns(() => {
      o = i, i = [], oe(() => {
        e !== n(...i) && (t(e, ...i), o && yc(n(...o), e) && t(null, ...o));
      });
    }), () => {
      ga(() => {
        i && yc(n(...i), e) && t(null, ...i);
      });
    };
  }), e;
}
let fs = !1;
function Bh(e) {
  var t = fs;
  try {
    return fs = !1, [e(), fs];
  } finally {
    fs = t;
  }
}
const Vh = {
  get(e, t) {
    if (!e.exclude.includes(t))
      return e.props[t];
  },
  set(e, t) {
    return !1;
  },
  getOwnPropertyDescriptor(e, t) {
    if (!e.exclude.includes(t) && t in e.props)
      return {
        enumerable: !0,
        configurable: !0,
        value: e.props[t]
      };
  },
  has(e, t) {
    return e.exclude.includes(t) ? !1 : t in e.props;
  },
  ownKeys(e) {
    return Reflect.ownKeys(e.props).filter((t) => !e.exclude.includes(t));
  }
};
// @__NO_SIDE_EFFECTS__
function Cn(e, t, n) {
  return new Proxy(
    { props: e, exclude: t },
    Vh
  );
}
const jh = {
  get(e, t) {
    let n = e.props.length;
    for (; n--; ) {
      let r = e.props[n];
      if (Wo(r) && (r = r()), typeof r == "object" && r !== null && t in r) return r[t];
    }
  },
  set(e, t, n) {
    let r = e.props.length;
    for (; r--; ) {
      let o = e.props[r];
      Wo(o) && (o = o());
      const i = Ar(o, t);
      if (i && i.set)
        return i.set(n), !0;
    }
    return !1;
  },
  getOwnPropertyDescriptor(e, t) {
    let n = e.props.length;
    for (; n--; ) {
      let r = e.props[n];
      if (Wo(r) && (r = r()), typeof r == "object" && r !== null && t in r) {
        const o = Ar(r, t);
        return o && !o.configurable && (o.configurable = !0), o;
      }
    }
  },
  has(e, t) {
    if (t === kr || t === pu) return !1;
    for (let n of e.props)
      if (Wo(n) && (n = n()), n != null && t in n) return !0;
    return !1;
  },
  ownKeys(e) {
    const t = [];
    for (let n of e.props)
      if (Wo(n) && (n = n()), !!n) {
        for (const r in n)
          t.includes(r) || t.push(r);
        for (const r of Object.getOwnPropertySymbols(n))
          t.includes(r) || t.push(r);
      }
    return t;
  }
};
function Rn(...e) {
  return new Proxy({ props: e }, jh);
}
function xc(e) {
  var t;
  return ((t = e.ctx) == null ? void 0 : t.d) ?? !1;
}
function W(e, t, n, r) {
  var u;
  var o = (n & Lf) !== 0, i = !gu, s = (n & zf) !== 0, d = (n & Df) !== 0, a = !1, c;
  s ? [c, a] = Bh(() => (
    /** @type {V} */
    e[t]
  )) : c = /** @type {V} */
  e[t];
  var g = kr in e || pu in e, h = s && (((u = Ar(e, t)) == null ? void 0 : u.set) ?? (g && t in e && ((T) => e[t] = T))) || void 0, p = (
    /** @type {V} */
    r
  ), _ = !0, w = !1, x = () => (w = !0, _ && (_ = !1, d ? p = oe(
    /** @type {() => V} */
    r
  ) : p = /** @type {V} */
  r), p);
  c === void 0 && r !== void 0 && (h && i && Tf(), c = x(), h && h(c));
  var k;
  if (k = () => {
    var T = (
      /** @type {V} */
      e[t]
    );
    return T === void 0 ? x() : (_ = !0, w = !1, T);
  }, !(n & Mf) && i)
    return k;
  if (h) {
    var y = e.$$legacy;
    return function(T, I) {
      return arguments.length > 0 ? ((!I || y || a) && h(I ? k() : T), T) : k();
    };
  }
  var R = !1, A = /* @__PURE__ */ Cu(c), S = /* @__PURE__ */ es(() => {
    var T = k(), I = l(A);
    return R ? (R = !1, I) : A.v = T;
  });
  return s && l(S), o || (S.equals = xl), function(T, I) {
    if (arguments.length > 0) {
      const b = I ? l(S) : s ? Xt(T) : T;
      if (!S.equals(b)) {
        if (R = !0, z(A, b), w && p !== void 0 && (p = b), xc(S))
          return T;
        oe(() => l(S));
      }
      return T;
    }
    return xc(S) ? S.v : l(S);
  };
}
function is(e) {
  je === null && wu(), Ie(() => {
    const t = oe(e);
    if (typeof t == "function") return (
      /** @type {() => void} */
      t
    );
  });
}
const Wh = "5";
var cu;
typeof window < "u" && ((cu = window.__svelte ?? (window.__svelte = {})).v ?? (cu.v = /* @__PURE__ */ new Set())).add(Wh);
const Dr = "Platinum Silver / CZ", ro = "Platinum Silver";
function Vr(e) {
  return e === "N" ? "10mm Round" : e === "E" ? "12mm Round" : e === "L" ? "12x10mm Oval" : "";
}
const Sc = {
  1: "https://app.mesh3d.com/viewer/?client=sanjose",
  2: "https://portal.mesh3d.com/embed/186f48af-e85c-4bfa-96b0-46b4a9b520c2?client=sanjose"
}, Ra = {
  1: "matte",
  2: "flat"
};
function Uh(e, { two_tone: t }) {
  var c, g, h;
  let n = "", r = "", o = "", i = "";
  for (let p = 1; p <= 4; p++) {
    const _ = "part" + p, w = e.parts[_];
    if (w && w.part) {
      if (n += `&${_}=${w.part}`, w.color)
        r += `&${_}Color=${w.color}`;
      else if (w.colors && (w.colors.tone1 && (r += `&${_}Color=${w.colors.tone1}`), w.colors.gems))
        for (const x in w.colors.gems) {
          const k = w.colors.gems[x];
          o += `&${_}${x}=${k}`;
        }
    }
  }
  let s = n + r + o;
  i += `&part2tone2=${Ra}${e.parts.part2.color}`;
  let d = Sc[1] + s + `&part2tone2=${Ra[1]}${e.parts.part2.color}`, a = Sc[2] + s + `&part2tone2=${Ra[2]}${e.parts.part2.color}`;
  if (t) {
    const p = ((g = (c = e.parts.part4) == null ? void 0 : c.colors) == null ? void 0 : g.tone1) || ((h = e.parts.part4) == null ? void 0 : h.color);
    a += "&sealTwoTone=1", p && typeof p == "string" && (a += `&sealTone2=${p}`);
  }
  return {
    src: {
      1: d,
      2: a
    },
    qs: s
  };
}
let qh = 0;
function ed() {
  return `id-${++qh}_${Math.random().toString(36).slice(2)}`;
}
const Fa = {};
function An(e) {
  let t = Fa[e];
  if (t) return t;
  let n = "";
  do
    n = `${e}_${Math.random().toString(36).slice(2)}`;
  while (Fa[n]);
  return Fa[e] = n, n;
}
function vn(e, t, n) {
  if (typeof n == "boolean" && (n = n === !0 ? "true" : "false"), n) {
    e.set(t, n);
    return;
  }
  e.delete(t);
}
function Fr(e, t, n) {
  return t ? n(e) : e;
}
function Lr(e) {
  return e.toLowerCase();
}
function Cc(e) {
  return e === "true" || e === "1";
}
function hs(e, t, n) {
  let [r, o] = e.split("/");
  return r = (r == null ? void 0 : r.trim()) || "", o = (o == null ? void 0 : o.trim()) || "", !r || !o || !t.includes(r) || !n.includes(o) ? (console.error("[x-3d-product-options] Unable to parse metal/stone. Invalid format", {
    metal_stone: e,
    metal: r,
    stone: o,
    all_metals: t,
    all_stones: n
  }), ["", ""]) : [r, o];
}
function Ko(e, t) {
  return !e || !t ? "" : `${e} / ${t}`;
}
function Qe(e) {
  if (!e) return 0;
  let t = Number(e);
  return isNaN(t) || !Number.isFinite(t) ? 0 : t;
}
const Kh = Intl.NumberFormat("en-US", {
  style: "currency",
  // currency: window.Shopify?.currency?.active || 'USD',
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});
function Je(e, t = !1) {
  let n = Qe(e), r = Kh.format(n);
  return t && (r = r.endsWith(".00") ? r.slice(0, -3) : r), r;
}
function Gh(e, t, n) {
  return n ? `${e}${n}${t}` : "";
}
const Hh = Gh.bind(null, "(", ")");
function ys(e, { finalTrim: t = !1, maxLines: n = 3, maxChars: r = 4 } = {}) {
  let i = e.split(`
`).slice(0, Math.max(1, n)).map((s) => {
    let d = s.substring(0, Math.max(4, r)).replaceAll("  ", " ");
    return (s[0] == " " || t) && (d = d.trim()), d;
  }).join(`
`);
  return t && (i = i.replace(/\s+$/g, "").trim()), i = i.replaceAll(`

`, `
`).replaceAll("|", ""), i === `
` ? "" : i;
}
function nd(e, t, n, r, o = 0) {
  if (!e || typeof e != "object") return [];
  if (o === r)
    return e._keys_ || [];
  const i = t[o], s = typeof n.get == "function" ? n.get(i) : n[i], d = [];
  if (s)
    e[s] && d.push(e[s]);
  else if (e != null && e._keys_)
    for (let c = 0, g = e._keys_.length; c < g; c++) {
      const h = e._keys_[c];
      e[h] && d.push(e[h]);
    }
  const a = /* @__PURE__ */ new Set();
  for (const c of d) {
    const g = nd(c, t, n, r, o + 1);
    for (let h = 0, p = g.length; h < p; h++) {
      const _ = g[h];
      a.add(_);
    }
  }
  return Array.from(a).sort((c, g) => c.localeCompare(g));
}
const oo = /* @__PURE__ */ new Map(), Yh = 500, Xh = (e, t) => t instanceof Map ? Array.from(t.entries()) : t;
function Ac(e, t, n, r) {
  const o = JSON.stringify({ filters: n, level: r }, Xh);
  if (oo.has(o))
    return oo.get(o);
  const i = nd(e, t, n, r);
  if (oo.size >= Yh) {
    const s = oo.keys().next().value;
    oo.delete(s);
  }
  return oo.set(o, i), i;
}
var ho, po, vo, li;
class Zh {
  constructor({
    data: t,
    keys: n,
    initialValues: r,
    getItem: o = (s, d) => s,
    autoSelect: i = !0
  }) {
    N(this, ho);
    N(this, po);
    N(this, vo);
    it(this, "keys");
    N(this, li);
    if (vt(this, li, i), !Array.isArray(n)) throw new Error("keys must be an array");
    if (n.length < 1) throw new Error("keys must have at least one element");
    if (Array.isArray(t[0]))
      throw new Error("Nested arrays are not supported");
    this.keys = n, this.treeByKey = n.reduce(
      (d, a, c) => {
        const g = n.slice(c), p = $h({
          data: t,
          keys: g,
          getItem: o,
          canSortKeys: a !== "metal"
        });
        return d[a] = p, d;
      },
      {}
    ), this.rootTree = this.treeByKey[n[0]], vt(this, ho, /* @__PURE__ */ ct(Xt(tp({ keys: n, tree: this.rootTree, initialValues: r })))), vt(this, po, /* @__PURE__ */ L(() => this.keys.reduce(
      (a, c, g) => {
        const h = Ac(
          this.rootTree,
          this.keys,
          this.filterState,
          // Map/pojo of selected filters
          g
        );
        return a[c] = { filterOptions: h, tree: this.treeByKey[c] }, a;
      },
      {}
    ))), vt(this, vo, /* @__PURE__ */ L(() => {
      const d = this.filterState;
      return this.keys.reduce(
        (c, g, h) => {
          if (!c) return null;
          const p = d[g];
          return c[p] ?? null;
        },
        this.rootTree
      );
    })), this.ensureCorrectState();
  }
  get filterState() {
    return l(f(this, ho));
  }
  set filterState(t) {
    z(f(this, ho), t, !0);
  }
  get facetOptions() {
    return l(f(this, po));
  }
  set facetOptions(t) {
    z(f(this, po), t);
  }
  get selectedNode() {
    return l(f(this, vo));
  }
  set selectedNode(t) {
    z(f(this, vo), t);
  }
  getIndexAndKey(t) {
    const n = typeof t == "string" ? this.keys.indexOf(t) : t, r = this.keys[n];
    if (!r) throw new Error(`Invalid index: ${n}. Must be one of ${this.keys.join(", ")}`);
    return { index: n, key: r };
  }
  getFacetOptions(t) {
    const { index: n, key: r } = this.getIndexAndKey(t);
    return { filterOptions: Ac(
      this.rootTree,
      this.keys,
      this.filterState,
      // Map/pojo of selected filters
      n
    ), tree: this.treeByKey[r] };
  }
  setFilterValue(t, n) {
    const { index: r, key: o } = this.getIndexAndKey(t), i = this.treeByKey[o];
    this.filterState[o] = n, Qh(
      ([s, d], a) => {
        var c;
        a > r && (!i || (c = i[v]) != null && c[d]);
      },
      this.filterState
    ), this.ensureCorrectState();
  }
  getFilterValue(t) {
    const { index: n, key: r } = this.getIndexAndKey(t);
    return this.filterState[r];
  }
  ensureCorrectState() {
    const t = f(this, li);
    let n = this.rootTree;
    for (let r = 0; r < this.keys.length; r++) {
      const o = this.keys[r], i = this.filterState[o], s = n == null ? void 0 : n[i];
      if (s == null) {
        for (let d = r; d < this.keys.length; d++) {
          const a = this.keys[d], c = t && this.facetOptions[a].filterOptions[0] || "";
          this.filterState[a] = c;
        }
        break;
      } else
        n = s;
    }
  }
  getRootNode(t) {
    return this.keys.reduce(
      (r, o, i) => {
        if (!r) return null;
        let s = t[o] || this.filterState[o];
        return r[s];
      },
      this.rootTree
    );
  }
}
ho = new WeakMap(), po = new WeakMap(), vo = new WeakMap(), li = new WeakMap();
const Jh = (e) => Object.prototype.toString.call(e) === "[object Object]";
function Ga(e, t, n = 0) {
  if (Jh(e)) {
    const r = [];
    for (const o in e)
      if (Object.prototype.hasOwnProperty.call(e, o)) {
        const i = e[o];
        r.push(o), Ga(i, t, n + 1);
      }
    t(e, r, n);
  }
  if (Array.isArray(e))
    for (let r = 0, o = e.length; r < o; r++)
      Ga(e[r], t, n);
  return e;
}
function Qh(e, t) {
  let n = 0;
  if (typeof t[Symbol.iterator] == "function")
    for (const o of t)
      e(o, n), n++;
  else if (Object.prototype.toString.call(t) === "[object Object]") {
    for (const o in t)
      if (Object.prototype.hasOwnProperty.call(t, o)) {
        const i = t[o];
        e(i, o, n), n++;
      }
  } else
    throw new Error("Invalid iterable");
  return t;
}
function $h({
  data: e,
  keys: t = [],
  getItem: n = (o) => o,
  canSortKeys: r = !0
}) {
  let o = {};
  return t.forEach((i, s) => {
    let d = s === t.length - 1;
    e.forEach((a) => {
      if (!a) return;
      let c = n(a);
      if (!c) return;
      const g = Array.isArray(c);
      let h = g ? c[s] : c[i];
      if (h == null || (typeof h == "number" && (h = h.toString()), typeof h != "string")) return;
      let p = t.slice(0, s).reduce(
        (_, w, x) => {
          const k = g ? c[x] : c[w];
          return _[k];
        },
        o
      );
      p && (p[h] = d ? a : p[h] || {});
    });
  }), Object.keys(o).length > 0 ? Ga(o, (i, s, d) => {
    d === t.length || Object.defineProperty(i, "_keys_", {
      enumerable: !1,
      configurable: !0,
      value: r ? s.sort((c, g) => c.localeCompare(g)) : s
    });
  }) : o;
}
function tp({ keys: e, tree: t, initialValues: n, type: r = "Object" }) {
  let o = t;
  const i = Array.from({ length: e.length }, (s, d) => {
    const a = e[d];
    let c = n && (n[a] || n[a.toLocaleLowerCase()]) || "";
    return c && o && o[c] ? (o = o[c], [a, c]) : (o = null, [a, ""]);
  });
  return Object.fromEntries(i);
}
function ep(e = document.body) {
  return (t) => (e = e || document.body, e.appendChild(t), () => {
    try {
      e.removeChild(t);
    } catch {
    }
  });
}
let kc = { props: {} };
function np(e, t) {
  return e.type === "numeric" && e.decimal ? t.replace(".", "").length : t.length;
}
function rp(e, t) {
  if (!t.trim()) return !e.required;
  const r = np(e, t);
  if (e.minlength && r < e.minlength || e.maxlength && r > e.maxlength) return !1;
  if (e.type === "numeric") {
    const o = Number(t);
    if (!Number.isFinite(o) || typeof e.min == "number" && o < e.min || typeof e.max == "number" && o > e.max) return !1;
  }
  return !0;
}
function ps(e, t) {
  var n, r;
  return ((r = (n = e.parts) == null ? void 0 : n[t]) == null ? void 0 : r.part) || "";
}
function op(e, { rootElement: t, initial: n }) {
  var b, wt, Pt, ut, E, V, K, Y, Z, ot, P, tt, Q, Ct, te, kt, Dt, We, Ue, jt, qe, un, $e, dn, fn, Mn, Jn, zn, Dn, nt, G, pt, Ot, Et, Mt, Ft, be, fe, ye, ue, Fe, Ke, hn, Zt, he, ke, Le, me, Ee, Bt;
  const r = new Map(e.schools_data), o = new Map(e.style_codes);
  let i = e.schools_data[0][1], s = i.variants[0], d = s.code, a = s.shapes[0], c = e.style_codes[0][1].value, g = a.twoTone === "only";
  const h = n != null && n.metal && (n != null && n.stone) ? Ko(n.metal, n.stone) : "";
  let p = e.metal_stone_combinations.includes(h) ? h : e.metal_stone_combinations[0], [_, w] = p ? hs(p, e.all_metals, e.all_stones) : ["", ""], x = e.metal_stone_combinations.reduce(
    ($, m) => {
      const [M, D] = hs(m, e.all_metals, e.all_stones);
      return $[m] = { metal_sone: m, metal: M, stone: D }, $;
    },
    {}
  );
  const k = o.get(c) || e.style_codes[0][1], y = e.metal_colors;
  let R = (n != null && n.p1Color ? y.find(($) => $.value === n.p1Color) : null) || y[0], A = (n != null && n.p2Color ? y.find(($) => $.value === n.p2Color) : null) || y[1], S = (n != null && n.p3Color ? y.find(($) => $.value === n.p3Color) : null) || y[2];
  function u($) {
    return Array.from({ length: $ }, (m, M) => {
      var dt;
      const D = `p1g${M + 1}`, J = (n && D in n ? n[D] : null) || ((dt = kc.props) == null ? void 0 : dt[D]) || null;
      return e.gemstone_colors.find((bt) => bt.value === J) || e.gemstone_colors[0];
    });
  }
  let T = u(k.gemstone_groups_count);
  if (n) {
    if (n.variantCode) {
      i = ((b = e.schools_data.find(([m, M]) => M.variants.some((D) => D.code === n.variantCode))) == null ? void 0 : b[1]) || i, s = i.variants.find((m) => m.code === n.variantCode) || s, d = s ? s.code : d;
      const $ = s.shapes.find((m) => m.value === n.shape);
      $ && (a = $, g = a.twoTone === "only", typeof n.twoTone == "boolean" && a.twoTone === "optional" && (g = n.twoTone));
    }
    if (n.p1Code) {
      const $ = e.style_codes.find(([m, M]) => M.value === n.p1Code);
      $ && $[1].shapes.find((M) => M === a.value) && (c = n.p1Code);
    }
  }
  class I {
    constructor() {
      N(this, V, r);
      N(this, K, o);
      N(this, Y, t);
      it(this, "pendant_or_ring", e.widget_for === "pendant" ? "Pendant" : "Ring");
      it(this, "part1prefix", e.widget_for === "pendant" ? "P" : "R");
      N(this, Z, /* @__PURE__ */ ct(""));
      N(this, ot, /* @__PURE__ */ ct(!1));
      // colors
      it(this, "COLORS", {
        PARTS: e.metal_colors,
        GEMS: e.gemstone_colors
      });
      N(this, P, /* @__PURE__ */ L(() => {
        var M, D;
        const m = e.metal_colors.map((J) => {
          var X, dt;
          return {
            ...J,
            price: (dt = (X = e.addons_pricing.metal_color_additional_price) == null ? void 0 : X[this.metal_stone]) == null ? void 0 : dt[J.value]
          };
        });
        return (this.metal === ro || this.metal === Dr) && m.unshift({
          value: "pl-silver",
          label: "PL Silver",
          hex: "#ffffff",
          price: (D = (M = e.addons_pricing.metal_color_additional_price) == null ? void 0 : M[this.metal_stone]) == null ? void 0 : D["pl-silver"]
        }), m;
      }));
      N(this, tt, /* @__PURE__ */ ct(Xt(_)));
      N(this, Q, /* @__PURE__ */ ct(Xt(w)));
      N(this, Ct, /* @__PURE__ */ L(() => {
        const m = this.metal, M = this.stone;
        return !m || !M ? "" : Ko(m, M);
      }));
      N(this, te, /* @__PURE__ */ L(() => {
        var D;
        const m = this.metal, M = ((D = this.part1Color) == null ? void 0 : D.label) || "";
        return m === ro || m === Dr ? "PL Silver" : `${m} ${M}`;
      }));
      N(this, kt, /* @__PURE__ */ ct(Xt(i.name)));
      N(this, Dt, /* @__PURE__ */ ct(Xt(d)));
      N(this, We, /* @__PURE__ */ ct(Xt(c)));
      N(this, Ue, /* @__PURE__ */ ct(Xt({})));
      N(this, jt, /* @__PURE__ */ L(() => e.dynamic_fields && !Array.isArray(e.dynamic_fields) ? e.dynamic_fields[this.selectedVariantCode] || [] : []));
      N(this, qe, /* @__PURE__ */ L(() => this.dynamicFields.map((m) => ({
        field: m,
        value: this.dynamicFieldValues[m.id] || ""
      })).filter(({ value: m, field: M }) => M.required || !!m.trim())));
      N(this, un, /* @__PURE__ */ L(() => this.dynamicFields.every((m) => rp(m, this.dynamicFieldValues[m.id] || ""))));
      N(this, $e, /* @__PURE__ */ L(() => f(this, V).get(this.selectedSchool)));
      N(this, dn, /* @__PURE__ */ L(() => this.school.variants.find((m) => m.code === this.selectedVariantCode)));
      N(this, fn, /* @__PURE__ */ L(() => f(this, K).get(this.selectedPart1Code) || e.style_codes[0][1]));
      N(this, Mn, /* @__PURE__ */ L(() => e.style_codes.filter(([m, M]) => M.shapes.includes(this.shape.value))));
      N(this, Jn, /* @__PURE__ */ L(() => {
        const m = this.part1Item;
        return m ? m.label === m.value ? m.value : `${m.label} (${m.value})` : "";
      }));
      N(this, zn, /* @__PURE__ */ L(() => {
        var m, M;
        return ((m = this.part1Item) == null ? void 0 : m.has_stones) || ((M = this.band) == null ? void 0 : M.has_stones) || !1;
      }));
      N(this, Dn, /* @__PURE__ */ ct(Xt(T)));
      N(this, nt, /* @__PURE__ */ ct(Xt(e.widget_for === "pendant" ? "" : n != null && n.bandStyle && ((Pt = (wt = this.part1Item) == null ? void 0 : wt.bands) != null && Pt.includes(n.bandStyle)) ? n.bandStyle : ((E = (ut = this.part1Item) == null ? void 0 : ut.bands) == null ? void 0 : E[0]) || "")));
      N(this, G, /* @__PURE__ */ L(() => {
        const m = `${this.selected_band}_${this.metal_stone}`, M = e.band_metal_stone_combinations_hashmap[m], D = M ? M.price : null, J = M ? M.band_code : null, X = J ? e.bands_hashmap[J] : null;
        return X && D ? { ...X, price: D } : null;
      }));
      N(this, pt, /* @__PURE__ */ ct(Xt(n != null && n.ringSize && e.ring_sizes.includes(n.ringSize) ? n.ringSize : e.ring_sizes.includes("6.5") ? "6.5" : e.ring_sizes[0] || "")));
      N(this, Ot, /* @__PURE__ */ L(() => this.variant.shapes.filter((M) => this.part1Item.shapes.some((D) => D === M.value))));
      N(this, Et, /* @__PURE__ */ ct(Xt(a)));
      N(this, Mt, /* @__PURE__ */ ct(Xt(g)));
      N(this, Ft, /* @__PURE__ */ ct(Xt(R)));
      N(this, be, /* @__PURE__ */ ct(Xt(this.SEAL_COLORS.find((m) => m.value === (n == null ? void 0 : n.p2Color)) || A)));
      N(this, fe, /* @__PURE__ */ ct(Xt(S)));
      N(this, ye, /* @__PURE__ */ ct(Xt(n != null && n.engraving ? ys(n.engraving, { finalTrim: !0 }) : "")));
      N(this, ue, /* @__PURE__ */ ct(!!this.engraving));
      N(this, Fe, /* @__PURE__ */ L(() => {
        const m = this.engraving;
        return m ? m.split(`
`).reduce(
          (D, J) => {
            const X = J.trim();
            return X && D.push(X), D;
          },
          []
        ) : [];
      }));
      N(this, Ke, /* @__PURE__ */ L(() => {
        const m = this.part1Item.value;
        let M = this.variant.code + this.shape.value, D = null;
        return this.twoToneSelected && (D = "2L" + M, M = "2" + M), { p1: m, p2: M, p3: D };
      }));
      N(this, hn, null);
      N(this, Zt, /* @__PURE__ */ L(() => {
        var It, Jt, xe, Ht;
        const m = this.partCodes, M = this.gemstone_colors.length > 0 ? this.gemstone_colors.reduce(
          (ee, pe, Me) => (ee[`g${Me + 1}`] = pe.value, ee),
          {}
        ) : void 0;
        let D = ((It = this.part1Color) == null ? void 0 : It.value) || "white", J = ((Jt = this.part2Color) == null ? void 0 : Jt.value) || "yellow", X = ((xe = this.part3Color) == null ? void 0 : xe.value) || "rose";
        D === "pl-silver" && (D = "white"), J === "pl-silver" && (J = "white"), X === "pl-silver" && (X = "white");
        const dt = {}, bt = e.portal_version === "1" ? { x: 90 } : {}, xt = e.portal_version === "2", ft = this.part1prefix === "R" && this.selected_band ? {
          parts: {
            // band top
            part1: {
              part: Fr(this.part1prefix + this.part1Item.value + this.shape.value, xt, Lr),
              colors: { tone1: D, gems: M }
            },
            // seal
            part2: {
              part: Fr(m.p2, xt, Lr),
              color: J,
              rotation: dt
            },
            // band circle
            part3: {
              part: Fr(`${(Ht = this.part1Item) == null ? void 0 : Ht.value}${this.selected_band}${this.shape.value}`, xt, Lr),
              color: D
            },
            // seal logo
            part4: m.p3 ? {
              part: Fr(m.p3 || "_", xt, Lr),
              colors: { tone1: m.p3 ? X : "" },
              rotation: dt
            } : { part: "", color: "" }
          }
        } : {
          parts: {
            part1: {
              part: Fr(this.part1prefix + this.part1Item.value + this.shape.value, xt, Lr),
              colors: { tone1: D, gems: M },
              rotation: bt
            },
            part2: {
              part: Fr(m.p2, xt, Lr),
              color: J,
              rotation: bt
            },
            part3: m.p3 ? {
              part: Fr(m.p3 || "_", xt, Lr),
              color: m.p3 ? X : "",
              rotation: bt
            } : {
              part: "",
              color: "",
              rotation: bt
            }
          }
        }, gt = {
          part1: ps(ft, "part1"),
          part2: ps(ft, "part2"),
          part3: ps(ft, "part3"),
          part4: ps(ft, "part4")
        }, At = f(this, hn), Lt = At ? gt.part1 !== At.part1 || gt.part2 !== At.part2 || gt.part3 !== At.part3 || gt.part4 !== At.part4 : !1;
        vt(this, hn, gt);
        const St = Uh(ft, { two_tone: this.twoToneSelected });
        return {
          src: St.src[e.portal_version],
          src_qs: St.qs,
          data: ft,
          parts_changed: Lt,
          portal_version: e.portal_version
        };
      }));
      N(this, he, /* @__PURE__ */ L(() => {
        var X, dt, bt;
        const m = this.variant;
        let M = this.selectedSchool;
        m.name !== "default" && (M += ` (${m.name})`);
        const D = this.iframeData;
        return {
          data: {
            School: M,
            [`${this.pendant_or_ring} Top Style`]: this.part1Item.label,
            [`${this.pendant_or_ring} Top Color`]: (X = this.part1Color) == null ? void 0 : X.label,
            "Seal Size": Vr(this.shape.value || ""),
            "Seal Color": (dt = this.part2Color) == null ? void 0 : dt.label,
            "Logo Color": this.twoToneSelected ? (bt = this.part3Color) == null ? void 0 : bt.label : "",
            "2-Tone": this.twoToneSelected,
            Stone: this.metal_stone,
            _json: {
              top_style: {
                label: this.part1Item.label,
                value: this.part1Item.value,
                color: this.part1Color
              },
              stone: this.metal_stone,
              seal: {
                value: this.shape.value,
                label: Vr(this.shape.value || ""),
                color: this.part2Color
              },
              logo_color: this.twoToneSelected ? this.part3Color : null,
              two_tone: this.twoToneSelected
            },
            _data: {
              src: D.src,
              parts: D.data.parts,
              parts_changed: D.parts_changed
            },
            price: { total: this.pricing.total }
          },
          sort_keys: [
            "School",
            `${this.pendant_or_ring} Top Style`,
            `${this.pendant_or_ring} Top Color`,
            "Seal Size",
            "Seal Color",
            "Logo Color",
            "_data"
          ]
        };
      }));
      N(this, ke, /* @__PURE__ */ L(() => {
        var X;
        const m = ((X = this.part1Item) == null ? void 0 : X.value) || "", M = e.metal_stone_combinations.map((dt) => {
          const bt = m ? `${m}_${this.shape.value}_${dt}` : "", xt = bt ? !e.style_size_stone_combinations_hashmap.get(bt) : !1, { metal: ft, stone: gt } = x[dt];
          return {
            label: dt,
            value: dt,
            disabled: xt,
            selected: this.metal_stone === dt,
            metal: ft,
            stone: gt
          };
        }), D = [], J = [];
        for (let dt = 0, bt = M.length; dt < bt; dt++) {
          const xt = M[dt];
          if (!D.find((gt) => gt.value === xt.metal)) {
            const At = !e.all_stones.some((Lt) => {
              const St = `${m}_${this.shape.value}_${Ko(xt.metal, Lt)}`;
              return e.style_size_stone_combinations_hashmap.get(St);
            });
            D.push({
              value: xt.metal,
              selected: this.metal === xt.metal,
              disabled: At
            });
          }
        }
        for (let dt = 0, bt = e.all_stones.length; dt < bt; dt++) {
          const xt = e.all_stones[dt], ft = `${m}_${this.shape.value}_${Ko(this.metal, xt)}`, gt = e.style_size_stone_combinations_hashmap.get(ft), At = !gt, Lt = this.stone === xt, St = gt ? gt.price : "";
          At || J.push({ value: xt, disabled: At, selected: Lt, price: St });
        }
        return { combined: M, metals: D, stones: J };
      }));
      // chain = $state({
      //   metal: '',
      //   color: '',
      //   length: '',
      // })
      it(this, "chain_facet", new Zh({
        data: e.chains_pricing.map((m) => ({
          length: m[0],
          metal: m[1],
          color: m[2],
          price: m[3]
        })),
        keys: ["metal", "color", "length"],
        initialValues: {
          metal: (n == null ? void 0 : n.chainMetal) || void 0,
          color: (n == null ? void 0 : n.chainColor) || void 0,
          length: (n == null ? void 0 : n.chainLength) || void 0
        }
      }));
      it(this, "chain", this.chain_facet.filterState);
      N(this, Le, /* @__PURE__ */ L(() => {
        var M, D;
        if (e.widget_for !== "pendant") return null;
        const m = (D = (M = e.chains_tree[this.chain.metal]) == null ? void 0 : M[this.chain.color]) == null ? void 0 : D[this.chain.length];
        return m ? {
          ...m,
          formatted_text: `${this.chain.length}" - ${this.chain.metal} - ${this.chain.color}`
        } : null;
      }));
      N(this, me, /* @__PURE__ */ L(() => {
        var D;
        const m = `${((D = this.part1Item) == null ? void 0 : D.value) || ""}_${this.shape.value}_${Ko(this.metal, this.stone)}`;
        return e.style_size_stone_combinations_hashmap.get(m) ?? null;
      }));
      N(this, Ee, /* @__PURE__ */ L(() => {
        var St, It, Jt, xe, Ht, ee, pe, Me, Rt, ve;
        const m = this.base_item, M = m ? m.price : null, D = e.widget_for === "pendant" ? null : ((St = this.band) == null ? void 0 : St.price) || null, J = ((It = this.chain_root) == null ? void 0 : It.price) || null, X = e.addons_pricing.engraving && this.engraving && this.engraving_show ? e.addons_pricing.engraving : null, dt = e.addons_pricing.two_tone && this.twoToneSelected ? e.addons_pricing.two_tone : null, bt = (Jt = this.part1Color) == null ? void 0 : Jt.value, xt = bt && this.metal_stone ? (Ht = (xe = e.addons_pricing.metal_color_additional_price) == null ? void 0 : xe[this.metal_stone]) == null ? void 0 : Ht[bt] : null, ft = ((ee = this.part2Color) == null ? void 0 : ee.value) || "", gt = ft && this.metal_stone ? ((Me = (pe = e.addons_pricing.seal_color_additional_price) == null ? void 0 : pe[this.metal_stone]) == null ? void 0 : Me[ft]) || ((ve = (Rt = e.addons_pricing.seal_color_additional_price) == null ? void 0 : Rt[this.metal]) == null ? void 0 : ve[ft]) : null, At = this.dynamicFieldEntries.reduce((ne, { field: _e }) => ne + Qe(_e.price), 0), Lt = Number(Qe(M) + Qe(D) + Qe(J) + Qe(dt) + Qe(X) + Qe(xt) + Qe(gt) + At).toFixed(2);
        return {
          style_metal_stone: M,
          band: D,
          chain: J,
          engraving: X,
          two_tone: dt,
          metal_color_price: xt,
          seal_color_price: gt,
          dynamic_fields: At,
          total: Lt
        };
      }));
      N(this, Bt, /* @__PURE__ */ L(() => {
        var M, D, J, X, dt;
        const m = [];
        m.push(["widget_for", e.widget_for]), m.push(["school", this.school.name]), m.push(["style", ((M = this.part1Item) == null ? void 0 : M.value) || ""]), m.push(["seal_design", this.selectedVariantCode]), m.push(["seal_size", this.shape.value]), m.push(["band_style", e.widget_for === "pendant" ? "" : this.selected_band]), m.push(["ring_size", this.ring_size]), m.push(["metal_stone", this.metal_stone]), m.push([
          "two_tone",
          this.shape.twoTone !== "none" && this.twoToneSelected ? "true" : "false"
        ]), m.push(["part1Color", ((D = this.part1Color) == null ? void 0 : D.value) ?? ""]), m.push(["part2Color", ((J = this.part2Color) == null ? void 0 : J.value) ?? ""]), m.push(["part3Color", ((X = this.part3Color) == null ? void 0 : X.value) ?? ""]);
        for (let bt = 0; bt < this.gemstone_colors.length; bt++) {
          const xt = `gemstone_colors[${bt}]`;
          m.push([xt, this.gemstone_colors[bt].value]);
        }
        return m.push([
          "chain",
          ((dt = this.chain_root) == null ? void 0 : dt.formatted_text) || ""
        ]), m.push(["engraving", this.engraving]), Object.fromEntries(m);
      }));
      _n(() => {
        const D = this.shapes;
        if (!D.length) {
          oe(() => {
            this.selectedPart1Code = this.part1List[0][1].value;
          });
          return;
        }
        const J = oe(() => {
          var X;
          return (X = this.shape) == null ? void 0 : X.value;
        });
        D && oe(() => {
          this.shape = D.find((X) => X.value === J) || D[0];
        });
      }), _n(() => {
        const D = this.part1Item;
        D == null || D.value;
        const J = this.metal_stones.combined, X = J.find((ft) => ft.selected);
        J && X && X.disabled && oe(() => {
          const ft = J.find((gt) => !gt.disabled);
          if (ft && ft.value) {
            const [gt, At] = hs(ft.value, e.all_metals, e.all_stones);
            this.metal = gt, this.stone = At;
          } else
            this.metal = "", this.stone = "";
        });
        const dt = oe(() => Uf(this.gemstone_colors));
        if (dt)
          for (let ft = 0; ft < dt.length; ft++) {
            const gt = `p1g${ft + 1}`;
            kc.props[gt] = dt[ft].value;
          }
        this.gemstone_colors = u(this.part1Item.gemstone_groups_count || 0);
        const bt = D && Array.isArray(D.bands) ? D.bands : null, xt = oe(() => this.selected_band);
        (!bt || bt.length === 0 || !bt.includes(xt)) && oe(() => {
          this.selected_band = e.widget_for === "pendant" ? "" : bt && bt.length > 0 ? bt[0] : "";
        });
      }), _n(() => {
        var J;
        this.metal, oe(() => this.base_item) || (this.stone = ((J = this.metal_stones.stones.find((X) => !X.disabled)) == null ? void 0 : J.value) || "");
      }), _n(() => {
        const D = this.metal_stone, J = this.COLORS.PARTS.find((dt) => dt.value === "white");
        if (!J) return;
        D === Dr && oe(() => {
          this.part1Color = J;
        });
      }), _n(() => {
        const D = this.metal;
        if (oe(() => {
          var X;
          return ((X = this.part2Color) == null ? void 0 : X.value) || "";
        }) === "pl-silver" && !this.SEAL_COLORS.find((X) => X.value === "pl-silver")) {
          oe(() => {
            this.part2Color = this.SEAL_COLORS[0];
          });
          return;
        }
        D === ro && oe(() => this.user_interacted) && oe(() => {
          this.part2Color = this.SEAL_COLORS.find((X) => X.value === "pl-silver") || this.SEAL_COLORS[0];
        });
      }), _n(() => {
        this.shape.twoTone === "only" ? this.twoToneSelected = !0 : this.shape.twoTone === "none" && (this.twoToneSelected = !1);
      });
      let m = !0;
      const M = e.iframe_id && document ? document.getElementById(e.iframe_id) : null;
      Ie(() => {
        var D;
        if (M)
          if (m) {
            const J = this.iframeData.src;
            M.src = J;
          } else
            M.setAttribute("data-src", this.iframeData.src), (D = M.contentWindow) == null || D.postMessage(this.iframeData.data, "*");
        f(this, Y).__event_data_change_iframe = this.iframeData, f(this, Y).dispatchEvent(new CustomEvent("data:change:iframe", { detail: this.iframeData, bubbles: !1 })), m = !1;
      }), Ie(() => {
        const D = this.event_change_data;
        t.__event_data_change = D, t.dispatchEvent(new CustomEvent("data:change", { detail: D, bubbles: !1 }));
      });
    }
    get current_url() {
      return l(f(this, Z));
    }
    set current_url(m) {
      z(f(this, Z), m, !0);
    }
    get user_interacted() {
      return l(f(this, ot));
    }
    set user_interacted(m) {
      z(f(this, ot), m, !0);
    }
    get SEAL_COLORS() {
      return l(f(this, P));
    }
    set SEAL_COLORS(m) {
      z(f(this, P), m);
    }
    get metal() {
      return l(f(this, tt));
    }
    set metal(m) {
      z(f(this, tt), m, !0);
    }
    get stone() {
      return l(f(this, Q));
    }
    set stone(m) {
      z(f(this, Q), m, !0);
    }
    get metal_stone() {
      return l(f(this, Ct));
    }
    set metal_stone(m) {
      z(f(this, Ct), m);
    }
    get part1_display_text() {
      return l(f(this, te));
    }
    set part1_display_text(m) {
      z(f(this, te), m);
    }
    get selectedSchool() {
      return l(f(this, kt));
    }
    set selectedSchool(m) {
      z(f(this, kt), m, !0);
    }
    get selectedVariantCode() {
      return l(f(this, Dt));
    }
    set selectedVariantCode(m) {
      z(f(this, Dt), m, !0);
    }
    get selectedPart1Code() {
      return l(f(this, We));
    }
    set selectedPart1Code(m) {
      z(f(this, We), m, !0);
    }
    get dynamicFieldValues() {
      return l(f(this, Ue));
    }
    set dynamicFieldValues(m) {
      z(f(this, Ue), m, !0);
    }
    get dynamicFields() {
      return l(f(this, jt));
    }
    set dynamicFields(m) {
      z(f(this, jt), m);
    }
    get dynamicFieldEntries() {
      return l(f(this, qe));
    }
    set dynamicFieldEntries(m) {
      z(f(this, qe), m);
    }
    get dynamicFieldsRequiredComplete() {
      return l(f(this, un));
    }
    set dynamicFieldsRequiredComplete(m) {
      z(f(this, un), m);
    }
    get school() {
      return l(f(this, $e));
    }
    set school(m) {
      z(f(this, $e), m);
    }
    get variant() {
      return l(f(this, dn));
    }
    set variant(m) {
      z(f(this, dn), m);
    }
    get part1Item() {
      return l(f(this, fn));
    }
    set part1Item(m) {
      z(f(this, fn), m);
    }
    get part1List() {
      return l(f(this, Mn));
    }
    set part1List(m) {
      z(f(this, Mn), m);
    }
    get part1ItemDisplayText() {
      return l(f(this, Jn));
    }
    set part1ItemDisplayText(m) {
      z(f(this, Jn), m);
    }
    get can_select_stone() {
      return l(f(this, zn));
    }
    set can_select_stone(m) {
      z(f(this, zn), m);
    }
    get gemstone_colors() {
      return l(f(this, Dn));
    }
    set gemstone_colors(m) {
      z(f(this, Dn), m, !0);
    }
    get selected_band() {
      return l(f(this, nt));
    }
    set selected_band(m) {
      z(f(this, nt), m, !0);
    }
    get band() {
      return l(f(this, G));
    }
    set band(m) {
      z(f(this, G), m);
    }
    get ring_size() {
      return l(f(this, pt));
    }
    set ring_size(m) {
      z(f(this, pt), m, !0);
    }
    get shapes() {
      return l(f(this, Ot));
    }
    set shapes(m) {
      z(f(this, Ot), m);
    }
    get shape() {
      return l(f(this, Et));
    }
    set shape(m) {
      z(f(this, Et), m, !0);
    }
    get twoToneSelected() {
      return l(f(this, Mt));
    }
    set twoToneSelected(m) {
      z(f(this, Mt), m, !0);
    }
    get part1Color() {
      return l(f(this, Ft));
    }
    set part1Color(m) {
      z(f(this, Ft), m, !0);
    }
    get part2Color() {
      return l(f(this, be));
    }
    set part2Color(m) {
      z(f(this, be), m, !0);
    }
    get part3Color() {
      return l(f(this, fe));
    }
    set part3Color(m) {
      z(f(this, fe), m, !0);
    }
    get engraving() {
      return l(f(this, ye));
    }
    set engraving(m) {
      z(f(this, ye), m, !0);
    }
    get engraving_show() {
      return l(f(this, ue));
    }
    set engraving_show(m) {
      z(f(this, ue), m, !0);
    }
    get engraving_lines() {
      return l(f(this, Fe));
    }
    set engraving_lines(m) {
      z(f(this, Fe), m);
    }
    get partCodes() {
      return l(f(this, Ke));
    }
    set partCodes(m) {
      z(f(this, Ke), m);
    }
    get iframeData() {
      return l(f(this, Zt));
    }
    set iframeData(m) {
      z(f(this, Zt), m);
    }
    get event_change_data() {
      return l(f(this, he));
    }
    set event_change_data(m) {
      z(f(this, he), m);
    }
    get metal_stones() {
      return l(f(this, ke));
    }
    set metal_stones(m) {
      z(f(this, ke), m);
    }
    get chain_root() {
      return l(f(this, Le));
    }
    set chain_root(m) {
      z(f(this, Le), m);
    }
    get base_item() {
      return l(f(this, me));
    }
    set base_item(m) {
      z(f(this, me), m);
    }
    get pricing() {
      return l(f(this, Ee));
    }
    set pricing(m) {
      z(f(this, Ee), m);
    }
    get state_values() {
      return l(f(this, Bt));
    }
    set state_values(m) {
      z(f(this, Bt), m);
    }
    set_school(m) {
      return f(this, V).get(m) ? (this.selectedSchool = m, this.selectedVariantCode = f(this, V).get(m).variants[0].code, !0) : !1;
    }
    set_shape(m) {
      if (m) {
        if (typeof m == "string") {
          const M = this.shapes.find((D) => D.value === m);
          return M ? (this.shape = M, !0) : void 0;
        }
        if (m.value && "twoTone" in m && this.shapes.find((M) => M === m || M.value === m.value))
          return this.shape = m, !0;
      }
    }
    set_metal_stone(m) {
      if (!m) {
        this.metal = "", this.stone = "";
        return;
      }
      const [M, D] = hs(m, e.all_metals, e.all_stones);
      this.metal = M, this.stone = D;
    }
    get_color_name_with_metal(m, M) {
      if (!m) return;
      let D = this.metal;
      return M === "base" ? M === "base" && (D === ro || D === Dr) ? "PL Silver" : D === ro || D === Dr ? m : `${D} ${m}` : M === "seal" || M === "logo" ? ((D === ro || D === Dr || M === "seal" || M === "logo") && (D = "14K"), (m === "pl-silver" || m === "PL Silver") && (D = ""), `${D} ${m}`.trim()) : m;
    }
  }
  return V = new WeakMap(), K = new WeakMap(), Y = new WeakMap(), Z = new WeakMap(), ot = new WeakMap(), P = new WeakMap(), tt = new WeakMap(), Q = new WeakMap(), Ct = new WeakMap(), te = new WeakMap(), kt = new WeakMap(), Dt = new WeakMap(), We = new WeakMap(), Ue = new WeakMap(), jt = new WeakMap(), qe = new WeakMap(), un = new WeakMap(), $e = new WeakMap(), dn = new WeakMap(), fn = new WeakMap(), Mn = new WeakMap(), Jn = new WeakMap(), zn = new WeakMap(), Dn = new WeakMap(), nt = new WeakMap(), G = new WeakMap(), pt = new WeakMap(), Ot = new WeakMap(), Et = new WeakMap(), Mt = new WeakMap(), Ft = new WeakMap(), be = new WeakMap(), fe = new WeakMap(), ye = new WeakMap(), ue = new WeakMap(), Fe = new WeakMap(), Ke = new WeakMap(), hn = new WeakMap(), Zt = new WeakMap(), he = new WeakMap(), ke = new WeakMap(), Le = new WeakMap(), me = new WeakMap(), Ee = new WeakMap(), Bt = new WeakMap(), new I();
}
function ip(e) {
  let t = [];
  for (let o = 0, i = e.length; o < i; o++) {
    const s = e[o];
    s.id && (s.fields = s.fields.filter((d) => d), (s.fields.length || s.never_skip) && t.push(s));
  }
  let n = t.reduce(
    (o, i) => {
      for (let s = 0, d = i.fields.length; s < d; s++) {
        const a = i.fields[s];
        a && !o.includes(a) && o.push(a);
      }
      return o;
    },
    []
  );
  const r = t.reduce(
    (o, i, s) => {
      for (let d = 0, a = i.fields.length; d < a; d++) {
        const c = i.fields[d];
        o[c] = s;
      }
      return o;
    },
    {}
  );
  return {
    steps: t,
    field_names: n,
    stepIndexByField: r
  };
}
function sp(e) {
  let t = /* @__PURE__ */ ct(e.steps), n = /* @__PURE__ */ ct(e.field_names), r = e.initialIndex ?? 0;
  (r < 0 || r >= l(t).length) && (r = 0);
  let o = /* @__PURE__ */ ct(Xt(r)), i = /* @__PURE__ */ ct(Xt(Object.fromEntries(l(n).map((y) => [
    y,
    { value: null, touched: !1, valid: !1 }
  ]))));
  function s(y) {
    (y.steps.length !== l(t).length || y.field_names.length !== l(n).length || l(t).some((A, S) => A.id !== y.steps[S].id || A.fields.length !== y.steps[S].fields.length || A.fields.some((u, T) => u !== y.steps[S].fields[T]))) && (z(t, y.steps), z(n, y.field_names), z(
      i,
      Object.fromEntries(l(n).map((A) => {
        const S = l(i)[A];
        return [
          A,
          S || { value: null, touched: !1, valid: !1 }
        ];
      })),
      !0
    ));
  }
  const d = /* @__PURE__ */ L(() => l(o) === 0), a = /* @__PURE__ */ L(() => l(o) === l(t).length - 1), c = /* @__PURE__ */ L(() => l(t)[l(o)]), g = /* @__PURE__ */ L(() => {
    const y = l(t)[l(o)];
    return y ? y.fields.every((R) => {
      const A = l(i)[R];
      return A.value != null && A.valid;
    }) : !1;
  }), h = /* @__PURE__ */ L(() => l(a) ? !1 : l(g)), p = /* @__PURE__ */ L(() => {
    let y = l(t).length;
    const R = l(t)[l(t).length - 1];
    return (R.id.toLowerCase() === "summary" || R.id.toLowerCase() === "review") && (y -= 1), Number(Math.min(100, Math.max(0, l(o) / y * 100)).toFixed(0));
  });
  function _() {
    l(h) && (l(a) || fc(o));
  }
  function w() {
    l(d) || fc(o, -1);
  }
  function x(y) {
    if (!l(t)[y] || y === l(o)) return;
    if (y < l(o)) {
      z(o, y, !0);
      return;
    }
    if (y === l(o) + 1) {
      _();
      return;
    }
    if (y === l(o) - 1) {
      w();
      return;
    }
    if (l(t).slice(0, y).every((I) => I.fields.every((wt) => l(i)[wt].value != null))) {
      z(o, y, !0);
      return;
    }
  }
  function k(y, { value: R, valid: A, touched: S }) {
    const u = l(i)[y];
    if (!u) {
      console.warn(`Field ${y} does not exist`);
      return;
    }
    typeof R < "u" && (u.value = R), typeof A == "boolean" && (u.valid = A), typeof S == "boolean" && (u.touched = S);
  }
  return {
    get stepIndex() {
      return l(o);
    },
    get currentStep() {
      return l(c);
    },
    get isFirst() {
      return l(d);
    },
    get isLast() {
      return l(a);
    },
    get canGoNext() {
      return l(h);
    },
    get isCurrentComplete() {
      return l(g);
    },
    get percent_complete() {
      return l(p);
    },
    resetSteps: s,
    get steps() {
      return l(t);
    },
    get field_names() {
      return l(n);
    },
    get fields_state() {
      return l(i);
    },
    // Actions
    next: _,
    prev: w,
    goToStep: x,
    setFieldValue: k
  };
}
var ap = (e, t, n) => {
  e.target.checked && t.setValue(l(n));
}, lp = /* @__PURE__ */ j('<span class="tw:p-2 tw:rounded tw:border tw:border-gray-300 tw:cursor-pointer"> </span>'), cp = /* @__PURE__ */ j('<label><input type="radio" class="tw:opacity-0 tw:w-0 tw:h-0 tw:absolute tw:z-[-1] svelte-10kowh4"/> <!></label>'), up = /* @__PURE__ */ j("<div></div>");
function Go(e, t) {
  Kt(t, !0);
  let n = W(t, "valueToString", 3, (s) => {
    if (typeof s == "string") return s;
    throw new Error("`valueToString` is required for non-string values");
  }), r = W(t, "class", 3, "");
  const o = ed();
  var i = up();
  qt(i, 1, "tw:relative tw:flex tw:gap-4 tw:flex-wrap"), we(i, 21, () => t.values, sn, (s, d) => {
    var a = cp();
    const c = /* @__PURE__ */ L(() => n()(l(d))), g = /* @__PURE__ */ L(() => `${o}-${l(c)}`), h = /* @__PURE__ */ L(() => t.value != null && l(c) === n()(t.value)), p = /* @__PURE__ */ L(() => {
      var y;
      return typeof t.disabled == "boolean" ? t.disabled : (y = t.disabled) == null ? void 0 : y.call(t, l(d));
    });
    var _ = C(a);
    _.__change = [ap, t, d];
    var w = F(_, 2);
    {
      var x = (y) => {
        var R = _t(), A = rt(R);
        ie(A, () => t.children ?? Re, () => ({
          value: l(d),
          checked: l(h),
          disabled: l(p)
        })), O(y, R);
      }, k = (y) => {
        var R = lp(), A = C(R);
        q(() => et(A, l(c))), O(y, R);
      };
      U(w, (y) => {
        t.children ? y(x) : y(k, !1);
      });
    }
    q(() => {
      qt(a, 1, `tw:relative xtw:overflow-hidden ${r() || ""} tw:text-center`), B(a, "for", l(g)), B(a, "data-value", l(c)), B(_, "id", l(g)), B(_, "name", `name_${o}`), Mh(_, l(h)), ge(_, l(c)), _.disabled = l(p);
    }), O(s, a);
  }), O(e, i), Gt();
}
Xn(["change"]);
var dp = /* @__PURE__ */ j("<option disabled> </option>"), fp = /* @__PURE__ */ j("<option> </option>"), hp = /* @__PURE__ */ j('<div><div class="product__label-wpper"><label class="mr-0 tw:inline-block product__label fs-body-100 tw:mr-1"> </label> <span class="t-opacity-70 tw:empty:hidden" data-option-value=""> </span></div> <div class="select-wrapper"><select><!><!></select></div> <!></div>');
function $n(e, t) {
  Kt(t, !0);
  let n = W(t, "id", 19, ed), r = W(t, "value", 15, ""), o = W(t, "options", 19, () => []), i = W(t, "required", 3, !0), s = W(t, "disabled", 3, !1), d = W(t, "totalOptionsCount", 3, null), a = W(t, "inlineLabel", 3, !0), c = W(t, "hidden", 3, !1), g = r() || "";
  function h(ut) {
    var V;
    const E = ut.target.value;
    (V = t.onChange) == null || V.call(t, E, ut), E !== g && (g = r(), r(E));
  }
  var p = hp(), _ = C(p), w = C(_), x = C(w), k = F(w, 2), y = C(k), R = F(_, 2), A = C(R);
  A.__change = h;
  var S = C(A);
  {
    var u = (ut) => {
      var E = dp();
      E.value = E.__value = "";
      var V = C(E);
      q(() => et(V, t.placeholder)), O(ut, E);
    };
    U(S, (ut) => {
      t.placeholder && ut(u);
    });
  }
  var T = F(S);
  {
    var I = (ut) => {
      var E = _t(), V = rt(E);
      ie(V, () => t.optionsSnippet), O(ut, E);
    }, b = (ut) => {
      var E = _t(), V = rt(E);
      we(V, 17, o, (K) => K.value, (K, Y) => {
        var Z = fp(), ot = {}, P = C(Z);
        q(() => {
          ot !== (ot = l(Y).value) && (Z.value = (Z.__value = l(Y).value) ?? ""), et(P, l(Y).label ?? l(Y).value);
        }), O(K, Z);
      }), O(ut, E);
    };
    U(T, (ut) => {
      t.optionsSnippet ? ut(I) : ut(b, !1);
    });
  }
  var wt = F(R, 2);
  {
    var Pt = (ut) => {
      var E = _t(), V = rt(E);
      ie(V, () => t.afterOptionsSnippet), O(ut, E);
    };
    U(wt, (ut) => {
      t.afterOptionsSnippet && ut(Pt);
    });
  }
  q(() => {
    B(p, "data-option", t.optionName), B(p, "data-value", r()), B(p, "data-value-text", t.valueText ?? r() ?? ""), B(p, "data-total-options-count", d()), qt(p, 1, `${a() ? "inline-field-v2" : ""}`), B(w, "for", n()), et(x, `${t.label ?? ""}:`), et(y, t.valueText ?? ""), B(A, "id", n()), B(A, "name", t.name), qt(A, 1, `input ${c() ? "tw:!hidden" : ""}`), A.required = i(), A.disabled = s();
  }), Lh(A, r), O(e, p), Gt();
}
Xn(["change"]);
var pp = /* @__PURE__ */ j('<label><input type="checkbox" class="tw:sr-only tw:peer"/> <span class="tw:absolute tw:inset-y-0 tw:start-0 tw:m-1 tw:grid tw:size-4 tw:place-content-center tw:rounded-none tw:bg-white tw:text-black tw:transition-[inset-inline-start] tw:peer-checked:start-6 tw:peer-checked:*:first:hidden tw:*:last:hidden tw:peer-checked:*:last:block"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="tw:size-4"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"></path></svg> <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="tw:size-4"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"></path></svg></span></label>');
function Ec(e, t) {
  Kt(t, !0);
  let n = W(t, "checked", 15, !1);
  const r = t.id;
  var o = pp(), i = C(o);
  i.__change = function(...s) {
    var d;
    (d = t.onchange) == null || d.apply(this, s);
  }, q(() => {
    B(o, "for", r), qt(o, 1, `tw:group tw:relative tw:block tw:h-6 tw:w-12 tw:rounded-none tw:bg-gray-400 tw:transition-colors tw:[-webkit-tap-highlight-color:_transparent] tw:has-checked:bg-black tw:cursor-pointer ${t.class || ""}`), B(i, "id", r), i.disabled = t.disabled;
  }), Dh(i, n), O(e, o), Gt();
}
Xn(["change"]);
function vp(e) {
  return typeof e == "function";
}
function ss(e) {
  return e !== null && typeof e == "object";
}
const gp = ["string", "number", "bigint", "boolean"];
function Ha(e) {
  return e == null || gp.includes(typeof e) ? !0 : Array.isArray(e) ? e.every((t) => Ha(t)) : typeof e == "object" ? Object.getPrototypeOf(e) === Object.prototype : !1;
}
const ii = Symbol("box"), Il = Symbol("is-writable");
function mp(e) {
  return ss(e) && ii in e;
}
function _p(e) {
  return H.isBox(e) && Il in e;
}
function H(e) {
  let t = /* @__PURE__ */ ct(Xt(e));
  return {
    [ii]: !0,
    [Il]: !0,
    get current() {
      return l(t);
    },
    set current(n) {
      z(t, n, !0);
    }
  };
}
function wp(e, t) {
  const n = /* @__PURE__ */ L(e);
  return t ? {
    [ii]: !0,
    [Il]: !0,
    get current() {
      return l(n);
    },
    set current(r) {
      t(r);
    }
  } : {
    [ii]: !0,
    get current() {
      return e();
    }
  };
}
function bp(e) {
  return H.isBox(e) ? e : vp(e) ? H.with(e) : H(e);
}
function yp(e) {
  return Object.entries(e).reduce(
    (t, [n, r]) => H.isBox(r) ? (H.isWritableBox(r) ? Object.defineProperty(t, n, {
      get() {
        return r.current;
      },
      set(o) {
        r.current = o;
      }
    }) : Object.defineProperty(t, n, {
      get() {
        return r.current;
      }
    }), t) : Object.assign(t, { [n]: r }),
    {}
  );
}
function xp(e) {
  return H.isWritableBox(e) ? {
    [ii]: !0,
    get current() {
      return e.current;
    }
  } : e;
}
H.from = bp;
H.with = wp;
H.flatten = yp;
H.readonly = xp;
H.isBox = mp;
H.isWritableBox = _p;
function rd(...e) {
  return function(t) {
    var n;
    for (const r of e)
      if (r) {
        if (t.defaultPrevented)
          return;
        typeof r == "function" ? r.call(this, t) : (n = r.current) == null || n.call(this, t);
      }
  };
}
var Oc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Sp(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var od = {}, Tc = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, Cp = /\n/g, Ap = /^\s*/, kp = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, Ep = /^:\s*/, Op = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, Tp = /^[;\s]*/, Pp = /^\s+|\s+$/g, Ip = `
`, Pc = "/", Ic = "*", jr = "", Np = "comment", Rp = "declaration", Fp = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  t = t || {};
  var n = 1, r = 1;
  function o(w) {
    var x = w.match(Cp);
    x && (n += x.length);
    var k = w.lastIndexOf(Ip);
    r = ~k ? w.length - k : r + w.length;
  }
  function i() {
    var w = { line: n, column: r };
    return function(x) {
      return x.position = new s(w), c(), x;
    };
  }
  function s(w) {
    this.start = w, this.end = { line: n, column: r }, this.source = t.source;
  }
  s.prototype.content = e;
  function d(w) {
    var x = new Error(
      t.source + ":" + n + ":" + r + ": " + w
    );
    if (x.reason = w, x.filename = t.source, x.line = n, x.column = r, x.source = e, !t.silent) throw x;
  }
  function a(w) {
    var x = w.exec(e);
    if (x) {
      var k = x[0];
      return o(k), e = e.slice(k.length), x;
    }
  }
  function c() {
    a(Ap);
  }
  function g(w) {
    var x;
    for (w = w || []; x = h(); )
      x !== !1 && w.push(x);
    return w;
  }
  function h() {
    var w = i();
    if (!(Pc != e.charAt(0) || Ic != e.charAt(1))) {
      for (var x = 2; jr != e.charAt(x) && (Ic != e.charAt(x) || Pc != e.charAt(x + 1)); )
        ++x;
      if (x += 2, jr === e.charAt(x - 1))
        return d("End of comment missing");
      var k = e.slice(2, x - 2);
      return r += 2, o(k), e = e.slice(x), r += 2, w({
        type: Np,
        comment: k
      });
    }
  }
  function p() {
    var w = i(), x = a(kp);
    if (x) {
      if (h(), !a(Ep)) return d("property missing ':'");
      var k = a(Op), y = w({
        type: Rp,
        property: Nc(x[0].replace(Tc, jr)),
        value: k ? Nc(k[0].replace(Tc, jr)) : jr
      });
      return a(Tp), y;
    }
  }
  function _() {
    var w = [];
    g(w);
    for (var x; x = p(); )
      x !== !1 && (w.push(x), g(w));
    return w;
  }
  return c(), _();
};
function Nc(e) {
  return e ? e.replace(Pp, jr) : jr;
}
var Lp = Oc && Oc.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(od, "__esModule", { value: !0 });
var Rc = od.default = zp, Mp = Lp(Fp);
function zp(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  var r = (0, Mp.default)(e), o = typeof t == "function";
  return r.forEach(function(i) {
    if (i.type === "declaration") {
      var s = i.property, d = i.value;
      o ? t(s, d, i) : d && (n = n || {}, n[s] = d);
    }
  }), n;
}
const Dp = Rc.default || Rc, Bp = /\d/, Vp = ["-", "_", "/", "."];
function jp(e = "") {
  if (!Bp.test(e))
    return e !== e.toLowerCase();
}
function Wp(e) {
  const t = [];
  let n = "", r, o;
  for (const i of e) {
    const s = Vp.includes(i);
    if (s === !0) {
      t.push(n), n = "", r = void 0;
      continue;
    }
    const d = jp(i);
    if (o === !1) {
      if (r === !1 && d === !0) {
        t.push(n), n = i, r = d;
        continue;
      }
      if (r === !0 && d === !1 && n.length > 1) {
        const a = n.at(-1);
        t.push(n.slice(0, Math.max(0, n.length - 1))), n = a + i, r = d;
        continue;
      }
    }
    n += i, r = d, o = s;
  }
  return t.push(n), t;
}
function id(e) {
  return e ? Wp(e).map((t) => qp(t)).join("") : "";
}
function Up(e) {
  return Kp(id(e || ""));
}
function qp(e) {
  return e ? e[0].toUpperCase() + e.slice(1) : "";
}
function Kp(e) {
  return e ? e[0].toLowerCase() + e.slice(1) : "";
}
function Xo(e) {
  if (!e)
    return {};
  const t = {};
  function n(r, o) {
    if (r.startsWith("-moz-") || r.startsWith("-webkit-") || r.startsWith("-ms-") || r.startsWith("-o-")) {
      t[id(r)] = o;
      return;
    }
    if (r.startsWith("--")) {
      t[r] = o;
      return;
    }
    t[Up(r)] = o;
  }
  return Dp(e, n), t;
}
function uo(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
function Gp(e, t) {
  const n = RegExp(e, "g");
  return (r) => {
    if (typeof r != "string")
      throw new TypeError(`expected an argument of type string, but got ${typeof r}`);
    return r.match(n) ? r.replace(n, t) : r;
  };
}
const Hp = Gp(/[A-Z]/, (e) => `-${e.toLowerCase()}`);
function Yp(e) {
  if (!e || typeof e != "object" || Array.isArray(e))
    throw new TypeError(`expected an argument of type object, but got ${typeof e}`);
  return Object.keys(e).map((t) => `${Hp(t)}: ${e[t]};`).join(`
`);
}
function Nl(e = {}) {
  return Yp(e).replace(`
`, " ");
}
const Xp = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  borderWidth: "0",
  transform: "translateX(-100%)"
};
Nl(Xp);
const Zp = [
  "onabort",
  "onanimationcancel",
  "onanimationend",
  "onanimationiteration",
  "onanimationstart",
  "onauxclick",
  "onbeforeinput",
  "onbeforetoggle",
  "onblur",
  "oncancel",
  "oncanplay",
  "oncanplaythrough",
  "onchange",
  "onclick",
  "onclose",
  "oncompositionend",
  "oncompositionstart",
  "oncompositionupdate",
  "oncontextlost",
  "oncontextmenu",
  "oncontextrestored",
  "oncopy",
  "oncuechange",
  "oncut",
  "ondblclick",
  "ondrag",
  "ondragend",
  "ondragenter",
  "ondragleave",
  "ondragover",
  "ondragstart",
  "ondrop",
  "ondurationchange",
  "onemptied",
  "onended",
  "onerror",
  "onfocus",
  "onfocusin",
  "onfocusout",
  "onformdata",
  "ongotpointercapture",
  "oninput",
  "oninvalid",
  "onkeydown",
  "onkeypress",
  "onkeyup",
  "onload",
  "onloadeddata",
  "onloadedmetadata",
  "onloadstart",
  "onlostpointercapture",
  "onmousedown",
  "onmouseenter",
  "onmouseleave",
  "onmousemove",
  "onmouseout",
  "onmouseover",
  "onmouseup",
  "onpaste",
  "onpause",
  "onplay",
  "onplaying",
  "onpointercancel",
  "onpointerdown",
  "onpointerenter",
  "onpointerleave",
  "onpointermove",
  "onpointerout",
  "onpointerover",
  "onpointerup",
  "onprogress",
  "onratechange",
  "onreset",
  "onresize",
  "onscroll",
  "onscrollend",
  "onsecuritypolicyviolation",
  "onseeked",
  "onseeking",
  "onselect",
  "onselectionchange",
  "onselectstart",
  "onslotchange",
  "onstalled",
  "onsubmit",
  "onsuspend",
  "ontimeupdate",
  "ontoggle",
  "ontouchcancel",
  "ontouchend",
  "ontouchmove",
  "ontouchstart",
  "ontransitioncancel",
  "ontransitionend",
  "ontransitionrun",
  "ontransitionstart",
  "onvolumechange",
  "onwaiting",
  "onwebkitanimationend",
  "onwebkitanimationiteration",
  "onwebkitanimationstart",
  "onwebkittransitionend",
  "onwheel"
], Jp = new Set(Zp);
function Qp(e) {
  return Jp.has(e);
}
function Er(...e) {
  const t = { ...e[0] };
  for (let n = 1; n < e.length; n++) {
    const r = e[n];
    if (r) {
      for (const o of Object.keys(r)) {
        const i = t[o], s = r[o], d = typeof i == "function", a = typeof s == "function";
        if (d && Qp(o)) {
          const c = i, g = s;
          t[o] = rd(c, g);
        } else if (d && a)
          t[o] = uo(i, s);
        else if (o === "class") {
          const c = Ha(i), g = Ha(s);
          c && g ? t[o] = Qo(i, s) : c ? t[o] = Qo(i) : g && (t[o] = Qo(s));
        } else if (o === "style") {
          const c = typeof i == "object", g = typeof s == "object", h = typeof i == "string", p = typeof s == "string";
          if (c && g)
            t[o] = { ...i, ...s };
          else if (c && p) {
            const _ = Xo(s);
            t[o] = { ...i, ..._ };
          } else if (h && g) {
            const _ = Xo(i);
            t[o] = { ..._, ...s };
          } else if (h && p) {
            const _ = Xo(i), w = Xo(s);
            t[o] = { ..._, ...w };
          } else c ? t[o] = i : g ? t[o] = s : h ? t[o] = i : p && (t[o] = s);
        } else
          t[o] = s !== void 0 ? s : i;
      }
      for (const o of Object.getOwnPropertySymbols(r)) {
        const i = t[o], s = r[o];
        t[o] = s !== void 0 ? s : i;
      }
    }
  }
  return typeof t.style == "object" && (t.style = Nl(t.style).replaceAll(`
`, " ")), t.hidden !== !0 && (t.hidden = void 0, delete t.hidden), t.disabled !== !0 && (t.disabled = void 0, delete t.disabled), t;
}
const sd = typeof window < "u" ? window : void 0;
function $p(e) {
  let t = e.activeElement;
  for (; t != null && t.shadowRoot; ) {
    const n = t.shadowRoot.activeElement;
    if (n === t)
      break;
    t = n;
  }
  return t;
}
function so(e) {
  z(e, e.v + 1);
}
var Bn, Vn, nr, go, xs;
const Yl = class Yl extends Map {
  /**
   * @param {Iterable<readonly [K, V]> | null | undefined} [value]
   */
  constructor(n) {
    super();
    N(this, go);
    /** @type {Map<K, Source<number>>} */
    N(this, Bn, /* @__PURE__ */ new Map());
    N(this, Vn, Tn(0));
    N(this, nr, Tn(0));
    if (n) {
      for (var [r, o] of n)
        super.set(r, o);
      f(this, nr).v = super.size;
    }
  }
  /** @param {K} key */
  has(n) {
    var r = f(this, Bn), o = r.get(n);
    if (o === void 0) {
      var i = super.get(n);
      if (i !== void 0)
        o = Tn(0), r.set(n, o);
      else
        return l(f(this, Vn)), !1;
    }
    return l(o), !0;
  }
  /**
   * @param {(value: V, key: K, map: Map<K, V>) => void} callbackfn
   * @param {any} [this_arg]
   */
  forEach(n, r) {
    ce(this, go, xs).call(this), super.forEach(n, r);
  }
  /** @param {K} key */
  get(n) {
    var r = f(this, Bn), o = r.get(n);
    if (o === void 0) {
      var i = super.get(n);
      if (i !== void 0)
        o = Tn(0), r.set(n, o);
      else {
        l(f(this, Vn));
        return;
      }
    }
    return l(o), super.get(n);
  }
  /**
   * @param {K} key
   * @param {V} value
   * */
  set(n, r) {
    var h;
    var o = f(this, Bn), i = o.get(n), s = super.get(n), d = super.set(n, r), a = f(this, Vn);
    if (i === void 0)
      o.set(n, Tn(0)), z(f(this, nr), super.size), so(a);
    else if (s !== r) {
      so(i);
      var c = a.reactions === null ? null : new Set(a.reactions), g = c === null || !((h = i.reactions) != null && h.every(
        (p) => (
          /** @type {NonNullable<typeof v_reactions>} */
          c.has(p)
        )
      ));
      g && so(a);
    }
    return d;
  }
  /** @param {K} key */
  delete(n) {
    var r = f(this, Bn), o = r.get(n), i = super.delete(n);
    return o !== void 0 && (r.delete(n), z(f(this, nr), super.size), z(o, -1), so(f(this, Vn))), i;
  }
  clear() {
    if (super.size !== 0) {
      super.clear();
      var n = f(this, Bn);
      z(f(this, nr), 0);
      for (var r of n.values())
        z(r, -1);
      so(f(this, Vn)), n.clear();
    }
  }
  keys() {
    return l(f(this, Vn)), super.keys();
  }
  values() {
    return ce(this, go, xs).call(this), super.values();
  }
  entries() {
    return ce(this, go, xs).call(this), super.entries();
  }
  [Symbol.iterator]() {
    return this.entries();
  }
  get size() {
    return l(f(this, nr)), super.size;
  }
};
Bn = new WeakMap(), Vn = new WeakMap(), nr = new WeakMap(), go = new WeakSet(), xs = function() {
  l(f(this, Vn));
  var n = f(this, Bn);
  if (f(this, nr).v !== n.size)
    for (var r of ac(Yl.prototype, this, "keys").call(this))
      n.has(r) || n.set(r, Tn(0));
  for (var [, o] of f(this, Bn))
    l(o);
};
let Ya = Yl;
function ad(e) {
  let t = 0, n = Tn(0), r;
  return () => {
    eh() && (l(n), ns(() => (t === 0 && (r = oe(() => e(() => so(n)))), t += 1, () => {
      lo().then(() => {
        t -= 1, t === 0 && (r == null || r(), r = void 0);
      });
    })));
  };
}
var mo, ci;
class tv {
  constructor(t = {}) {
    N(this, mo);
    N(this, ci);
    const {
      window: n = sd,
      document: r = n == null ? void 0 : n.document
    } = t;
    n !== void 0 && (vt(this, mo, r), vt(this, ci, ad((o) => {
      const i = yn(n, "focusin", o), s = yn(n, "focusout", o);
      return () => {
        i(), s();
      };
    })));
  }
  get current() {
    var t;
    return (t = f(this, ci)) == null || t.call(this), f(this, mo) ? $p(f(this, mo)) : null;
  }
}
mo = new WeakMap(), ci = new WeakMap();
new tv();
function ev(e) {
  return typeof e == "function";
}
var ui, rr;
class as {
  /**
   * @param name The name of the context.
   * This is used for generating the context key and error messages.
   */
  constructor(t) {
    N(this, ui);
    N(this, rr);
    vt(this, ui, t), vt(this, rr, Symbol(t));
  }
  /**
   * The key used to get and set the context.
   *
   * It is not recommended to use this value directly.
   * Instead, use the methods provided by this class.
   */
  get key() {
    return f(this, rr);
  }
  /**
   * Checks whether this has been set in the context of a parent component.
   *
   * Must be called during component initialisation.
   */
  exists() {
    return Kf(f(this, rr));
  }
  /**
   * Retrieves the context that belongs to the closest parent component.
   *
   * Must be called during component initialisation.
   *
   * @throws An error if the context does not exist.
   */
  get() {
    const t = uc(f(this, rr));
    if (t === void 0)
      throw new Error(`Context "${f(this, ui)}" not found`);
    return t;
  }
  /**
   * Retrieves the context that belongs to the closest parent component,
   * or the given fallback value if the context does not exist.
   *
   * Must be called during component initialisation.
   */
  getOr(t) {
    const n = uc(f(this, rr));
    return n === void 0 ? t : n;
  }
  /**
   * Associates the given value with the current component and returns it.
   *
   * Must be called during component initialisation.
   */
  set(t) {
    return qf(f(this, rr), t);
  }
}
ui = new WeakMap(), rr = new WeakMap();
function nv(e, t) {
  switch (e) {
    case "post":
      Ie(t);
      break;
    case "pre":
      _n(t);
      break;
  }
}
function ld(e, t, n, r = {}) {
  const { lazy: o = !1 } = r;
  let i = !o, s = Array.isArray(e) ? [] : void 0;
  nv(t, () => {
    const d = Array.isArray(e) ? e.map((c) => c()) : e();
    if (!i) {
      i = !0, s = d;
      return;
    }
    const a = oe(() => n(d, s));
    return s = d, a;
  });
}
function gn(e, t, n) {
  ld(e, "post", t, n);
}
function rv(e, t, n) {
  ld(e, "pre", t, n);
}
gn.pre = rv;
function Fc(e) {
  return ev(e) ? e() : e;
}
var gr, _o, wo, bo, mr, Us, qs, yo;
class ov {
  constructor(t, n = { box: "border-box" }) {
    // no need to use `$state` here since we are using createSubscriber
    N(this, gr, { width: 0, height: 0 });
    N(this, _o, !1);
    N(this, wo);
    N(this, bo);
    N(this, mr);
    // we use a derived here to extract the width so that if the width doesn't change we don't get a state update
    // which we would get if we would just use a getter since the version of the subscriber will be changing
    N(this, Us, /* @__PURE__ */ L(() => {
      var t;
      return (t = l(f(this, yo))) == null || t(), this.getSize().width;
    }));
    // we use a derived here to extract the height so that if the height doesn't change we don't get a state update
    // which we would get if we would just use a getter since the version of the subscriber will be changing
    N(this, qs, /* @__PURE__ */ L(() => {
      var t;
      return (t = l(f(this, yo))) == null || t(), this.getSize().height;
    }));
    // we need to use a derived here because the class will be created before the node is bound to the ref
    N(this, yo, /* @__PURE__ */ L(() => {
      const t = Fc(f(this, bo));
      if (t)
        return ad((n) => {
          if (!f(this, mr)) return;
          const r = new (f(this, mr)).ResizeObserver((o) => {
            vt(this, _o, !0);
            for (const i of o) {
              const s = f(this, wo).box === "content-box" ? i.contentBoxSize : i.borderBoxSize, d = Array.isArray(s) ? s : [s];
              f(this, gr).width = d.reduce((a, c) => Math.max(a, c.inlineSize), 0), f(this, gr).height = d.reduce((a, c) => Math.max(a, c.blockSize), 0);
            }
            n();
          });
          return r.observe(t), () => {
            vt(this, _o, !1), r.disconnect();
          };
        });
    }));
    vt(this, mr, n.window ?? sd), vt(this, wo, n), vt(this, bo, t), vt(this, gr, { width: 0, height: 0 });
  }
  calculateSize() {
    const t = Fc(f(this, bo));
    if (!t || !f(this, mr))
      return;
    const n = t.offsetWidth, r = t.offsetHeight;
    if (f(this, wo).box === "border-box")
      return { width: n, height: r };
    const o = f(this, mr).getComputedStyle(t), i = parseFloat(o.paddingLeft) + parseFloat(o.paddingRight), s = parseFloat(o.paddingTop) + parseFloat(o.paddingBottom), d = parseFloat(o.borderLeftWidth) + parseFloat(o.borderRightWidth), a = parseFloat(o.borderTopWidth) + parseFloat(o.borderBottomWidth), c = n - i - d, g = r - s - a;
    return { width: c, height: g };
  }
  getSize() {
    return f(this, _o) ? f(this, gr) : this.calculateSize() ?? f(this, gr);
  }
  get current() {
    var t;
    return (t = l(f(this, yo))) == null || t(), this.getSize();
  }
  get width() {
    return l(f(this, Us));
  }
  get height() {
    return l(f(this, qs));
  }
}
gr = new WeakMap(), _o = new WeakMap(), wo = new WeakMap(), bo = new WeakMap(), mr = new WeakMap(), Us = new WeakMap(), qs = new WeakMap(), yo = new WeakMap();
var xo;
class iv {
  constructor(t, n) {
    N(this, xo, /* @__PURE__ */ ct(void 0));
    n !== void 0 && z(f(this, xo), n, !0), gn(() => t(), (r, o) => {
      z(f(this, xo), o, !0);
    });
  }
  get current() {
    return l(f(this, xo));
  }
}
xo = new WeakMap();
function ls(e) {
  Ie(() => () => {
    e();
  });
}
function cd(e, t) {
  return setTimeout(t, e);
}
function Rl(e) {
  lo().then(e);
}
const sv = 1, av = 9, lv = 11;
function Xa(e) {
  return ss(e) && e.nodeType === sv && typeof e.nodeName == "string";
}
function ud(e) {
  return ss(e) && e.nodeType === av;
}
function cv(e) {
  var t;
  return ss(e) && ((t = e.constructor) == null ? void 0 : t.name) === "VisualViewport";
}
function uv(e) {
  return ss(e) && e.nodeType !== void 0;
}
function dd(e) {
  return uv(e) && e.nodeType === lv && "host" in e;
}
function dv(e, t) {
  var r;
  if (!e || !t || !Xa(e) || !Xa(t))
    return !1;
  const n = (r = t.getRootNode) == null ? void 0 : r.call(t);
  if (e === t || e.contains(t))
    return !0;
  if (n && dd(n)) {
    let o = t;
    for (; o; ) {
      if (e === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function fv(e) {
  return ud(e) ? e : cv(e) ? e.document : (e == null ? void 0 : e.ownerDocument) ?? document;
}
function fd(e) {
  var t;
  return dd(e) ? fd(e.host) : ud(e) ? e.defaultView ?? window : Xa(e) ? ((t = e.ownerDocument) == null ? void 0 : t.defaultView) ?? window : window;
}
function hv(e) {
  let t = e.activeElement;
  for (; t != null && t.shadowRoot; ) {
    const n = t.shadowRoot.activeElement;
    if (n === t)
      break;
    t = n;
  }
  return t;
}
var di;
class hd {
  constructor(t) {
    it(this, "element");
    N(this, di, /* @__PURE__ */ L(() => this.element.current ? this.element.current.getRootNode() ?? document : document));
    it(this, "getDocument", () => fv(this.root));
    it(this, "getWindow", () => this.getDocument().defaultView ?? window);
    it(this, "getActiveElement", () => hv(this.root));
    it(this, "isActiveElement", (t) => t === this.getActiveElement());
    it(this, "querySelector", (t) => this.root ? this.root.querySelector(t) : null);
    it(this, "querySelectorAll", (t) => this.root ? this.root.querySelectorAll(t) : []);
    it(this, "setTimeout", (t, n) => this.getWindow().setTimeout(t, n));
    it(this, "clearTimeout", (t) => this.getWindow().clearTimeout(t));
    typeof t == "function" ? this.element = H.with(t) : this.element = t;
  }
  get root() {
    return l(f(this, di));
  }
  set root(t) {
    z(f(this, di), t);
  }
  getElementById(t) {
    return this.root.getElementById(t);
  }
}
di = new WeakMap();
function ti(e, t) {
  return {
    [vh()]: (n) => H.isBox(e) ? (e.current = n, oe(() => t == null ? void 0 : t(n)), () => {
      "isConnected" in n && n.isConnected || (e.current = null, t == null || t(null));
    }) : (e(n), oe(() => t == null ? void 0 : t(n)), () => {
      "isConnected" in n && n.isConnected || (e(null), t == null || t(null));
    })
  };
}
function pd(e) {
  return e ? "open" : "closed";
}
function pv(e) {
  return e ? "true" : "false";
}
var So, fi;
class vv {
  constructor(t) {
    N(this, So);
    N(this, fi);
    it(this, "attrs");
    vt(this, So, t.getVariant ? t.getVariant() : null), vt(this, fi, f(this, So) ? `data-${f(this, So)}-` : `data-${t.component}-`), this.getAttr = this.getAttr.bind(this), this.selector = this.selector.bind(this), this.attrs = Object.fromEntries(t.parts.map((n) => [n, this.getAttr(n)]));
  }
  getAttr(t, n) {
    return n ? `data-${n}-${t}` : `${f(this, fi)}${t}`;
  }
  selector(t, n) {
    return `[${this.getAttr(t, n)}]`;
  }
}
So = new WeakMap(), fi = new WeakMap();
function gv(e) {
  const t = new vv(e);
  return {
    ...t.attrs,
    selector: t.selector,
    getAttr: t.getAttr
  };
}
const mv = "Enter", _v = "Escape", wv = " ";
function Xe() {
}
function vd(e, t) {
  return `bits-${e}`;
}
var hi, Ks, gd;
class bv {
  constructor(t, n) {
    N(this, Ks);
    it(this, "state");
    N(this, hi);
    this.state = H(t), vt(this, hi, n), this.dispatch = this.dispatch.bind(this);
  }
  dispatch(t) {
    this.state.current = ce(this, Ks, gd).call(this, t);
  }
}
hi = new WeakMap(), Ks = new WeakSet(), gd = function(t) {
  return f(this, hi)[this.state.current][t] ?? this.state.current;
};
const yv = {
  mounted: {
    UNMOUNT: "unmounted",
    ANIMATION_OUT: "unmountSuspended"
  },
  unmountSuspended: { MOUNT: "mounted", ANIMATION_END: "unmounted" },
  unmounted: { MOUNT: "mounted" }
};
var pi, vi, gi;
class xv {
  constructor(t) {
    it(this, "opts");
    N(this, pi, /* @__PURE__ */ ct("none"));
    N(this, vi, /* @__PURE__ */ ct(Xt({})));
    it(this, "initialStatus");
    it(this, "previousPresent");
    it(this, "machine");
    it(this, "present");
    N(this, gi, /* @__PURE__ */ L(() => ["mounted", "unmountSuspended"].includes(this.machine.state.current)));
    this.opts = t, this.present = this.opts.open, this.initialStatus = t.open.current ? "mounted" : "unmounted", this.previousPresent = new iv(() => this.present.current), this.machine = new bv(this.initialStatus, yv), this.handleAnimationEnd = this.handleAnimationEnd.bind(this), this.handleAnimationStart = this.handleAnimationStart.bind(this), Sv(this), Cv(this), Av(this);
  }
  get prevAnimationNameState() {
    return l(f(this, pi));
  }
  set prevAnimationNameState(t) {
    z(f(this, pi), t, !0);
  }
  get styles() {
    return l(f(this, vi));
  }
  set styles(t) {
    z(f(this, vi), t, !0);
  }
  /**
   * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
   * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
   * make sure we only trigger ANIMATION_END for the currently active animation.
   */
  handleAnimationEnd(t) {
    if (!this.opts.ref.current) return;
    const n = Ns(this.opts.ref.current), r = n.includes(t.animationName) || n === "none";
    t.target === this.opts.ref.current && r && this.machine.dispatch("ANIMATION_END");
  }
  handleAnimationStart(t) {
    this.opts.ref.current && t.target === this.opts.ref.current && (this.prevAnimationNameState = Ns(this.opts.ref.current));
  }
  get isPresent() {
    return l(f(this, gi));
  }
  set isPresent(t) {
    z(f(this, gi), t);
  }
}
pi = new WeakMap(), vi = new WeakMap(), gi = new WeakMap();
function Sv(e) {
  gn(() => e.present.current, () => {
    if (!e.opts.ref.current || !(e.present.current !== e.previousPresent.current)) return;
    const n = e.prevAnimationNameState, r = Ns(e.opts.ref.current);
    if (e.present.current)
      e.machine.dispatch("MOUNT");
    else if (r === "none" || e.styles.display === "none")
      e.machine.dispatch("UNMOUNT");
    else {
      const o = n !== r;
      e.previousPresent.current && o ? e.machine.dispatch("ANIMATION_OUT") : e.machine.dispatch("UNMOUNT");
    }
  });
}
function Cv(e) {
  gn(() => e.machine.state.current, () => {
    if (!e.opts.ref.current) return;
    const t = Ns(e.opts.ref.current);
    e.prevAnimationNameState = e.machine.state.current === "mounted" ? t : "none";
  });
}
function Av(e) {
  gn(() => e.opts.ref.current, () => {
    if (e.opts.ref.current)
      return e.styles = getComputedStyle(e.opts.ref.current), uo(yn(e.opts.ref.current, "animationstart", e.handleAnimationStart), yn(e.opts.ref.current, "animationcancel", e.handleAnimationEnd), yn(e.opts.ref.current, "animationend", e.handleAnimationEnd));
  });
}
function Ns(e) {
  return e && getComputedStyle(e).animationName || "none";
}
function kv(e, t) {
  Kt(t, !0);
  const n = new xv({
    open: H.with(() => t.open),
    ref: t.ref
  });
  var r = _t(), o = rt(r);
  {
    var i = (s) => {
      var d = _t(), a = rt(d);
      ie(a, () => t.presence ?? Re, () => ({ present: n.isPresent })), O(s, d);
    };
    U(o, (s) => {
      (t.forceMount || t.open || n.isPresent) && s(i);
    });
  }
  O(e, r), Gt();
}
var Co, qr, _r, lr, Za, Ss;
class Ev {
  constructor(t) {
    N(this, lr);
    N(this, Co);
    N(this, qr);
    N(this, _r, !1);
    vt(this, Co, t), ls(() => ce(this, lr, Za).call(this));
  }
  run(t) {
    if (f(this, _r))
      return;
    ce(this, lr, Za).call(this), vt(this, _r, !0);
    const n = f(this, Co).ref.current;
    if (!n) {
      vt(this, _r, !1);
      return;
    }
    if (typeof n.getAnimations != "function") {
      ce(this, lr, Ss).call(this, t);
      return;
    }
    vt(this, qr, window.requestAnimationFrame(() => {
      const r = n.getAnimations();
      if (r.length === 0) {
        ce(this, lr, Ss).call(this, t);
        return;
      }
      Promise.allSettled(r.map((o) => o.finished)).then(() => {
        ce(this, lr, Ss).call(this, t);
      });
    }));
  }
}
Co = new WeakMap(), qr = new WeakMap(), _r = new WeakMap(), lr = new WeakSet(), Za = function() {
  f(this, qr) && (window.cancelAnimationFrame(f(this, qr)), vt(this, qr, void 0)), vt(this, _r, !1);
}, Ss = function(t) {
  const n = () => {
    t(), vt(this, _r, !1);
  };
  f(this, Co).afterTick ? Rl(n) : n();
};
var or, mi, _i;
class Ov {
  constructor(t) {
    N(this, or);
    N(this, mi);
    N(this, _i);
    vt(this, or, t), vt(this, mi, t.enabled ?? !0), vt(this, _i, new Ev({
      ref: f(this, or).ref,
      afterTick: f(this, or).open
    })), gn([() => f(this, or).open.current], ([n]) => {
      f(this, mi) && f(this, _i).run(() => {
        n === f(this, or).open.current && f(this, or).onComplete();
      });
    });
  }
}
or = new WeakMap(), mi = new WeakMap(), _i = new WeakMap();
function Tv(e, t) {
  var n = _t(), r = rt(n);
  Eh(r, () => t.children, (o) => {
    var i = _t(), s = rt(i);
    ie(s, () => t.children ?? Re), O(o, i);
  }), O(e, n);
}
const Fl = typeof document < "u", Lc = Pv();
function Pv() {
  var e, t;
  return Fl && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || // The new iPad Pro Gen3 does not identify itself as iPad, but as Macintosh.
  ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Mc(e) {
  return e instanceof HTMLElement;
}
function md(e) {
  return e instanceof Element;
}
function Iv(e) {
  return e !== null;
}
const Nv = new as("BitsConfig");
function Rv() {
  const e = new Fv(null, {});
  return Nv.getOr(e).opts;
}
class Fv {
  constructor(t, n) {
    it(this, "opts");
    const r = Lv(t, n);
    this.opts = {
      defaultPortalTo: r((o) => o.defaultPortalTo),
      defaultLocale: r((o) => o.defaultLocale)
    };
  }
}
function Lv(e, t) {
  return (n) => H.with(() => {
    var i, s;
    const o = (i = n(t)) == null ? void 0 : i.current;
    if (o !== void 0)
      return o;
    if (e !== null)
      return (s = n(e.opts)) == null ? void 0 : s.current;
  });
}
function Mv(e, t) {
  return (n) => {
    const r = Rv();
    return H.with(() => {
      const o = n();
      if (o !== void 0)
        return o;
      const i = e(r).current;
      return i !== void 0 ? i : t;
    });
  };
}
const zv = Mv((e) => e.defaultPortalTo, "body");
function Dv(e, t) {
  Kt(t, !0);
  const n = zv(() => t.to), r = Gf();
  let o = /* @__PURE__ */ L(i);
  function i() {
    if (!Fl || t.disabled) return null;
    let h = null;
    return typeof n.current == "string" ? h = document.querySelector(n.current) : h = n.current, h;
  }
  let s;
  function d() {
    s && (kh(s), s = null);
  }
  gn(
    [
      () => l(o),
      () => t.disabled
    ],
    ([h, p]) => {
      if (!h || p) {
        d();
        return;
      }
      return s = Yu(Tv, {
        target: h,
        props: { children: t.children },
        context: r
      }), () => {
        d();
      };
    }
  );
  var a = _t(), c = rt(a);
  {
    var g = (h) => {
      var p = _t(), _ = rt(p);
      ie(_, () => t.children ?? Re), O(h, p);
    };
    U(c, (h) => {
      t.disabled && h(g);
    });
  }
  O(e, a), Gt();
}
function _d(e, t, n, r) {
  const o = Array.isArray(t) ? t : [t];
  return o.forEach((i) => e.addEventListener(i, n, r)), () => {
    o.forEach((i) => e.removeEventListener(i, n, r));
  };
}
function zc(e, t = 500) {
  let n = null;
  const r = (...o) => {
    n !== null && clearTimeout(n), n = setTimeout(() => {
      e(...o);
    }, t);
  };
  return r.destroy = () => {
    n !== null && (clearTimeout(n), n = null);
  }, r;
}
function wd(e, t) {
  return e === t || e.contains(t);
}
function bd(e) {
  return (e == null ? void 0 : e.ownerDocument) ?? document;
}
function Bv(e, t) {
  const { clientX: n, clientY: r } = e, o = t.getBoundingClientRect();
  return n < o.left || n > o.right || r < o.top || r > o.bottom;
}
globalThis.bitsDismissableLayers ?? (globalThis.bitsDismissableLayers = /* @__PURE__ */ new Map());
var Ao, Kr, wr, ko, Eo, br, wi, ir, Gs, Lo, yd, Hs, Oo, Ys, Xs, Zs, Js, bi, xd, Qs, $s;
const Xl = class Xl {
  constructor(t) {
    N(this, Lo);
    it(this, "opts");
    N(this, Ao);
    N(this, Kr);
    N(this, wr, { pointerdown: !1 });
    N(this, ko, !1);
    N(this, Eo, !1);
    N(this, br);
    N(this, wi);
    N(this, ir, Xe);
    N(this, Gs, (t) => {
      t.defaultPrevented || this.opts.ref.current && Rl(() => {
        var n, r;
        !this.opts.ref.current || f(this, Js).call(this, t.target) || t.target && !f(this, Eo) && ((r = (n = f(this, wi)).current) == null || r.call(n, t));
      });
    });
    N(this, Hs, (t) => {
      let n = t;
      n.defaultPrevented && (n = Dc(t)), f(this, Ao).current(t);
    });
    N(this, Oo, zc(
      (t) => {
        if (!this.opts.ref.current) {
          f(this, ir).call(this);
          return;
        }
        const n = this.opts.isValidEvent.current(t, this.opts.ref.current) || Wv(t, this.opts.ref.current);
        if (!f(this, ko) || ce(this, Lo, xd).call(this) || !n) {
          f(this, ir).call(this);
          return;
        }
        let r = t;
        if (r.defaultPrevented && (r = Dc(r)), f(this, Kr).current !== "close" && f(this, Kr).current !== "defer-otherwise-close") {
          f(this, ir).call(this);
          return;
        }
        t.pointerType === "touch" ? (f(this, ir).call(this), vt(this, ir, _d(f(this, br), "click", f(this, Hs), { once: !0 }))) : f(this, Ao).current(r);
      },
      10
    ));
    N(this, Ys, (t) => {
      f(this, wr)[t.type] = !0;
    });
    N(this, Xs, (t) => {
      f(this, wr)[t.type] = !1;
    });
    N(this, Zs, () => {
      this.opts.ref.current && vt(this, ko, jv(this.opts.ref.current));
    });
    N(this, Js, (t) => this.opts.ref.current ? wd(this.opts.ref.current, t) : !1);
    N(this, bi, zc(
      () => {
        for (const t in f(this, wr))
          f(this, wr)[t] = !1;
        vt(this, ko, !1);
      },
      20
    ));
    N(this, Qs, () => {
      vt(this, Eo, !0);
    });
    N(this, $s, () => {
      vt(this, Eo, !1);
    });
    it(this, "props", {
      onfocuscapture: f(this, Qs),
      onblurcapture: f(this, $s)
    });
    this.opts = t, vt(this, Kr, t.interactOutsideBehavior), vt(this, Ao, t.onInteractOutside), vt(this, wi, t.onFocusOutside), Ie(() => {
      vt(this, br, bd(this.opts.ref.current));
    });
    let n = Xe;
    const r = () => {
      f(this, bi).call(this), globalThis.bitsDismissableLayers.delete(this), f(this, Oo).destroy(), n();
    };
    gn(
      [
        () => this.opts.enabled.current,
        () => this.opts.ref.current
      ],
      () => {
        if (!(!this.opts.enabled.current || !this.opts.ref.current))
          return cd(1, () => {
            this.opts.ref.current && (globalThis.bitsDismissableLayers.set(this, f(this, Kr)), n(), n = ce(this, Lo, yd).call(this));
          }), r;
      }
    ), ls(() => {
      f(this, bi).destroy(), globalThis.bitsDismissableLayers.delete(this), f(this, Oo).destroy(), f(this, ir).call(this), n();
    });
  }
  static create(t) {
    return new Xl(t);
  }
};
Ao = new WeakMap(), Kr = new WeakMap(), wr = new WeakMap(), ko = new WeakMap(), Eo = new WeakMap(), br = new WeakMap(), wi = new WeakMap(), ir = new WeakMap(), Gs = new WeakMap(), Lo = new WeakSet(), yd = function() {
  return uo(
    /**
    * CAPTURE INTERACTION START
    * mark interaction-start event as intercepted.
    * mark responsible layer during interaction start
    * to avoid checking if is responsible layer during interaction end
    * when a new floating element may have been opened.
    */
    yn(f(this, br), "pointerdown", uo(f(this, Ys), f(this, Zs)), { capture: !0 }),
    /**
    * BUBBLE INTERACTION START
    * Mark interaction-start event as non-intercepted. Debounce `onInteractOutsideStart`
    * to avoid prematurely checking if other events were intercepted.
    */
    yn(f(this, br), "pointerdown", uo(f(this, Xs), f(this, Oo))),
    /**
    * HANDLE FOCUS OUTSIDE
    */
    yn(f(this, br), "focusin", f(this, Gs))
  );
}, Hs = new WeakMap(), Oo = new WeakMap(), Ys = new WeakMap(), Xs = new WeakMap(), Zs = new WeakMap(), Js = new WeakMap(), bi = new WeakMap(), xd = function() {
  return Object.values(f(this, wr)).some(Boolean);
}, Qs = new WeakMap(), $s = new WeakMap();
let Ja = Xl;
function Vv(e) {
  return e.findLast(([t, { current: n }]) => n === "close" || n === "ignore");
}
function jv(e) {
  const t = [...globalThis.bitsDismissableLayers], n = Vv(t);
  if (n) return n[0].opts.ref.current === e;
  const [r] = t[0];
  return r.opts.ref.current === e;
}
function Wv(e, t) {
  if ("button" in e && e.button > 0) return !1;
  const n = e.target;
  return md(n) ? bd(n).documentElement.contains(n) && !wd(t, n) && Bv(e, t) : !1;
}
function Dc(e) {
  const t = e.currentTarget, n = e.target;
  let r;
  e instanceof PointerEvent ? r = new PointerEvent(e.type, e) : r = new PointerEvent("pointerdown", e);
  let o = !1;
  return new Proxy(r, {
    get: (s, d) => d === "currentTarget" ? t : d === "target" ? n : d === "preventDefault" ? () => {
      o = !0, typeof s.preventDefault == "function" && s.preventDefault();
    } : d === "defaultPrevented" ? o : d in s ? s[d] : e[d]
  });
}
function Uv(e, t) {
  Kt(t, !0);
  let n = W(t, "interactOutsideBehavior", 3, "close"), r = W(t, "onInteractOutside", 3, Xe), o = W(t, "onFocusOutside", 3, Xe), i = W(t, "isValidEvent", 3, () => !1);
  const s = Ja.create({
    id: H.with(() => t.id),
    interactOutsideBehavior: H.with(() => n()),
    onInteractOutside: H.with(() => r()),
    enabled: H.with(() => t.enabled),
    onFocusOutside: H.with(() => o()),
    isValidEvent: H.with(() => i()),
    ref: t.ref
  });
  var d = _t(), a = rt(d);
  ie(a, () => t.children ?? Re, () => ({ props: s.props })), O(e, d), Gt();
}
globalThis.bitsEscapeLayers ?? (globalThis.bitsEscapeLayers = /* @__PURE__ */ new Map());
var ta, ea;
const Zl = class Zl {
  constructor(t) {
    it(this, "opts");
    it(this, "domContext");
    N(this, ta, () => yn(this.domContext.getDocument(), "keydown", f(this, ea), { passive: !1 }));
    N(this, ea, (t) => {
      if (t.key !== _v || !qv(this)) return;
      const n = new KeyboardEvent(t.type, t);
      t.preventDefault();
      const r = this.opts.escapeKeydownBehavior.current;
      r !== "close" && r !== "defer-otherwise-close" || this.opts.onEscapeKeydown.current(n);
    });
    this.opts = t, this.domContext = new hd(this.opts.ref);
    let n = Xe;
    gn(() => t.enabled.current, (r) => (r && (globalThis.bitsEscapeLayers.set(this, t.escapeKeydownBehavior), n = f(this, ta).call(this)), () => {
      n(), globalThis.bitsEscapeLayers.delete(this);
    }));
  }
  static create(t) {
    return new Zl(t);
  }
};
ta = new WeakMap(), ea = new WeakMap();
let Qa = Zl;
function qv(e) {
  const t = [...globalThis.bitsEscapeLayers], n = t.findLast(([o, { current: i }]) => i === "close" || i === "ignore");
  if (n) return n[0] === e;
  const [r] = t[0];
  return r === e;
}
function Kv(e, t) {
  Kt(t, !0);
  let n = W(t, "escapeKeydownBehavior", 3, "close"), r = W(t, "onEscapeKeydown", 3, Xe);
  Qa.create({
    escapeKeydownBehavior: H.with(() => n()),
    onEscapeKeydown: H.with(() => r()),
    enabled: H.with(() => t.enabled),
    ref: t.ref
  });
  var o = _t(), i = rt(o);
  ie(i, () => t.children ?? Re), O(e, o), Gt();
}
var sr, yi;
const na = class na {
  constructor() {
    N(this, sr, H([]));
    N(this, yi, /* @__PURE__ */ new WeakMap());
  }
  static getInstance() {
    return this.instance || (this.instance = new na()), this.instance;
  }
  register(t) {
    const n = this.getActive();
    n && n !== t && n.pause(), f(this, sr).current = f(this, sr).current.filter((r) => r !== t), f(this, sr).current.unshift(t);
  }
  unregister(t) {
    f(this, sr).current = f(this, sr).current.filter((r) => r !== t);
    const n = this.getActive();
    n && n.resume();
  }
  getActive() {
    return f(this, sr).current[0];
  }
  setFocusMemory(t, n) {
    f(this, yi).set(t, n);
  }
  getFocusMemory(t) {
    return f(this, yi).get(t);
  }
  isActiveScope(t) {
    return this.getActive() === t;
  }
};
sr = new WeakMap(), yi = new WeakMap(), it(na, "instance");
let $a = na;
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Sd = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], tl = /* @__PURE__ */ Sd.join(","), Cd = typeof Element > "u", Ro = Cd ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Rs = !Cd && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, Fs = function e(t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = o === "" || o === "true", s = i || n && t && e(t.parentNode);
  return s;
}, Gv = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, Ad = function(t, n, r) {
  if (Fs(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(tl));
  return n && Ro.call(t, tl) && o.unshift(t), o = o.filter(r), o;
}, kd = function e(t, n, r) {
  for (var o = [], i = Array.from(t); i.length; ) {
    var s = i.shift();
    if (!Fs(s, !1))
      if (s.tagName === "SLOT") {
        var d = s.assignedElements(), a = d.length ? d : s.children, c = e(a, !0, r);
        r.flatten ? o.push.apply(o, c) : o.push({
          scopeParent: s,
          candidates: c
        });
      } else {
        var g = Ro.call(s, tl);
        g && r.filter(s) && (n || !t.includes(s)) && o.push(s);
        var h = s.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(s), p = !Fs(h, !1) && (!r.shadowRootFilter || r.shadowRootFilter(s));
        if (h && p) {
          var _ = e(h === !0 ? s.children : h.children, !0, r);
          r.flatten ? o.push.apply(o, _) : o.push({
            scopeParent: s,
            candidates: _
          });
        } else
          i.unshift.apply(i, s.children);
      }
  }
  return o;
}, Ed = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, Od = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || Gv(t)) && !Ed(t) ? 0 : t.tabIndex;
}, Hv = function(t, n) {
  var r = Od(t);
  return r < 0 && n && !Ed(t) ? 0 : r;
}, Yv = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, Td = function(t) {
  return t.tagName === "INPUT";
}, Xv = function(t) {
  return Td(t) && t.type === "hidden";
}, Zv = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, Jv = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, Qv = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Rs(t), r = function(d) {
    return n.querySelectorAll('input[type="radio"][name="' + d + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(t.name));
  else
    try {
      o = r(t.name);
    } catch (s) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", s.message), !1;
    }
  var i = Jv(o, t.form);
  return !i || i === t;
}, $v = function(t) {
  return Td(t) && t.type === "radio";
}, tg = function(t) {
  return $v(t) && !Qv(t);
}, eg = function(t) {
  var n, r = t && Rs(t), o = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var s, d, a;
    for (i = !!((s = o) !== null && s !== void 0 && (d = s.ownerDocument) !== null && d !== void 0 && d.contains(o) || t != null && (a = t.ownerDocument) !== null && a !== void 0 && a.contains(t)); !i && o; ) {
      var c, g, h;
      r = Rs(o), o = (c = r) === null || c === void 0 ? void 0 : c.host, i = !!((g = o) !== null && g !== void 0 && (h = g.ownerDocument) !== null && h !== void 0 && h.contains(o));
    }
  }
  return i;
}, Bc = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, o = n.height;
  return r === 0 && o === 0;
}, ng = function(t, n) {
  var r = n.displayCheck, o = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var i = Ro.call(t, "details>summary:first-of-type"), s = i ? t.parentElement : t;
  if (Ro.call(s, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var d = t; t; ) {
        var a = t.parentElement, c = Rs(t);
        if (a && !a.shadowRoot && o(a) === !0)
          return Bc(t);
        t.assignedSlot ? t = t.assignedSlot : !a && c !== t.ownerDocument ? t = c.host : t = a;
      }
      t = d;
    }
    if (eg(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return Bc(t);
  return !1;
}, rg = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var o = n.children.item(r);
          if (o.tagName === "LEGEND")
            return Ro.call(n, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Ls = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Fs(n) || Xv(n) || ng(n, t) || // For a details element with a summary, the summary element gets the focus
  Zv(n) || rg(n));
}, Vc = function(t, n) {
  return !(tg(n) || Od(n) < 0 || !Ls(t, n));
}, og = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, ig = function e(t) {
  var n = [], r = [];
  return t.forEach(function(o, i) {
    var s = !!o.scopeParent, d = s ? o.scopeParent : o, a = Hv(d, s), c = s ? e(o.candidates) : d;
    a === 0 ? s ? n.push.apply(n, c) : n.push(d) : r.push({
      documentOrder: i,
      tabIndex: a,
      item: o,
      isScope: s,
      content: c
    });
  }), r.sort(Yv).reduce(function(o, i) {
    return i.isScope ? o.push.apply(o, i.content) : o.push(i.content), o;
  }, []).concat(n);
}, sg = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = kd([t], n.includeContainer, {
    filter: Vc.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: og
  }) : r = Ad(t, n.includeContainer, Vc.bind(null, n)), ig(r);
}, ag = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = kd([t], n.includeContainer, {
    filter: Ls.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = Ad(t, n.includeContainer, Ls.bind(null, n)), r;
}, lg = /* @__PURE__ */ Sd.concat("iframe").join(","), cg = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Ro.call(t, lg) === !1 ? !1 : Ls(n, t);
}, yr, en, En, Gr, xr, Ne, Pd, Id, Nd, Rd, nl, Cs, rl;
const Jl = class Jl {
  constructor(t) {
    N(this, Ne);
    N(this, yr, !1);
    N(this, en, null);
    N(this, En, $a.getInstance());
    N(this, Gr, []);
    N(this, xr);
    vt(this, xr, t);
  }
  get paused() {
    return f(this, yr);
  }
  pause() {
    vt(this, yr, !0);
  }
  resume() {
    vt(this, yr, !1);
  }
  mount(t) {
    f(this, en) && this.unmount(), vt(this, en, t), f(this, En).register(this), ce(this, Ne, Rd).call(this), ce(this, Ne, Id).call(this);
  }
  unmount() {
    f(this, en) && (ce(this, Ne, Pd).call(this), ce(this, Ne, Nd).call(this), f(this, En).unregister(this), vt(this, en, null));
  }
  static use(t) {
    let n = null;
    return gn(
      [
        () => t.ref.current,
        () => t.enabled.current
      ],
      ([r, o]) => {
        r && o ? (n || (n = new Jl(t)), n.mount(r)) : n && (n.unmount(), n = null);
      }
    ), ls(() => {
      n == null || n.unmount();
    }), {
      get props() {
        return { tabindex: -1 };
      }
    };
  }
};
yr = new WeakMap(), en = new WeakMap(), En = new WeakMap(), Gr = new WeakMap(), xr = new WeakMap(), Ne = new WeakSet(), Pd = function() {
  for (const t of f(this, Gr))
    t();
  vt(this, Gr, []);
}, Id = function() {
  if (!f(this, en)) return;
  const t = new CustomEvent("focusScope.onOpenAutoFocus", { bubbles: !1, cancelable: !0 });
  f(this, xr).onOpenAutoFocus.current(t), t.defaultPrevented || requestAnimationFrame(() => {
    if (!f(this, en)) return;
    const n = ce(this, Ne, Cs).call(this);
    n ? (n.focus(), f(this, En).setFocusMemory(this, n)) : f(this, en).focus();
  });
}, Nd = function() {
  const t = new CustomEvent("focusScope.onCloseAutoFocus", { bubbles: !1, cancelable: !0 });
  if (f(this, xr).onCloseAutoFocus.current(t), !t.defaultPrevented) {
    const n = document.activeElement;
    n && n !== document.body && n.focus();
  }
}, Rd = function() {
  if (!f(this, en) || !f(this, xr).trap.current) return;
  const t = f(this, en), n = t.ownerDocument, r = (s) => {
    if (f(this, yr) || !f(this, En).isActiveScope(this)) return;
    const d = s.target;
    if (!d) return;
    if (t.contains(d))
      f(this, En).setFocusMemory(this, d);
    else {
      const c = f(this, En).getFocusMemory(this);
      if (c && t.contains(c) && cg(c))
        s.preventDefault(), c.focus();
      else {
        const g = ce(this, Ne, Cs).call(this), h = ce(this, Ne, rl).call(this)[0];
        (g || h || t).focus();
      }
    }
  }, o = (s) => {
    if (!f(this, xr).loop || f(this, yr) || s.key !== "Tab" || !f(this, En).isActiveScope(this)) return;
    const d = ce(this, Ne, nl).call(this);
    if (d.length < 2) return;
    const a = d[0], c = d[d.length - 1];
    !s.shiftKey && n.activeElement === c ? (s.preventDefault(), a.focus()) : s.shiftKey && n.activeElement === a && (s.preventDefault(), c.focus());
  };
  f(this, Gr).push(yn(n, "focusin", r, { capture: !0 }), yn(t, "keydown", o));
  const i = new MutationObserver(() => {
    const s = f(this, En).getFocusMemory(this);
    if (s && !t.contains(s)) {
      const d = ce(this, Ne, Cs).call(this), a = ce(this, Ne, rl).call(this)[0], c = d || a;
      c ? (c.focus(), f(this, En).setFocusMemory(this, c)) : t.focus();
    }
  });
  i.observe(t, { childList: !0, subtree: !0 }), f(this, Gr).push(() => i.disconnect());
}, nl = function() {
  return f(this, en) ? sg(f(this, en), { includeContainer: !1, getShadowRoot: !0 }) : [];
}, Cs = function() {
  return ce(this, Ne, nl).call(this)[0] || null;
}, rl = function() {
  return f(this, en) ? ag(f(this, en), { includeContainer: !1, getShadowRoot: !0 }) : [];
};
let el = Jl;
function ug(e, t) {
  Kt(t, !0);
  let n = W(t, "enabled", 3, !1), r = W(t, "trapFocus", 3, !1), o = W(t, "loop", 3, !1), i = W(t, "onCloseAutoFocus", 3, Xe), s = W(t, "onOpenAutoFocus", 3, Xe);
  const d = el.use({
    enabled: H.with(() => n()),
    trap: H.with(() => r()),
    loop: o(),
    onCloseAutoFocus: H.with(() => i()),
    onOpenAutoFocus: H.with(() => s()),
    ref: t.ref
  });
  var a = _t(), c = rt(a);
  ie(c, () => t.focusScope ?? Re, () => ({ props: d.props })), O(e, a), Gt();
}
globalThis.bitsTextSelectionLayers ?? (globalThis.bitsTextSelectionLayers = /* @__PURE__ */ new Map());
var To, ra, Fd, oa, xi;
const Ql = class Ql {
  constructor(t) {
    N(this, ra);
    it(this, "opts");
    it(this, "domContext");
    N(this, To, Xe);
    N(this, oa, (t) => {
      const n = this.opts.ref.current, r = t.target;
      !Mc(n) || !Mc(r) || !this.opts.enabled.current || !fg(this) || !dv(n, r) || (this.opts.onPointerDown.current(t), !t.defaultPrevented && vt(this, To, dg(n, this.domContext.getDocument().body)));
    });
    N(this, xi, () => {
      f(this, To).call(this), vt(this, To, Xe);
    });
    this.opts = t, this.domContext = new hd(t.ref);
    let n = Xe;
    gn(() => this.opts.enabled.current, (r) => (r && (globalThis.bitsTextSelectionLayers.set(this, this.opts.enabled), n(), n = ce(this, ra, Fd).call(this)), () => {
      n(), f(this, xi).call(this), globalThis.bitsTextSelectionLayers.delete(this);
    }));
  }
  static create(t) {
    return new Ql(t);
  }
};
To = new WeakMap(), ra = new WeakSet(), Fd = function() {
  return uo(yn(this.domContext.getDocument(), "pointerdown", f(this, oa)), yn(this.domContext.getDocument(), "pointerup", rd(f(this, xi), this.opts.onPointerUp.current)));
}, oa = new WeakMap(), xi = new WeakMap();
let ol = Ql;
const jc = (e) => e.style.userSelect || e.style.webkitUserSelect;
function dg(e, t) {
  const n = jc(t), r = jc(e);
  return vs(t, "none"), vs(e, "text"), () => {
    vs(t, n), vs(e, r);
  };
}
function vs(e, t) {
  e.style.userSelect = t, e.style.webkitUserSelect = t;
}
function fg(e) {
  const t = [...globalThis.bitsTextSelectionLayers];
  if (!t.length) return !1;
  const n = t.at(-1);
  return n ? n[0] === e : !1;
}
function hg(e, t) {
  Kt(t, !0);
  let n = W(t, "preventOverflowTextSelection", 3, !0), r = W(t, "onPointerDown", 3, Xe), o = W(t, "onPointerUp", 3, Xe);
  ol.create({
    id: H.with(() => t.id),
    onPointerDown: H.with(() => r()),
    onPointerUp: H.with(() => o()),
    enabled: H.with(() => t.enabled && n()),
    ref: t.ref
  });
  var i = _t(), s = rt(i);
  ie(s, () => t.children ?? Re), O(e, i), Gt();
}
globalThis.bitsIdCounter ?? (globalThis.bitsIdCounter = { current: 0 });
function cs(e = "bits") {
  return globalThis.bitsIdCounter.current++, `${e}-${globalThis.bitsIdCounter.current}`;
}
var Si, Po, Hr, Yr, ia, Ld;
class pg {
  constructor(t) {
    N(this, ia);
    N(this, Si);
    N(this, Po, 0);
    N(this, Hr, /* @__PURE__ */ ct());
    N(this, Yr);
    vt(this, Si, t);
  }
  get(...t) {
    return vt(this, Po, f(this, Po) + 1), l(f(this, Hr)) === void 0 && vt(this, Yr, nh(() => {
      z(f(this, Hr), f(this, Si).call(this, ...t), !0);
    })), Ie(() => () => {
      ce(this, ia, Ld).call(this);
    }), l(f(this, Hr));
  }
}
Si = new WeakMap(), Po = new WeakMap(), Hr = new WeakMap(), Yr = new WeakMap(), ia = new WeakSet(), Ld = function() {
  vt(this, Po, f(this, Po) - 1), f(this, Yr) && f(this, Po) <= 0 && (f(this, Yr).call(this), z(f(this, Hr), void 0), vt(this, Yr, void 0));
};
const vg = new pg(() => {
  const e = new Ya(), t = /* @__PURE__ */ L(() => {
    for (const i of e.values())
      if (i) return !0;
    return !1;
  });
  let n = /* @__PURE__ */ ct(null), r = null;
  function o() {
    Fl && (document.body.setAttribute("style", l(n) ?? ""), document.body.style.removeProperty("--scrollbar-width"), Lc && (r == null || r()));
  }
  return gn(() => l(t), () => {
    if (!l(t)) return;
    z(n, document.body.getAttribute("style"), !0);
    const i = getComputedStyle(document.body), s = window.innerWidth - document.documentElement.clientWidth, a = {
      padding: Number.parseInt(i.paddingRight ?? "0", 10) + s,
      margin: Number.parseInt(i.marginRight ?? "0", 10)
    };
    s > 0 && (document.body.style.paddingRight = `${a.padding}px`, document.body.style.marginRight = `${a.margin}px`, document.body.style.setProperty("--scrollbar-width", `${s}px`), document.body.style.overflow = "hidden"), Lc && (r = _d(
      document,
      "touchmove",
      (c) => {
        c.target === document.documentElement && (c.touches.length > 1 || c.preventDefault());
      },
      { passive: !1 }
    )), Rl(() => {
      document.body.style.pointerEvents = "none", document.body.style.overflow = "hidden";
    });
  }), ls(() => () => {
    r == null || r();
  }), {
    get map() {
      return e;
    },
    resetBodyStyle: o
  };
});
var Xr, Ci, Ai, On;
class gg {
  constructor(t, n = () => null) {
    N(this, Xr, cs());
    N(this, Ci);
    N(this, Ai, () => null);
    N(this, On);
    it(this, "locked");
    vt(this, Ci, t), vt(this, Ai, n), vt(this, On, vg.get()), f(this, On) && (f(this, On).map.set(f(this, Xr), f(this, Ci) ?? !1), this.locked = H.with(() => f(this, On).map.get(f(this, Xr)) ?? !1, (r) => f(this, On).map.set(f(this, Xr), r)), ls(() => {
      if (f(this, On).map.delete(f(this, Xr)), mg(f(this, On).map)) return;
      const r = f(this, Ai).call(this);
      r === null ? requestAnimationFrame(() => f(this, On).resetBodyStyle()) : cd(r, () => f(this, On).resetBodyStyle());
    }));
  }
}
Xr = new WeakMap(), Ci = new WeakMap(), Ai = new WeakMap(), On = new WeakMap();
function mg(e) {
  for (const [t, n] of e)
    if (n) return !0;
  return !1;
}
function Wc(e, t) {
  Kt(t, !0);
  let n = W(t, "preventScroll", 3, !0), r = W(t, "restoreScrollDelay", 3, null);
  n() && new gg(n(), () => r()), Gt();
}
const _g = ["top", "right", "bottom", "left"], Tr = Math.min, wn = Math.max, Ms = Math.round, gs = Math.floor, Un = (e) => ({
  x: e,
  y: e
}), wg = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, bg = {
  start: "end",
  end: "start"
};
function il(e, t, n) {
  return wn(e, Tr(t, n));
}
function ur(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function dr(e) {
  return e.split("-")[0];
}
function Do(e) {
  return e.split("-")[1];
}
function Ll(e) {
  return e === "x" ? "y" : "x";
}
function Ml(e) {
  return e === "y" ? "height" : "width";
}
const yg = /* @__PURE__ */ new Set(["top", "bottom"]);
function Wn(e) {
  return yg.has(dr(e)) ? "y" : "x";
}
function zl(e) {
  return Ll(Wn(e));
}
function xg(e, t, n) {
  n === void 0 && (n = !1);
  const r = Do(e), o = zl(e), i = Ml(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = zs(s)), [s, zs(s)];
}
function Sg(e) {
  const t = zs(e);
  return [sl(e), t, sl(t)];
}
function sl(e) {
  return e.replace(/start|end/g, (t) => bg[t]);
}
const Uc = ["left", "right"], qc = ["right", "left"], Cg = ["top", "bottom"], Ag = ["bottom", "top"];
function kg(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? qc : Uc : t ? Uc : qc;
    case "left":
    case "right":
      return t ? Cg : Ag;
    default:
      return [];
  }
}
function Eg(e, t, n, r) {
  const o = Do(e);
  let i = kg(dr(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(sl)))), i;
}
function zs(e) {
  return e.replace(/left|right|bottom|top/g, (t) => wg[t]);
}
function Og(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Md(e) {
  return typeof e != "number" ? Og(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ds(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Kc(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = Wn(t), s = zl(t), d = Ml(s), a = dr(t), c = i === "y", g = r.x + r.width / 2 - o.width / 2, h = r.y + r.height / 2 - o.height / 2, p = r[d] / 2 - o[d] / 2;
  let _;
  switch (a) {
    case "top":
      _ = {
        x: g,
        y: r.y - o.height
      };
      break;
    case "bottom":
      _ = {
        x: g,
        y: r.y + r.height
      };
      break;
    case "right":
      _ = {
        x: r.x + r.width,
        y: h
      };
      break;
    case "left":
      _ = {
        x: r.x - o.width,
        y: h
      };
      break;
    default:
      _ = {
        x: r.x,
        y: r.y
      };
  }
  switch (Do(t)) {
    case "start":
      _[s] -= p * (n && c ? -1 : 1);
      break;
    case "end":
      _[s] += p * (n && c ? -1 : 1);
      break;
  }
  return _;
}
const Tg = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, d = i.filter(Boolean), a = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let c = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: g,
    y: h
  } = Kc(c, r, a), p = r, _ = {}, w = 0;
  for (let x = 0; x < d.length; x++) {
    const {
      name: k,
      fn: y
    } = d[x], {
      x: R,
      y: A,
      data: S,
      reset: u
    } = await y({
      x: g,
      y: h,
      initialPlacement: r,
      placement: p,
      strategy: o,
      middlewareData: _,
      rects: c,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    g = R ?? g, h = A ?? h, _ = {
      ..._,
      [k]: {
        ..._[k],
        ...S
      }
    }, u && w <= 50 && (w++, typeof u == "object" && (u.placement && (p = u.placement), u.rects && (c = u.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : u.rects), {
      x: g,
      y: h
    } = Kc(c, p, a)), x = -1);
  }
  return {
    x: g,
    y: h,
    placement: p,
    strategy: o,
    middlewareData: _
  };
};
async function si(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: d,
    strategy: a
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: g = "viewport",
    elementContext: h = "floating",
    altBoundary: p = !1,
    padding: _ = 0
  } = ur(t, e), w = Md(_), k = d[p ? h === "floating" ? "reference" : "floating" : h], y = Ds(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(k))) == null || n ? k : k.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(d.floating)),
    boundary: c,
    rootBoundary: g,
    strategy: a
  })), R = h === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, A = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(d.floating)), S = await (i.isElement == null ? void 0 : i.isElement(A)) ? await (i.getScale == null ? void 0 : i.getScale(A)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, u = Ds(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: d,
    rect: R,
    offsetParent: A,
    strategy: a
  }) : R);
  return {
    top: (y.top - u.top + w.top) / S.y,
    bottom: (u.bottom - y.bottom + w.bottom) / S.y,
    left: (y.left - u.left + w.left) / S.x,
    right: (u.right - y.right + w.right) / S.x
  };
}
const Pg = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: d,
      middlewareData: a
    } = t, {
      element: c,
      padding: g = 0
    } = ur(e, t) || {};
    if (c == null)
      return {};
    const h = Md(g), p = {
      x: n,
      y: r
    }, _ = zl(o), w = Ml(_), x = await s.getDimensions(c), k = _ === "y", y = k ? "top" : "left", R = k ? "bottom" : "right", A = k ? "clientHeight" : "clientWidth", S = i.reference[w] + i.reference[_] - p[_] - i.floating[w], u = p[_] - i.reference[_], T = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let I = T ? T[A] : 0;
    (!I || !await (s.isElement == null ? void 0 : s.isElement(T))) && (I = d.floating[A] || i.floating[w]);
    const b = S / 2 - u / 2, wt = I / 2 - x[w] / 2 - 1, Pt = Tr(h[y], wt), ut = Tr(h[R], wt), E = Pt, V = I - x[w] - ut, K = I / 2 - x[w] / 2 + b, Y = il(E, K, V), Z = !a.arrow && Do(o) != null && K !== Y && i.reference[w] / 2 - (K < E ? Pt : ut) - x[w] / 2 < 0, ot = Z ? K < E ? K - E : K - V : 0;
    return {
      [_]: p[_] + ot,
      data: {
        [_]: Y,
        centerOffset: K - Y - ot,
        ...Z && {
          alignmentOffset: ot
        }
      },
      reset: Z
    };
  }
}), Ig = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: d,
        platform: a,
        elements: c
      } = t, {
        mainAxis: g = !0,
        crossAxis: h = !0,
        fallbackPlacements: p,
        fallbackStrategy: _ = "bestFit",
        fallbackAxisSideDirection: w = "none",
        flipAlignment: x = !0,
        ...k
      } = ur(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const y = dr(o), R = Wn(d), A = dr(d) === d, S = await (a.isRTL == null ? void 0 : a.isRTL(c.floating)), u = p || (A || !x ? [zs(d)] : Sg(d)), T = w !== "none";
      !p && T && u.push(...Eg(d, x, w, S));
      const I = [d, ...u], b = await si(t, k), wt = [];
      let Pt = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (g && wt.push(b[y]), h) {
        const K = xg(o, s, S);
        wt.push(b[K[0]], b[K[1]]);
      }
      if (Pt = [...Pt, {
        placement: o,
        overflows: wt
      }], !wt.every((K) => K <= 0)) {
        var ut, E;
        const K = (((ut = i.flip) == null ? void 0 : ut.index) || 0) + 1, Y = I[K];
        if (Y && (!(h === "alignment" ? R !== Wn(Y) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        Pt.every((P) => P.overflows[0] > 0 && Wn(P.placement) === R)))
          return {
            data: {
              index: K,
              overflows: Pt
            },
            reset: {
              placement: Y
            }
          };
        let Z = (E = Pt.filter((ot) => ot.overflows[0] <= 0).sort((ot, P) => ot.overflows[1] - P.overflows[1])[0]) == null ? void 0 : E.placement;
        if (!Z)
          switch (_) {
            case "bestFit": {
              var V;
              const ot = (V = Pt.filter((P) => {
                if (T) {
                  const tt = Wn(P.placement);
                  return tt === R || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  tt === "y";
                }
                return !0;
              }).map((P) => [P.placement, P.overflows.filter((tt) => tt > 0).reduce((tt, Q) => tt + Q, 0)]).sort((P, tt) => P[1] - tt[1])[0]) == null ? void 0 : V[0];
              ot && (Z = ot);
              break;
            }
            case "initialPlacement":
              Z = d;
              break;
          }
        if (o !== Z)
          return {
            reset: {
              placement: Z
            }
          };
      }
      return {};
    }
  };
};
function Gc(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Hc(e) {
  return _g.some((t) => e[t] >= 0);
}
const Ng = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = ur(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await si(t, {
            ...o,
            elementContext: "reference"
          }), s = Gc(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Hc(s)
            }
          };
        }
        case "escaped": {
          const i = await si(t, {
            ...o,
            altBoundary: !0
          }), s = Gc(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Hc(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, zd = /* @__PURE__ */ new Set(["left", "top"]);
async function Rg(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = dr(n), d = Do(n), a = Wn(n) === "y", c = zd.has(s) ? -1 : 1, g = i && a ? -1 : 1, h = ur(t, e);
  let {
    mainAxis: p,
    crossAxis: _,
    alignmentAxis: w
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: h.mainAxis || 0,
    crossAxis: h.crossAxis || 0,
    alignmentAxis: h.alignmentAxis
  };
  return d && typeof w == "number" && (_ = d === "end" ? w * -1 : w), a ? {
    x: _ * g,
    y: p * c
  } : {
    x: p * c,
    y: _ * g
  };
}
const Fg = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: d
      } = t, a = await Rg(t, e);
      return s === ((n = d.offset) == null ? void 0 : n.placement) && (r = d.arrow) != null && r.alignmentOffset ? {} : {
        x: o + a.x,
        y: i + a.y,
        data: {
          ...a,
          placement: s
        }
      };
    }
  };
}, Lg = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: d = {
          fn: (k) => {
            let {
              x: y,
              y: R
            } = k;
            return {
              x: y,
              y: R
            };
          }
        },
        ...a
      } = ur(e, t), c = {
        x: n,
        y: r
      }, g = await si(t, a), h = Wn(dr(o)), p = Ll(h);
      let _ = c[p], w = c[h];
      if (i) {
        const k = p === "y" ? "top" : "left", y = p === "y" ? "bottom" : "right", R = _ + g[k], A = _ - g[y];
        _ = il(R, _, A);
      }
      if (s) {
        const k = h === "y" ? "top" : "left", y = h === "y" ? "bottom" : "right", R = w + g[k], A = w - g[y];
        w = il(R, w, A);
      }
      const x = d.fn({
        ...t,
        [p]: _,
        [h]: w
      });
      return {
        ...x,
        data: {
          x: x.x - n,
          y: x.y - r,
          enabled: {
            [p]: i,
            [h]: s
          }
        }
      };
    }
  };
}, Mg = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: s
      } = t, {
        offset: d = 0,
        mainAxis: a = !0,
        crossAxis: c = !0
      } = ur(e, t), g = {
        x: n,
        y: r
      }, h = Wn(o), p = Ll(h);
      let _ = g[p], w = g[h];
      const x = ur(d, t), k = typeof x == "number" ? {
        mainAxis: x,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...x
      };
      if (a) {
        const A = p === "y" ? "height" : "width", S = i.reference[p] - i.floating[A] + k.mainAxis, u = i.reference[p] + i.reference[A] - k.mainAxis;
        _ < S ? _ = S : _ > u && (_ = u);
      }
      if (c) {
        var y, R;
        const A = p === "y" ? "width" : "height", S = zd.has(dr(o)), u = i.reference[h] - i.floating[A] + (S && ((y = s.offset) == null ? void 0 : y[h]) || 0) + (S ? 0 : k.crossAxis), T = i.reference[h] + i.reference[A] + (S ? 0 : ((R = s.offset) == null ? void 0 : R[h]) || 0) - (S ? k.crossAxis : 0);
        w < u ? w = u : w > T && (w = T);
      }
      return {
        [p]: _,
        [h]: w
      };
    }
  };
}, zg = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: s,
        elements: d
      } = t, {
        apply: a = () => {
        },
        ...c
      } = ur(e, t), g = await si(t, c), h = dr(o), p = Do(o), _ = Wn(o) === "y", {
        width: w,
        height: x
      } = i.floating;
      let k, y;
      h === "top" || h === "bottom" ? (k = h, y = p === (await (s.isRTL == null ? void 0 : s.isRTL(d.floating)) ? "start" : "end") ? "left" : "right") : (y = h, k = p === "end" ? "top" : "bottom");
      const R = x - g.top - g.bottom, A = w - g.left - g.right, S = Tr(x - g[k], R), u = Tr(w - g[y], A), T = !t.middlewareData.shift;
      let I = S, b = u;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (b = A), (r = t.middlewareData.shift) != null && r.enabled.y && (I = R), T && !p) {
        const Pt = wn(g.left, 0), ut = wn(g.right, 0), E = wn(g.top, 0), V = wn(g.bottom, 0);
        _ ? b = w - 2 * (Pt !== 0 || ut !== 0 ? Pt + ut : wn(g.left, g.right)) : I = x - 2 * (E !== 0 || V !== 0 ? E + V : wn(g.top, g.bottom));
      }
      await a({
        ...t,
        availableWidth: b,
        availableHeight: I
      });
      const wt = await s.getDimensions(d.floating);
      return w !== wt.width || x !== wt.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ba() {
  return typeof window < "u";
}
function Bo(e) {
  return Dd(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function xn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Zn(e) {
  var t;
  return (t = (Dd(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Dd(e) {
  return ba() ? e instanceof Node || e instanceof xn(e).Node : !1;
}
function Fn(e) {
  return ba() ? e instanceof Element || e instanceof xn(e).Element : !1;
}
function Yn(e) {
  return ba() ? e instanceof HTMLElement || e instanceof xn(e).HTMLElement : !1;
}
function Yc(e) {
  return !ba() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof xn(e).ShadowRoot;
}
const Dg = /* @__PURE__ */ new Set(["inline", "contents"]);
function us(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Ln(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !Dg.has(o);
}
const Bg = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Vg(e) {
  return Bg.has(Bo(e));
}
const jg = [":popover-open", ":modal"];
function ya(e) {
  return jg.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const Wg = ["transform", "translate", "scale", "rotate", "perspective"], Ug = ["transform", "translate", "scale", "rotate", "perspective", "filter"], qg = ["paint", "layout", "strict", "content"];
function Dl(e) {
  const t = Bl(), n = Fn(e) ? Ln(e) : e;
  return Wg.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || Ug.some((r) => (n.willChange || "").includes(r)) || qg.some((r) => (n.contain || "").includes(r));
}
function Kg(e) {
  let t = Pr(e);
  for (; Yn(t) && !Fo(t); ) {
    if (Dl(t))
      return t;
    if (ya(t))
      return null;
    t = Pr(t);
  }
  return null;
}
function Bl() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const Gg = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Fo(e) {
  return Gg.has(Bo(e));
}
function Ln(e) {
  return xn(e).getComputedStyle(e);
}
function xa(e) {
  return Fn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Pr(e) {
  if (Bo(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Yc(e) && e.host || // Fallback.
    Zn(e)
  );
  return Yc(t) ? t.host : t;
}
function Bd(e) {
  const t = Pr(e);
  return Fo(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Yn(t) && us(t) ? t : Bd(t);
}
function ai(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Bd(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = xn(o);
  if (i) {
    const d = al(s);
    return t.concat(s, s.visualViewport || [], us(o) ? o : [], d && n ? ai(d) : []);
  }
  return t.concat(o, ai(o, [], n));
}
function al(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Vd(e) {
  const t = Ln(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Yn(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, d = Ms(n) !== i || Ms(r) !== s;
  return d && (n = i, r = s), {
    width: n,
    height: r,
    $: d
  };
}
function Vl(e) {
  return Fn(e) ? e : e.contextElement;
}
function fo(e) {
  const t = Vl(e);
  if (!Yn(t))
    return Un(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = Vd(t);
  let s = (i ? Ms(n.width) : n.width) / r, d = (i ? Ms(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!d || !Number.isFinite(d)) && (d = 1), {
    x: s,
    y: d
  };
}
const Hg = /* @__PURE__ */ Un(0);
function jd(e) {
  const t = xn(e);
  return !Bl() || !t.visualViewport ? Hg : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Yg(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== xn(e) ? !1 : t;
}
function Jr(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Vl(e);
  let s = Un(1);
  t && (r ? Fn(r) && (s = fo(r)) : s = fo(e));
  const d = Yg(i, n, r) ? jd(i) : Un(0);
  let a = (o.left + d.x) / s.x, c = (o.top + d.y) / s.y, g = o.width / s.x, h = o.height / s.y;
  if (i) {
    const p = xn(i), _ = r && Fn(r) ? xn(r) : r;
    let w = p, x = al(w);
    for (; x && r && _ !== w; ) {
      const k = fo(x), y = x.getBoundingClientRect(), R = Ln(x), A = y.left + (x.clientLeft + parseFloat(R.paddingLeft)) * k.x, S = y.top + (x.clientTop + parseFloat(R.paddingTop)) * k.y;
      a *= k.x, c *= k.y, g *= k.x, h *= k.y, a += A, c += S, w = xn(x), x = al(w);
    }
  }
  return Ds({
    width: g,
    height: h,
    x: a,
    y: c
  });
}
function jl(e, t) {
  const n = xa(e).scrollLeft;
  return t ? t.left + n : Jr(Zn(e)).left + n;
}
function Wd(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    jl(e, r)
  )), i = r.top + t.scrollTop;
  return {
    x: o,
    y: i
  };
}
function Xg(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", s = Zn(r), d = t ? ya(t.floating) : !1;
  if (r === s || d && i)
    return n;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Un(1);
  const g = Un(0), h = Yn(r);
  if ((h || !h && !i) && ((Bo(r) !== "body" || us(s)) && (a = xa(r)), Yn(r))) {
    const _ = Jr(r);
    c = fo(r), g.x = _.x + r.clientLeft, g.y = _.y + r.clientTop;
  }
  const p = s && !h && !i ? Wd(s, a, !0) : Un(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - a.scrollLeft * c.x + g.x + p.x,
    y: n.y * c.y - a.scrollTop * c.y + g.y + p.y
  };
}
function Zg(e) {
  return Array.from(e.getClientRects());
}
function Jg(e) {
  const t = Zn(e), n = xa(e), r = e.ownerDocument.body, o = wn(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = wn(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + jl(e);
  const d = -n.scrollTop;
  return Ln(r).direction === "rtl" && (s += wn(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: d
  };
}
function Qg(e, t) {
  const n = xn(e), r = Zn(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, d = 0, a = 0;
  if (o) {
    i = o.width, s = o.height;
    const c = Bl();
    (!c || c && t === "fixed") && (d = o.offsetLeft, a = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: d,
    y: a
  };
}
const $g = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function tm(e, t) {
  const n = Jr(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = Yn(e) ? fo(e) : Un(1), s = e.clientWidth * i.x, d = e.clientHeight * i.y, a = o * i.x, c = r * i.y;
  return {
    width: s,
    height: d,
    x: a,
    y: c
  };
}
function Xc(e, t, n) {
  let r;
  if (t === "viewport")
    r = Qg(e, n);
  else if (t === "document")
    r = Jg(Zn(e));
  else if (Fn(t))
    r = tm(t, n);
  else {
    const o = jd(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Ds(r);
}
function Ud(e, t) {
  const n = Pr(e);
  return n === t || !Fn(n) || Fo(n) ? !1 : Ln(n).position === "fixed" || Ud(n, t);
}
function em(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = ai(e, [], !1).filter((d) => Fn(d) && Bo(d) !== "body"), o = null;
  const i = Ln(e).position === "fixed";
  let s = i ? Pr(e) : e;
  for (; Fn(s) && !Fo(s); ) {
    const d = Ln(s), a = Dl(s);
    !a && d.position === "fixed" && (o = null), (i ? !a && !o : !a && d.position === "static" && !!o && $g.has(o.position) || us(s) && !a && Ud(e, s)) ? r = r.filter((g) => g !== s) : o = d, s = Pr(s);
  }
  return t.set(e, r), r;
}
function nm(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? ya(t) ? [] : em(t, this._c) : [].concat(n), r], d = s[0], a = s.reduce((c, g) => {
    const h = Xc(t, g, o);
    return c.top = wn(h.top, c.top), c.right = Tr(h.right, c.right), c.bottom = Tr(h.bottom, c.bottom), c.left = wn(h.left, c.left), c;
  }, Xc(t, d, o));
  return {
    width: a.right - a.left,
    height: a.bottom - a.top,
    x: a.left,
    y: a.top
  };
}
function rm(e) {
  const {
    width: t,
    height: n
  } = Vd(e);
  return {
    width: t,
    height: n
  };
}
function om(e, t, n) {
  const r = Yn(t), o = Zn(t), i = n === "fixed", s = Jr(e, !0, i, t);
  let d = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = Un(0);
  function c() {
    a.x = jl(o);
  }
  if (r || !r && !i)
    if ((Bo(t) !== "body" || us(o)) && (d = xa(t)), r) {
      const _ = Jr(t, !0, i, t);
      a.x = _.x + t.clientLeft, a.y = _.y + t.clientTop;
    } else o && c();
  i && !r && o && c();
  const g = o && !r && !i ? Wd(o, d) : Un(0), h = s.left + d.scrollLeft - a.x - g.x, p = s.top + d.scrollTop - a.y - g.y;
  return {
    x: h,
    y: p,
    width: s.width,
    height: s.height
  };
}
function La(e) {
  return Ln(e).position === "static";
}
function Zc(e, t) {
  if (!Yn(e) || Ln(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Zn(e) === n && (n = n.ownerDocument.body), n;
}
function qd(e, t) {
  const n = xn(e);
  if (ya(e))
    return n;
  if (!Yn(e)) {
    let o = Pr(e);
    for (; o && !Fo(o); ) {
      if (Fn(o) && !La(o))
        return o;
      o = Pr(o);
    }
    return n;
  }
  let r = Zc(e, t);
  for (; r && Vg(r) && La(r); )
    r = Zc(r, t);
  return r && Fo(r) && La(r) && !Dl(r) ? n : r || Kg(e) || n;
}
const im = async function(e) {
  const t = this.getOffsetParent || qd, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: om(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function sm(e) {
  return Ln(e).direction === "rtl";
}
const am = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Xg,
  getDocumentElement: Zn,
  getClippingRect: nm,
  getOffsetParent: qd,
  getElementRects: im,
  getClientRects: Zg,
  getDimensions: rm,
  getScale: fo,
  isElement: Fn,
  isRTL: sm
};
function Kd(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function lm(e, t) {
  let n = null, r;
  const o = Zn(e);
  function i() {
    var d;
    clearTimeout(r), (d = n) == null || d.disconnect(), n = null;
  }
  function s(d, a) {
    d === void 0 && (d = !1), a === void 0 && (a = 1), i();
    const c = e.getBoundingClientRect(), {
      left: g,
      top: h,
      width: p,
      height: _
    } = c;
    if (d || t(), !p || !_)
      return;
    const w = gs(h), x = gs(o.clientWidth - (g + p)), k = gs(o.clientHeight - (h + _)), y = gs(g), A = {
      rootMargin: -w + "px " + -x + "px " + -k + "px " + -y + "px",
      threshold: wn(0, Tr(1, a)) || 1
    };
    let S = !0;
    function u(T) {
      const I = T[0].intersectionRatio;
      if (I !== a) {
        if (!S)
          return s();
        I ? s(!1, I) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      I === 1 && !Kd(c, e.getBoundingClientRect()) && s(), S = !1;
    }
    try {
      n = new IntersectionObserver(u, {
        ...A,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(u, A);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function cm(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: d = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = r, c = Vl(e), g = o || i ? [...c ? ai(c) : [], ...ai(t)] : [];
  g.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), i && y.addEventListener("resize", n);
  });
  const h = c && d ? lm(c, n) : null;
  let p = -1, _ = null;
  s && (_ = new ResizeObserver((y) => {
    let [R] = y;
    R && R.target === c && _ && (_.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var A;
      (A = _) == null || A.observe(t);
    })), n();
  }), c && !a && _.observe(c), _.observe(t));
  let w, x = a ? Jr(e) : null;
  a && k();
  function k() {
    const y = Jr(e);
    x && !Kd(x, y) && n(), x = y, w = requestAnimationFrame(k);
  }
  return n(), () => {
    var y;
    g.forEach((R) => {
      o && R.removeEventListener("scroll", n), i && R.removeEventListener("resize", n);
    }), h == null || h(), (y = _) == null || y.disconnect(), _ = null, a && cancelAnimationFrame(w);
  };
}
const um = Fg, dm = Lg, fm = Ig, hm = zg, pm = Ng, vm = Pg, gm = Mg, mm = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: am,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return Tg(e, t, {
    ...o,
    platform: i
  });
};
function Mr(e) {
  return typeof e == "function" ? e() : e;
}
function Gd(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Jc(e, t) {
  const n = Gd(e);
  return Math.round(t * n) / n;
}
function Qc(e) {
  return {
    [`--bits-${e}-content-transform-origin`]: "var(--bits-floating-transform-origin)",
    [`--bits-${e}-content-available-width`]: "var(--bits-floating-available-width)",
    [`--bits-${e}-content-available-height`]: "var(--bits-floating-available-height)",
    [`--bits-${e}-anchor-width`]: "var(--bits-floating-anchor-width)",
    [`--bits-${e}-anchor-height`]: "var(--bits-floating-anchor-height)"
  };
}
function _m(e) {
  const t = e.whileElementsMounted, n = /* @__PURE__ */ L(() => Mr(e.open) ?? !0), r = /* @__PURE__ */ L(() => Mr(e.middleware)), o = /* @__PURE__ */ L(() => Mr(e.transform) ?? !0), i = /* @__PURE__ */ L(() => Mr(e.placement) ?? "bottom"), s = /* @__PURE__ */ L(() => Mr(e.strategy) ?? "absolute"), d = /* @__PURE__ */ L(() => Mr(e.sideOffset) ?? 0), a = /* @__PURE__ */ L(() => Mr(e.alignOffset) ?? 0), c = e.reference;
  let g = /* @__PURE__ */ ct(0), h = /* @__PURE__ */ ct(0);
  const p = H(null);
  let _ = /* @__PURE__ */ ct(Xt(l(s))), w = /* @__PURE__ */ ct(Xt(l(i))), x = /* @__PURE__ */ ct(Xt({})), k = /* @__PURE__ */ ct(!1);
  const y = /* @__PURE__ */ L(() => {
    const I = p.current ? Jc(p.current, l(g)) : l(g), b = p.current ? Jc(p.current, l(h)) : l(h);
    return l(o) ? {
      position: l(_),
      left: "0",
      top: "0",
      transform: `translate(${I}px, ${b}px)`,
      ...p.current && Gd(p.current) >= 1.5 && { willChange: "transform" }
    } : {
      position: l(_),
      left: `${I}px`,
      top: `${b}px`
    };
  });
  let R;
  function A() {
    c.current === null || p.current === null || mm(c.current, p.current, {
      middleware: l(r),
      placement: l(i),
      strategy: l(s)
    }).then((I) => {
      if (!l(n) && l(g) !== 0 && l(h) !== 0) {
        const b = Math.max(Math.abs(l(d)), Math.abs(l(a)), 15);
        if (I.x <= b && I.y <= b) return;
      }
      z(g, I.x, !0), z(h, I.y, !0), z(_, I.strategy, !0), z(w, I.placement, !0), z(x, I.middlewareData, !0), z(k, !0);
    });
  }
  function S() {
    typeof R == "function" && (R(), R = void 0);
  }
  function u() {
    if (S(), t === void 0) {
      A();
      return;
    }
    c.current === null || p.current === null || (R = t(c.current, p.current, A));
  }
  function T() {
    l(n) || z(k, !1);
  }
  return Ie(A), Ie(u), Ie(T), Ie(() => S), {
    floating: p,
    reference: c,
    get strategy() {
      return l(_);
    },
    get placement() {
      return l(w);
    },
    get middlewareData() {
      return l(x);
    },
    get isPositioned() {
      return l(k);
    },
    get floatingStyles() {
      return l(y);
    },
    get update() {
      return A;
    }
  };
}
const wm = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Wl = new as("Floating.Root"), ll = new as("Floating.Content"), Ul = new as("Floating.Root");
class Bs {
  constructor() {
    it(this, "anchorNode", H(null));
    it(this, "customAnchorNode", H(null));
    it(this, "triggerNode", H(null));
    Ie(() => {
      this.customAnchorNode.current ? typeof this.customAnchorNode.current == "string" ? this.anchorNode.current = document.querySelector(this.customAnchorNode.current) : this.anchorNode.current = this.customAnchorNode.current : this.anchorNode.current = this.triggerNode.current;
    });
  }
  static create(t = !1) {
    return t ? Ul.set(new Bs()) : Wl.set(new Bs());
  }
}
var ki, sa, Ei, aa, Oi, la, Ti, Pi, Ii, Ni, Ri, Fi, Li, Mi, zi, Di, Bi, Vi, ji, Wi, Ui, qi, Ki, Gi;
const ca = class ca {
  constructor(t, n) {
    it(this, "opts");
    it(this, "root");
    // nodes
    it(this, "contentRef", H(null));
    it(this, "wrapperRef", H(null));
    it(this, "arrowRef", H(null));
    it(this, "contentAttachment", ti(this.contentRef));
    it(this, "wrapperAttachment", ti(this.wrapperRef));
    it(this, "arrowAttachment", ti(this.arrowRef));
    // ids
    it(this, "arrowId", H(cs()));
    N(this, ki, /* @__PURE__ */ L(() => {
      if (typeof this.opts.style == "string") return Xo(this.opts.style);
      if (!this.opts.style) return {};
    }));
    N(this, sa);
    N(this, Ei, new ov(() => this.arrowRef.current ?? void 0));
    N(this, aa, /* @__PURE__ */ L(() => {
      var t;
      return ((t = f(this, Ei)) == null ? void 0 : t.width) ?? 0;
    }));
    N(this, Oi, /* @__PURE__ */ L(() => {
      var t;
      return ((t = f(this, Ei)) == null ? void 0 : t.height) ?? 0;
    }));
    N(this, la, /* @__PURE__ */ L(() => {
      var t;
      return ((t = this.opts.side) == null ? void 0 : t.current) + (this.opts.align.current !== "center" ? `-${this.opts.align.current}` : "");
    }));
    N(this, Ti, /* @__PURE__ */ L(() => Array.isArray(this.opts.collisionBoundary.current) ? this.opts.collisionBoundary.current : [this.opts.collisionBoundary.current]));
    N(this, Pi, /* @__PURE__ */ L(() => l(f(this, Ti)).length > 0));
    N(this, Ii, /* @__PURE__ */ L(() => ({
      padding: this.opts.collisionPadding.current,
      boundary: l(f(this, Ti)).filter(Iv),
      altBoundary: this.hasExplicitBoundaries
    })));
    N(this, Ni, /* @__PURE__ */ ct(void 0));
    N(this, Ri, /* @__PURE__ */ ct(void 0));
    N(this, Fi, /* @__PURE__ */ ct(void 0));
    N(this, Li, /* @__PURE__ */ ct(void 0));
    N(this, Mi, /* @__PURE__ */ L(() => [
      um({
        mainAxis: this.opts.sideOffset.current + l(f(this, Oi)),
        alignmentAxis: this.opts.alignOffset.current
      }),
      this.opts.avoidCollisions.current && dm({
        mainAxis: !0,
        crossAxis: !1,
        limiter: this.opts.sticky.current === "partial" ? gm() : void 0,
        ...this.detectOverflowOptions
      }),
      this.opts.avoidCollisions.current && fm({ ...this.detectOverflowOptions }),
      hm({
        ...this.detectOverflowOptions,
        apply: ({ rects: t, availableWidth: n, availableHeight: r }) => {
          const { width: o, height: i } = t.reference;
          z(f(this, Ni), n, !0), z(f(this, Ri), r, !0), z(f(this, Fi), o, !0), z(f(this, Li), i, !0);
        }
      }),
      this.arrowRef.current && vm({
        element: this.arrowRef.current,
        padding: this.opts.arrowPadding.current
      }),
      bm({
        arrowWidth: l(f(this, aa)),
        arrowHeight: l(f(this, Oi))
      }),
      this.opts.hideWhenDetached.current && pm({
        strategy: "referenceHidden",
        ...this.detectOverflowOptions
      })
    ].filter(Boolean)));
    it(this, "floating");
    N(this, zi, /* @__PURE__ */ L(() => ym(this.floating.placement)));
    N(this, Di, /* @__PURE__ */ L(() => xm(this.floating.placement)));
    N(this, Bi, /* @__PURE__ */ L(() => {
      var t;
      return ((t = this.floating.middlewareData.arrow) == null ? void 0 : t.x) ?? 0;
    }));
    N(this, Vi, /* @__PURE__ */ L(() => {
      var t;
      return ((t = this.floating.middlewareData.arrow) == null ? void 0 : t.y) ?? 0;
    }));
    N(this, ji, /* @__PURE__ */ L(() => {
      var t;
      return ((t = this.floating.middlewareData.arrow) == null ? void 0 : t.centerOffset) !== 0;
    }));
    N(this, Wi, /* @__PURE__ */ ct());
    N(this, Ui, /* @__PURE__ */ L(() => wm[this.placedSide]));
    N(this, qi, /* @__PURE__ */ L(() => {
      var t, n, r;
      return {
        id: this.opts.wrapperId.current,
        "data-bits-floating-content-wrapper": "",
        style: {
          ...this.floating.floatingStyles,
          // keep off page when measuring
          transform: this.floating.isPositioned ? this.floating.floatingStyles.transform : "translate(0, -200%)",
          minWidth: "max-content",
          zIndex: this.contentZIndex,
          "--bits-floating-transform-origin": `${(t = this.floating.middlewareData.transformOrigin) == null ? void 0 : t.x} ${(n = this.floating.middlewareData.transformOrigin) == null ? void 0 : n.y}`,
          "--bits-floating-available-width": `${l(f(this, Ni))}px`,
          "--bits-floating-available-height": `${l(f(this, Ri))}px`,
          "--bits-floating-anchor-width": `${l(f(this, Fi))}px`,
          "--bits-floating-anchor-height": `${l(f(this, Li))}px`,
          // hide the content if using the hide middleware and should be hidden
          ...((r = this.floating.middlewareData.hide) == null ? void 0 : r.referenceHidden) && {
            visibility: "hidden",
            "pointer-events": "none"
          },
          ...l(f(this, ki))
        },
        // Floating UI calculates logical alignment based the `dir` attribute
        dir: this.opts.dir.current,
        ...this.wrapperAttachment
      };
    }));
    N(this, Ki, /* @__PURE__ */ L(() => ({
      "data-side": this.placedSide,
      "data-align": this.placedAlign,
      style: Nl({ ...l(f(this, ki)) }),
      ...this.contentAttachment
    })));
    N(this, Gi, /* @__PURE__ */ L(() => ({
      position: "absolute",
      left: this.arrowX ? `${this.arrowX}px` : void 0,
      top: this.arrowY ? `${this.arrowY}px` : void 0,
      [this.arrowBaseSide]: 0,
      "transform-origin": {
        top: "",
        right: "0 0",
        bottom: "center 0",
        left: "100% 0"
      }[this.placedSide],
      transform: {
        top: "translateY(100%)",
        right: "translateY(50%) rotate(90deg) translateX(-50%)",
        bottom: "rotate(180deg)",
        left: "translateY(50%) rotate(-90deg) translateX(50%)"
      }[this.placedSide],
      visibility: this.cannotCenterArrow ? "hidden" : void 0
    })));
    this.opts = t, this.root = n, t.customAnchor && (this.root.customAnchorNode.current = t.customAnchor.current), gn(() => t.customAnchor.current, (r) => {
      this.root.customAnchorNode.current = r;
    }), this.floating = _m({
      strategy: () => this.opts.strategy.current,
      placement: () => l(f(this, la)),
      middleware: () => this.middleware,
      reference: this.root.anchorNode,
      whileElementsMounted: (...r) => {
        var i;
        return cm(...r, {
          animationFrame: ((i = f(this, sa)) == null ? void 0 : i.current) === "always"
        });
      },
      open: () => this.opts.enabled.current,
      sideOffset: () => this.opts.sideOffset.current,
      alignOffset: () => this.opts.alignOffset.current
    }), Ie(() => {
      var r;
      this.floating.isPositioned && ((r = this.opts.onPlaced) == null || r.current());
    }), gn(() => this.contentRef.current, (r) => {
      if (!r) return;
      const o = fd(r);
      this.contentZIndex = o.getComputedStyle(r).zIndex;
    }), Ie(() => {
      this.floating.floating.current = this.wrapperRef.current;
    });
  }
  static create(t, n = !1) {
    return n ? ll.set(new ca(t, Ul.get())) : ll.set(new ca(t, Wl.get()));
  }
  get hasExplicitBoundaries() {
    return l(f(this, Pi));
  }
  set hasExplicitBoundaries(t) {
    z(f(this, Pi), t);
  }
  get detectOverflowOptions() {
    return l(f(this, Ii));
  }
  set detectOverflowOptions(t) {
    z(f(this, Ii), t);
  }
  get middleware() {
    return l(f(this, Mi));
  }
  set middleware(t) {
    z(f(this, Mi), t);
  }
  get placedSide() {
    return l(f(this, zi));
  }
  set placedSide(t) {
    z(f(this, zi), t);
  }
  get placedAlign() {
    return l(f(this, Di));
  }
  set placedAlign(t) {
    z(f(this, Di), t);
  }
  get arrowX() {
    return l(f(this, Bi));
  }
  set arrowX(t) {
    z(f(this, Bi), t);
  }
  get arrowY() {
    return l(f(this, Vi));
  }
  set arrowY(t) {
    z(f(this, Vi), t);
  }
  get cannotCenterArrow() {
    return l(f(this, ji));
  }
  set cannotCenterArrow(t) {
    z(f(this, ji), t);
  }
  get contentZIndex() {
    return l(f(this, Wi));
  }
  set contentZIndex(t) {
    z(f(this, Wi), t, !0);
  }
  get arrowBaseSide() {
    return l(f(this, Ui));
  }
  set arrowBaseSide(t) {
    z(f(this, Ui), t);
  }
  get wrapperProps() {
    return l(f(this, qi));
  }
  set wrapperProps(t) {
    z(f(this, qi), t);
  }
  get props() {
    return l(f(this, Ki));
  }
  set props(t) {
    z(f(this, Ki), t);
  }
  get arrowStyle() {
    return l(f(this, Gi));
  }
  set arrowStyle(t) {
    z(f(this, Gi), t);
  }
};
ki = new WeakMap(), sa = new WeakMap(), Ei = new WeakMap(), aa = new WeakMap(), Oi = new WeakMap(), la = new WeakMap(), Ti = new WeakMap(), Pi = new WeakMap(), Ii = new WeakMap(), Ni = new WeakMap(), Ri = new WeakMap(), Fi = new WeakMap(), Li = new WeakMap(), Mi = new WeakMap(), zi = new WeakMap(), Di = new WeakMap(), Bi = new WeakMap(), Vi = new WeakMap(), ji = new WeakMap(), Wi = new WeakMap(), Ui = new WeakMap(), qi = new WeakMap(), Ki = new WeakMap(), Gi = new WeakMap();
let cl = ca;
var Hi;
const $l = class $l {
  constructor(t, n) {
    it(this, "opts");
    it(this, "content");
    N(this, Hi, /* @__PURE__ */ L(() => ({
      id: this.opts.id.current,
      style: this.content.arrowStyle,
      "data-side": this.content.placedSide,
      ...this.content.arrowAttachment
    })));
    this.opts = t, this.content = n;
  }
  static create(t) {
    return new $l(t, ll.get());
  }
  get props() {
    return l(f(this, Hi));
  }
  set props(t) {
    z(f(this, Hi), t);
  }
};
Hi = new WeakMap();
let ul = $l;
class Vs {
  constructor(t, n) {
    it(this, "opts");
    it(this, "root");
    this.opts = t, this.root = n, t.virtualEl && t.virtualEl.current ? n.triggerNode = H.from(t.virtualEl.current) : n.triggerNode = t.ref;
  }
  static create(t, n = !1) {
    return n ? new Vs(t, Ul.get()) : new Vs(t, Wl.get());
  }
}
function bm(e) {
  return {
    name: "transformOrigin",
    options: e,
    fn(t) {
      var k, y, R;
      const { placement: n, rects: r, middlewareData: o } = t, s = ((k = o.arrow) == null ? void 0 : k.centerOffset) !== 0, d = s ? 0 : e.arrowWidth, a = s ? 0 : e.arrowHeight, [c, g] = ql(n), h = { start: "0%", center: "50%", end: "100%" }[g], p = (((y = o.arrow) == null ? void 0 : y.x) ?? 0) + d / 2, _ = (((R = o.arrow) == null ? void 0 : R.y) ?? 0) + a / 2;
      let w = "", x = "";
      return c === "bottom" ? (w = s ? h : `${p}px`, x = `${-a}px`) : c === "top" ? (w = s ? h : `${p}px`, x = `${r.floating.height + a}px`) : c === "right" ? (w = `${-a}px`, x = s ? h : `${_}px`) : c === "left" && (w = `${r.floating.width + a}px`, x = s ? h : `${_}px`), { data: { x: w, y: x } };
    }
  };
}
function ql(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
function ym(e) {
  return ql(e)[0];
}
function xm(e) {
  return ql(e)[1];
}
function Sm(e, t) {
  Kt(t, !0);
  let n = W(t, "tooltip", 3, !1);
  Bs.create(n());
  var r = _t(), o = rt(r);
  ie(o, () => t.children ?? Re), O(e, r), Gt();
}
function Cm(e, t) {
  Kt(t, !0);
  let n = W(t, "tooltip", 3, !1);
  Vs.create(
    {
      id: H.with(() => t.id),
      virtualEl: H.with(() => t.virtualEl),
      ref: t.ref
    },
    n()
  );
  var r = _t(), o = rt(r);
  ie(o, () => t.children ?? Re), O(e, r), Gt();
}
var Am = /* @__PURE__ */ to('<svg viewBox="0 0 30 10" preserveAspectRatio="none" data-arrow=""><polygon points="0,0 30,0 15,10" fill="currentColor"></polygon></svg>'), km = /* @__PURE__ */ j("<span><!></span>");
function Em(e, t) {
  Kt(t, !0);
  let n = W(t, "id", 19, cs), r = W(t, "width", 3, 10), o = W(t, "height", 3, 5), i = /* @__PURE__ */ Cn(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "id",
    "children",
    "child",
    "width",
    "height"
  ]);
  const s = /* @__PURE__ */ L(() => Er(i, { id: n() }));
  var d = _t(), a = rt(d);
  {
    var c = (h) => {
      var p = _t(), _ = rt(p);
      ie(_, () => t.child, () => ({ props: l(s) })), O(h, p);
    }, g = (h) => {
      var p = km();
      ao(p, () => ({ ...l(s) }));
      var _ = C(p);
      {
        var w = (k) => {
          var y = _t(), R = rt(y);
          ie(R, () => t.children ?? Re), O(k, y);
        }, x = (k) => {
          var y = Am();
          q(() => {
            B(y, "width", r()), B(y, "height", o());
          }), O(k, y);
        };
        U(_, (k) => {
          t.children ? k(w) : k(x, !1);
        });
      }
      O(h, p);
    };
    U(a, (h) => {
      t.child ? h(c) : h(g, !1);
    });
  }
  O(e, d), Gt();
}
function Om(e, t) {
  Kt(t, !0);
  let n = W(t, "id", 19, cs), r = W(t, "ref", 15, null), o = /* @__PURE__ */ Cn(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "id",
    "ref"
  ]);
  const i = ul.create({
    id: H.with(() => n()),
    ref: H.with(() => r(), (d) => r(d))
  }), s = /* @__PURE__ */ L(() => Er(o, i.props));
  Em(e, Rn(() => l(s))), Gt();
}
function Tm(e, t) {
  Kt(t, !0);
  let n = W(t, "side", 3, "bottom"), r = W(t, "sideOffset", 3, 0), o = W(t, "align", 3, "center"), i = W(t, "alignOffset", 3, 0), s = W(t, "arrowPadding", 3, 0), d = W(t, "avoidCollisions", 3, !0), a = W(t, "collisionBoundary", 19, () => []), c = W(t, "collisionPadding", 3, 0), g = W(t, "hideWhenDetached", 3, !1), h = W(t, "onPlaced", 3, () => {
  }), p = W(t, "sticky", 3, "partial"), _ = W(t, "updatePositionStrategy", 3, "optimized"), w = W(t, "strategy", 3, "fixed"), x = W(t, "dir", 3, "ltr"), k = W(t, "style", 19, () => ({})), y = W(t, "wrapperId", 19, cs), R = W(t, "customAnchor", 3, null), A = W(t, "tooltip", 3, !1);
  const S = cl.create(
    {
      side: H.with(() => n()),
      sideOffset: H.with(() => r()),
      align: H.with(() => o()),
      alignOffset: H.with(() => i()),
      id: H.with(() => t.id),
      arrowPadding: H.with(() => s()),
      avoidCollisions: H.with(() => d()),
      collisionBoundary: H.with(() => a()),
      collisionPadding: H.with(() => c()),
      hideWhenDetached: H.with(() => g()),
      onPlaced: H.with(() => h()),
      sticky: H.with(() => p()),
      updatePositionStrategy: H.with(() => _()),
      strategy: H.with(() => w()),
      dir: H.with(() => x()),
      style: H.with(() => k()),
      enabled: H.with(() => t.enabled),
      wrapperId: H.with(() => y()),
      customAnchor: H.with(() => R())
    },
    A()
  ), u = /* @__PURE__ */ L(() => Er(S.wrapperProps, { style: { pointerEvents: "auto" } }));
  var T = _t(), I = rt(T);
  ie(I, () => t.content ?? Re, () => ({
    props: S.props,
    wrapperProps: l(u)
  })), O(e, T), Gt();
}
function Pm(e, t) {
  Kt(t, !0), is(() => {
    var o;
    (o = t.onPlaced) == null || o.call(t);
  });
  var n = _t(), r = rt(n);
  ie(r, () => t.content ?? Re, () => ({ props: {}, wrapperProps: {} })), O(e, n), Gt();
}
function Im(e, t) {
  let n = W(t, "isStatic", 3, !1), r = /* @__PURE__ */ Cn(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "content",
    "isStatic",
    "onPlaced"
  ]);
  var o = _t(), i = rt(o);
  {
    var s = (a) => {
      Pm(a, {
        get content() {
          return t.content;
        },
        get onPlaced() {
          return t.onPlaced;
        }
      });
    }, d = (a) => {
      Tm(a, Rn(
        {
          get content() {
            return t.content;
          },
          get onPlaced() {
            return t.onPlaced;
          }
        },
        () => r
      ));
    };
    U(i, (a) => {
      n() ? a(s) : a(d, !1);
    });
  }
  O(e, o);
}
var Nm = /* @__PURE__ */ j("<!> <!>", 1);
function Hd(e, t) {
  Kt(t, !0);
  let n = W(t, "interactOutsideBehavior", 3, "close"), r = W(t, "trapFocus", 3, !0), o = W(t, "isValidEvent", 3, () => !1), i = W(t, "customAnchor", 3, null), s = W(t, "isStatic", 3, !1), d = W(t, "tooltip", 3, !1), a = /* @__PURE__ */ Cn(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "popper",
    "onEscapeKeydown",
    "escapeKeydownBehavior",
    "preventOverflowTextSelection",
    "id",
    "onPointerDown",
    "onPointerUp",
    "side",
    "sideOffset",
    "align",
    "alignOffset",
    "arrowPadding",
    "avoidCollisions",
    "collisionBoundary",
    "collisionPadding",
    "sticky",
    "hideWhenDetached",
    "updatePositionStrategy",
    "strategy",
    "dir",
    "preventScroll",
    "wrapperId",
    "style",
    "onPlaced",
    "onInteractOutside",
    "onCloseAutoFocus",
    "onOpenAutoFocus",
    "onFocusOutside",
    "interactOutsideBehavior",
    "loop",
    "trapFocus",
    "isValidEvent",
    "customAnchor",
    "isStatic",
    "enabled",
    "ref",
    "tooltip"
  ]);
  Im(e, {
    get isStatic() {
      return s();
    },
    get id() {
      return t.id;
    },
    get side() {
      return t.side;
    },
    get sideOffset() {
      return t.sideOffset;
    },
    get align() {
      return t.align;
    },
    get alignOffset() {
      return t.alignOffset;
    },
    get arrowPadding() {
      return t.arrowPadding;
    },
    get avoidCollisions() {
      return t.avoidCollisions;
    },
    get collisionBoundary() {
      return t.collisionBoundary;
    },
    get collisionPadding() {
      return t.collisionPadding;
    },
    get sticky() {
      return t.sticky;
    },
    get hideWhenDetached() {
      return t.hideWhenDetached;
    },
    get updatePositionStrategy() {
      return t.updatePositionStrategy;
    },
    get strategy() {
      return t.strategy;
    },
    get dir() {
      return t.dir;
    },
    get wrapperId() {
      return t.wrapperId;
    },
    get style() {
      return t.style;
    },
    get onPlaced() {
      return t.onPlaced;
    },
    get customAnchor() {
      return i();
    },
    get enabled() {
      return t.enabled;
    },
    get tooltip() {
      return d();
    },
    content: (g, h) => {
      let p = () => h == null ? void 0 : h().props, _ = () => h == null ? void 0 : h().wrapperProps;
      var w = Nm(), x = rt(w);
      {
        var k = (A) => {
          Wc(A, {
            get preventScroll() {
              return t.preventScroll;
            }
          });
        }, y = (A, S) => {
          {
            var u = (T) => {
              Wc(T, {
                get preventScroll() {
                  return t.preventScroll;
                }
              });
            };
            U(
              A,
              (T) => {
                t.forceMount || T(u);
              },
              S
            );
          }
        };
        U(x, (A) => {
          t.forceMount && t.enabled ? A(k) : A(y, !1);
        });
      }
      var R = F(x, 2);
      ug(R, {
        get onOpenAutoFocus() {
          return t.onOpenAutoFocus;
        },
        get onCloseAutoFocus() {
          return t.onCloseAutoFocus;
        },
        get loop() {
          return t.loop;
        },
        get enabled() {
          return t.enabled;
        },
        get trapFocus() {
          return r();
        },
        get forceMount() {
          return t.forceMount;
        },
        get ref() {
          return t.ref;
        },
        focusScope: (S, u) => {
          let T = () => u == null ? void 0 : u().props;
          Kv(S, {
            get onEscapeKeydown() {
              return t.onEscapeKeydown;
            },
            get escapeKeydownBehavior() {
              return t.escapeKeydownBehavior;
            },
            get enabled() {
              return t.enabled;
            },
            get ref() {
              return t.ref;
            },
            children: (I, b) => {
              {
                const wt = (Pt, ut) => {
                  let E = () => ut == null ? void 0 : ut().props;
                  hg(Pt, {
                    get id() {
                      return t.id;
                    },
                    get preventOverflowTextSelection() {
                      return t.preventOverflowTextSelection;
                    },
                    get onPointerDown() {
                      return t.onPointerDown;
                    },
                    get onPointerUp() {
                      return t.onPointerUp;
                    },
                    get enabled() {
                      return t.enabled;
                    },
                    get ref() {
                      return t.ref;
                    },
                    children: (V, K) => {
                      var Y = _t(), Z = rt(Y), ot = /* @__PURE__ */ cr(() => ({
                        props: Er(a, p(), E(), T(), { style: { pointerEvents: "auto" } }),
                        wrapperProps: _()
                      }));
                      ie(Z, () => t.popper ?? Re, () => l(ot)), O(V, Y);
                    },
                    $$slots: { default: !0 }
                  });
                };
                Uv(I, {
                  get id() {
                    return t.id;
                  },
                  get onInteractOutside() {
                    return t.onInteractOutside;
                  },
                  get onFocusOutside() {
                    return t.onFocusOutside;
                  },
                  get interactOutsideBehavior() {
                    return n();
                  },
                  isValidEvent: o(),
                  get enabled() {
                    return t.enabled;
                  },
                  get ref() {
                    return t.ref;
                  },
                  children: wt,
                  $$slots: { default: !0 }
                });
              }
            },
            $$slots: { default: !0 }
          });
        },
        $$slots: { focusScope: !0 }
      }), O(g, w);
    },
    $$slots: { content: !0 }
  }), Gt();
}
function Rm(e, t) {
  let n = W(t, "interactOutsideBehavior", 3, "close"), r = W(t, "trapFocus", 3, !0), o = W(t, "isValidEvent", 3, () => !1), i = W(t, "customAnchor", 3, null), s = W(t, "isStatic", 3, !1), d = /* @__PURE__ */ Cn(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "popper",
    "open",
    "onEscapeKeydown",
    "escapeKeydownBehavior",
    "preventOverflowTextSelection",
    "id",
    "onPointerDown",
    "onPointerUp",
    "side",
    "sideOffset",
    "align",
    "alignOffset",
    "arrowPadding",
    "avoidCollisions",
    "collisionBoundary",
    "collisionPadding",
    "sticky",
    "hideWhenDetached",
    "updatePositionStrategy",
    "strategy",
    "dir",
    "preventScroll",
    "wrapperId",
    "style",
    "onPlaced",
    "onInteractOutside",
    "onCloseAutoFocus",
    "onOpenAutoFocus",
    "onFocusOutside",
    "interactOutsideBehavior",
    "loop",
    "trapFocus",
    "isValidEvent",
    "customAnchor",
    "isStatic",
    "ref"
  ]);
  kv(e, {
    get open() {
      return t.open;
    },
    get ref() {
      return t.ref;
    },
    presence: (c) => {
      Hd(c, Rn(
        {
          get popper() {
            return t.popper;
          },
          get onEscapeKeydown() {
            return t.onEscapeKeydown;
          },
          get escapeKeydownBehavior() {
            return t.escapeKeydownBehavior;
          },
          get preventOverflowTextSelection() {
            return t.preventOverflowTextSelection;
          },
          get id() {
            return t.id;
          },
          get onPointerDown() {
            return t.onPointerDown;
          },
          get onPointerUp() {
            return t.onPointerUp;
          },
          get side() {
            return t.side;
          },
          get sideOffset() {
            return t.sideOffset;
          },
          get align() {
            return t.align;
          },
          get alignOffset() {
            return t.alignOffset;
          },
          get arrowPadding() {
            return t.arrowPadding;
          },
          get avoidCollisions() {
            return t.avoidCollisions;
          },
          get collisionBoundary() {
            return t.collisionBoundary;
          },
          get collisionPadding() {
            return t.collisionPadding;
          },
          get sticky() {
            return t.sticky;
          },
          get hideWhenDetached() {
            return t.hideWhenDetached;
          },
          get updatePositionStrategy() {
            return t.updatePositionStrategy;
          },
          get strategy() {
            return t.strategy;
          },
          get dir() {
            return t.dir;
          },
          get preventScroll() {
            return t.preventScroll;
          },
          get wrapperId() {
            return t.wrapperId;
          },
          get style() {
            return t.style;
          },
          get onPlaced() {
            return t.onPlaced;
          },
          get customAnchor() {
            return i();
          },
          get isStatic() {
            return s();
          },
          get enabled() {
            return t.open;
          },
          get onInteractOutside() {
            return t.onInteractOutside;
          },
          get onCloseAutoFocus() {
            return t.onCloseAutoFocus;
          },
          get onOpenAutoFocus() {
            return t.onOpenAutoFocus;
          },
          get interactOutsideBehavior() {
            return n();
          },
          get loop() {
            return t.loop;
          },
          get trapFocus() {
            return r();
          },
          isValidEvent: o(),
          get onFocusOutside() {
            return t.onFocusOutside;
          },
          forceMount: !1,
          get ref() {
            return t.ref;
          }
        },
        () => d
      ));
    },
    $$slots: { presence: !0 }
  });
}
function Fm(e, t) {
  let n = W(t, "interactOutsideBehavior", 3, "close"), r = W(t, "trapFocus", 3, !0), o = W(t, "isValidEvent", 3, () => !1), i = W(t, "customAnchor", 3, null), s = W(t, "isStatic", 3, !1), d = /* @__PURE__ */ Cn(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "popper",
    "onEscapeKeydown",
    "escapeKeydownBehavior",
    "preventOverflowTextSelection",
    "id",
    "onPointerDown",
    "onPointerUp",
    "side",
    "sideOffset",
    "align",
    "alignOffset",
    "arrowPadding",
    "avoidCollisions",
    "collisionBoundary",
    "collisionPadding",
    "sticky",
    "hideWhenDetached",
    "updatePositionStrategy",
    "strategy",
    "dir",
    "preventScroll",
    "wrapperId",
    "style",
    "onPlaced",
    "onInteractOutside",
    "onCloseAutoFocus",
    "onOpenAutoFocus",
    "onFocusOutside",
    "interactOutsideBehavior",
    "loop",
    "trapFocus",
    "isValidEvent",
    "customAnchor",
    "isStatic",
    "enabled"
  ]);
  Hd(e, Rn(
    {
      get popper() {
        return t.popper;
      },
      get onEscapeKeydown() {
        return t.onEscapeKeydown;
      },
      get escapeKeydownBehavior() {
        return t.escapeKeydownBehavior;
      },
      get preventOverflowTextSelection() {
        return t.preventOverflowTextSelection;
      },
      get id() {
        return t.id;
      },
      get onPointerDown() {
        return t.onPointerDown;
      },
      get onPointerUp() {
        return t.onPointerUp;
      },
      get side() {
        return t.side;
      },
      get sideOffset() {
        return t.sideOffset;
      },
      get align() {
        return t.align;
      },
      get alignOffset() {
        return t.alignOffset;
      },
      get arrowPadding() {
        return t.arrowPadding;
      },
      get avoidCollisions() {
        return t.avoidCollisions;
      },
      get collisionBoundary() {
        return t.collisionBoundary;
      },
      get collisionPadding() {
        return t.collisionPadding;
      },
      get sticky() {
        return t.sticky;
      },
      get hideWhenDetached() {
        return t.hideWhenDetached;
      },
      get updatePositionStrategy() {
        return t.updatePositionStrategy;
      },
      get strategy() {
        return t.strategy;
      },
      get dir() {
        return t.dir;
      },
      get preventScroll() {
        return t.preventScroll;
      },
      get wrapperId() {
        return t.wrapperId;
      },
      get style() {
        return t.style;
      },
      get onPlaced() {
        return t.onPlaced;
      },
      get customAnchor() {
        return i();
      },
      get isStatic() {
        return s();
      },
      get enabled() {
        return t.enabled;
      },
      get onInteractOutside() {
        return t.onInteractOutside;
      },
      get onCloseAutoFocus() {
        return t.onCloseAutoFocus;
      },
      get onOpenAutoFocus() {
        return t.onOpenAutoFocus;
      },
      get interactOutsideBehavior() {
        return n();
      },
      get loop() {
        return t.loop;
      },
      get trapFocus() {
        return r();
      },
      isValidEvent: o(),
      get onFocusOutside() {
        return t.onFocusOutside;
      }
    },
    () => d,
    { forceMount: !0 }
  ));
}
const dl = gv({
  component: "popover",
  parts: ["root", "trigger", "content", "close"]
}), Kl = new as("Popover.Root");
var Yi, Xi;
const tc = class tc {
  constructor(t) {
    it(this, "opts");
    N(this, Yi, /* @__PURE__ */ ct(null));
    N(this, Xi, /* @__PURE__ */ ct(null));
    this.opts = t, new Ov({
      ref: H.with(() => this.contentNode),
      open: this.opts.open,
      onComplete: () => {
        this.opts.onOpenChangeComplete.current(this.opts.open.current);
      }
    });
  }
  static create(t) {
    return Kl.set(new tc(t));
  }
  get contentNode() {
    return l(f(this, Yi));
  }
  set contentNode(t) {
    z(f(this, Yi), t, !0);
  }
  get triggerNode() {
    return l(f(this, Xi));
  }
  set triggerNode(t) {
    z(f(this, Xi), t, !0);
  }
  toggleOpen() {
    this.opts.open.current = !this.opts.open.current;
  }
  handleClose() {
    this.opts.open.current && (this.opts.open.current = !1);
  }
};
Yi = new WeakMap(), Xi = new WeakMap();
let fl = tc;
var ua, Yd, Zi;
const ec = class ec {
  constructor(t, n) {
    N(this, ua);
    it(this, "opts");
    it(this, "root");
    it(this, "attachment");
    N(this, Zi, /* @__PURE__ */ L(() => ({
      id: this.opts.id.current,
      "aria-haspopup": "dialog",
      "aria-expanded": pv(this.root.opts.open.current),
      "data-state": pd(this.root.opts.open.current),
      "aria-controls": ce(this, ua, Yd).call(this),
      [dl.trigger]: "",
      disabled: this.opts.disabled.current,
      //
      onkeydown: this.onkeydown,
      onclick: this.onclick,
      ...this.attachment
    })));
    this.opts = t, this.root = n, this.attachment = ti(this.opts.ref, (r) => this.root.triggerNode = r), this.onclick = this.onclick.bind(this), this.onkeydown = this.onkeydown.bind(this);
  }
  static create(t) {
    return new ec(t, Kl.get());
  }
  onclick(t) {
    this.opts.disabled.current || t.button === 0 && this.root.toggleOpen();
  }
  onkeydown(t) {
    this.opts.disabled.current || (t.key === mv || t.key === wv) && (t.preventDefault(), this.root.toggleOpen());
  }
  get props() {
    return l(f(this, Zi));
  }
  set props(t) {
    z(f(this, Zi), t);
  }
};
ua = new WeakSet(), Yd = function() {
  var t, n;
  if (this.root.opts.open.current && ((t = this.root.contentNode) != null && t.id))
    return (n = this.root.contentNode) == null ? void 0 : n.id;
}, Zi = new WeakMap();
let hl = ec;
var Ji, Qi;
const nc = class nc {
  constructor(t, n) {
    it(this, "opts");
    it(this, "root");
    it(this, "attachment");
    it(this, "onInteractOutside", (t) => {
      this.opts.onInteractOutside.current(t), !(t.defaultPrevented || !md(t.target) || t.target.closest(dl.selector("trigger")) === this.root.triggerNode) && this.root.handleClose();
    });
    it(this, "onEscapeKeydown", (t) => {
      this.opts.onEscapeKeydown.current(t), !t.defaultPrevented && this.root.handleClose();
    });
    it(this, "onCloseAutoFocus", (t) => {
      var n;
      this.opts.onCloseAutoFocus.current(t), !t.defaultPrevented && (t.preventDefault(), (n = this.root.triggerNode) == null || n.focus());
    });
    N(this, Ji, /* @__PURE__ */ L(() => ({ open: this.root.opts.open.current })));
    N(this, Qi, /* @__PURE__ */ L(() => ({
      id: this.opts.id.current,
      tabindex: -1,
      "data-state": pd(this.root.opts.open.current),
      [dl.content]: "",
      style: { pointerEvents: "auto" },
      ...this.attachment
    })));
    it(this, "popperProps", {
      onInteractOutside: this.onInteractOutside,
      onEscapeKeydown: this.onEscapeKeydown,
      onCloseAutoFocus: this.onCloseAutoFocus
    });
    this.opts = t, this.root = n, this.attachment = ti(this.opts.ref, (r) => this.root.contentNode = r);
  }
  static create(t) {
    return new nc(t, Kl.get());
  }
  get snippetProps() {
    return l(f(this, Ji));
  }
  set snippetProps(t) {
    z(f(this, Ji), t);
  }
  get props() {
    return l(f(this, Qi));
  }
  set props(t) {
    z(f(this, Qi), t);
  }
};
Ji = new WeakMap(), Qi = new WeakMap();
let pl = nc;
var Lm = /* @__PURE__ */ j("<div><div><!></div></div>"), Mm = /* @__PURE__ */ j("<div><div><!></div></div>");
function zm(e, t) {
  const n = Hu();
  Kt(t, !0);
  let r = W(t, "ref", 15, null), o = W(t, "id", 19, () => vd(n)), i = W(t, "forceMount", 3, !1), s = W(t, "onCloseAutoFocus", 3, Xe), d = W(t, "onEscapeKeydown", 3, Xe), a = W(t, "onInteractOutside", 3, Xe), c = W(t, "trapFocus", 3, !0), g = W(t, "preventScroll", 3, !1), h = /* @__PURE__ */ Cn(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "child",
    "children",
    "ref",
    "id",
    "forceMount",
    "onCloseAutoFocus",
    "onEscapeKeydown",
    "onInteractOutside",
    "trapFocus",
    "preventScroll"
  ]);
  const p = pl.create({
    id: H.with(() => o()),
    ref: H.with(() => r(), (R) => r(R)),
    onInteractOutside: H.with(() => a()),
    onEscapeKeydown: H.with(() => d()),
    onCloseAutoFocus: H.with(() => s())
  }), _ = /* @__PURE__ */ L(() => Er(h, p.props));
  var w = _t(), x = rt(w);
  {
    var k = (R) => {
      Fm(R, Rn(() => l(_), () => p.popperProps, {
        get ref() {
          return p.opts.ref;
        },
        get enabled() {
          return p.root.opts.open.current;
        },
        get id() {
          return o();
        },
        get trapFocus() {
          return c();
        },
        get preventScroll() {
          return g();
        },
        loop: !0,
        forceMount: !0,
        popper: (S, u) => {
          let T = () => u == null ? void 0 : u().props, I = () => u == null ? void 0 : u().wrapperProps;
          var b = _t();
          const wt = /* @__PURE__ */ L(() => Er(T(), {
            style: Qc("popover")
          }));
          var Pt = rt(b);
          {
            var ut = (V) => {
              var K = _t(), Y = rt(K), Z = /* @__PURE__ */ cr(() => ({
                props: l(wt),
                wrapperProps: I(),
                ...p.snippetProps
              }));
              ie(Y, () => t.child, () => l(Z)), O(V, K);
            }, E = (V) => {
              var K = Lm();
              ao(K, () => ({ ...I() }));
              var Y = C(K);
              ao(Y, () => ({ ...l(wt) }));
              var Z = C(Y);
              ie(Z, () => t.children ?? Re), O(V, K);
            };
            U(Pt, (V) => {
              t.child ? V(ut) : V(E, !1);
            });
          }
          O(S, b);
        },
        $$slots: { popper: !0 }
      }));
    }, y = (R, A) => {
      {
        var S = (u) => {
          Rm(u, Rn(() => l(_), () => p.popperProps, {
            get ref() {
              return p.opts.ref;
            },
            get open() {
              return p.root.opts.open.current;
            },
            get id() {
              return o();
            },
            get trapFocus() {
              return c();
            },
            get preventScroll() {
              return g();
            },
            loop: !0,
            forceMount: !1,
            popper: (I, b) => {
              let wt = () => b == null ? void 0 : b().props, Pt = () => b == null ? void 0 : b().wrapperProps;
              var ut = _t();
              const E = /* @__PURE__ */ L(() => Er(wt(), {
                style: Qc("popover")
              }));
              var V = rt(ut);
              {
                var K = (Z) => {
                  var ot = _t(), P = rt(ot), tt = /* @__PURE__ */ cr(() => ({
                    props: l(E),
                    wrapperProps: Pt(),
                    ...p.snippetProps
                  }));
                  ie(P, () => t.child, () => l(tt)), O(Z, ot);
                }, Y = (Z) => {
                  var ot = Mm();
                  ao(ot, () => ({ ...Pt() }));
                  var P = C(ot);
                  ao(P, () => ({ ...l(E) }));
                  var tt = C(P);
                  ie(tt, () => t.children ?? Re), O(Z, ot);
                };
                U(V, (Z) => {
                  t.child ? Z(K) : Z(Y, !1);
                });
              }
              O(I, ut);
            },
            $$slots: { popper: !0 }
          }));
        };
        U(
          R,
          (u) => {
            i() || u(S);
          },
          A
        );
      }
    };
    U(x, (R) => {
      i() ? R(k) : R(y, !1);
    });
  }
  O(e, w), Gt();
}
var Dm = /* @__PURE__ */ j("<button><!></button>");
function Bm(e, t) {
  const n = Hu();
  Kt(t, !0);
  let r = W(t, "id", 19, () => vd(n)), o = W(t, "ref", 15, null), i = W(t, "type", 3, "button"), s = W(t, "disabled", 3, !1), d = /* @__PURE__ */ Cn(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "children",
    "child",
    "id",
    "ref",
    "type",
    "disabled"
  ]);
  const a = hl.create({
    id: H.with(() => r()),
    ref: H.with(() => o(), (g) => o(g)),
    disabled: H.with(() => !!s())
  }), c = /* @__PURE__ */ L(() => Er(d, a.props, { type: i() }));
  Cm(e, {
    get id() {
      return r();
    },
    get ref() {
      return a.opts.ref;
    },
    children: (g, h) => {
      var p = _t(), _ = rt(p);
      {
        var w = (k) => {
          var y = _t(), R = rt(y);
          ie(R, () => t.child, () => ({ props: l(c) })), O(k, y);
        }, x = (k) => {
          var y = Dm();
          ao(y, () => ({ ...l(c) }));
          var R = C(y);
          ie(R, () => t.children ?? Re), O(k, y);
        };
        U(_, (k) => {
          t.child ? k(w) : k(x, !1);
        });
      }
      O(g, p);
    },
    $$slots: { default: !0 }
  }), Gt();
}
function Vm(e, t) {
  Kt(t, !0);
  let n = W(t, "ref", 15, null), r = /* @__PURE__ */ Cn(t, ["$$slots", "$$events", "$$legacy", "ref"]);
  Om(e, Rn(() => r, {
    "data-popover-arrow": "",
    get ref() {
      return n();
    },
    set ref(o) {
      n(o);
    }
  })), Gt();
}
function jm(e, t) {
  Kt(t, !0);
  let n = W(t, "open", 15, !1), r = W(t, "onOpenChange", 3, Xe), o = W(t, "onOpenChangeComplete", 3, Xe);
  fl.create({
    open: H.with(() => n(), (i) => {
      n(i), r()(i);
    }),
    onOpenChangeComplete: H.with(() => o())
  }), Sm(e, {
    children: (i, s) => {
      var d = _t(), a = rt(d);
      ie(a, () => t.children ?? Re), O(i, d);
    },
    $$slots: { default: !0 }
  }), Gt();
}
const Gl = "-", Wm = (e) => {
  const t = qm(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      const d = s.split(Gl);
      return d[0] === "" && d.length !== 1 && d.shift(), Xd(d, t) || Um(s);
    },
    getConflictingClassGroupIds: (s, d) => {
      const a = n[s] || [];
      return d && r[s] ? [...a, ...r[s]] : a;
    }
  };
}, Xd = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? Xd(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(Gl);
  return (s = t.validators.find(({
    validator: d
  }) => d(i))) == null ? void 0 : s.classGroupId;
}, $c = /^\[(.+)\]$/, Um = (e) => {
  if ($c.test(e)) {
    const t = $c.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, qm = (e) => {
  const {
    theme: t,
    classGroups: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const o in n)
    vl(n[o], r, o, t);
  return r;
}, vl = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? t : tu(t, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (Km(o)) {
        vl(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([i, s]) => {
      vl(s, tu(t, i), n, r);
    });
  });
}, tu = (e, t) => {
  let n = e;
  return t.split(Gl).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, Km = (e) => e.isThemeGetter, Gm = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (i, s) => {
    n.set(i, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let s = n.get(i);
      if (s !== void 0)
        return s;
      if ((s = r.get(i)) !== void 0)
        return o(i, s), s;
    },
    set(i, s) {
      n.has(i) ? n.set(i, s) : o(i, s);
    }
  };
}, gl = "!", ml = ":", Hm = ml.length, Ym = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: n
  } = e;
  let r = (o) => {
    const i = [];
    let s = 0, d = 0, a = 0, c;
    for (let w = 0; w < o.length; w++) {
      let x = o[w];
      if (s === 0 && d === 0) {
        if (x === ml) {
          i.push(o.slice(a, w)), a = w + Hm;
          continue;
        }
        if (x === "/") {
          c = w;
          continue;
        }
      }
      x === "[" ? s++ : x === "]" ? s-- : x === "(" ? d++ : x === ")" && d--;
    }
    const g = i.length === 0 ? o : o.substring(a), h = Xm(g), p = h !== g, _ = c && c > a ? c - a : void 0;
    return {
      modifiers: i,
      hasImportantModifier: p,
      baseClassName: h,
      maybePostfixModifierPosition: _
    };
  };
  if (t) {
    const o = t + ml, i = r;
    r = (s) => s.startsWith(o) ? i(s.substring(o.length)) : {
      isExternal: !0,
      modifiers: [],
      hasImportantModifier: !1,
      baseClassName: s,
      maybePostfixModifierPosition: void 0
    };
  }
  if (n) {
    const o = r;
    r = (i) => n({
      className: i,
      parseClassName: o
    });
  }
  return r;
}, Xm = (e) => e.endsWith(gl) ? e.substring(0, e.length - 1) : e.startsWith(gl) ? e.substring(1) : e, Zm = (e) => {
  const t = Object.fromEntries(e.orderSensitiveModifiers.map((r) => [r, !0]));
  return (r) => {
    if (r.length <= 1)
      return r;
    const o = [];
    let i = [];
    return r.forEach((s) => {
      s[0] === "[" || t[s] ? (o.push(...i.sort(), s), i = []) : i.push(s);
    }), o.push(...i.sort()), o;
  };
}, Jm = (e) => ({
  cache: Gm(e.cacheSize),
  parseClassName: Ym(e),
  sortModifiers: Zm(e),
  ...Wm(e)
}), Qm = /\s+/, $m = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o,
    sortModifiers: i
  } = t, s = [], d = e.trim().split(Qm);
  let a = "";
  for (let c = d.length - 1; c >= 0; c -= 1) {
    const g = d[c], {
      isExternal: h,
      modifiers: p,
      hasImportantModifier: _,
      baseClassName: w,
      maybePostfixModifierPosition: x
    } = n(g);
    if (h) {
      a = g + (a.length > 0 ? " " + a : a);
      continue;
    }
    let k = !!x, y = r(k ? w.substring(0, x) : w);
    if (!y) {
      if (!k) {
        a = g + (a.length > 0 ? " " + a : a);
        continue;
      }
      if (y = r(w), !y) {
        a = g + (a.length > 0 ? " " + a : a);
        continue;
      }
      k = !1;
    }
    const R = i(p).join(":"), A = _ ? R + gl : R, S = A + y;
    if (s.includes(S))
      continue;
    s.push(S);
    const u = o(y, k);
    for (let T = 0; T < u.length; ++T) {
      const I = u[T];
      s.push(A + I);
    }
    a = g + (a.length > 0 ? " " + a : a);
  }
  return a;
};
function t_() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = Zd(t)) && (r && (r += " "), r += n);
  return r;
}
const Zd = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = Zd(e[r])) && (n && (n += " "), n += t);
  return n;
};
function e_(e, ...t) {
  let n, r, o, i = s;
  function s(a) {
    const c = t.reduce((g, h) => h(g), e());
    return n = Jm(c), r = n.cache.get, o = n.cache.set, i = d, d(a);
  }
  function d(a) {
    const c = r(a);
    if (c)
      return c;
    const g = $m(a, n);
    return o(a, g), g;
  }
  return function() {
    return i(t_.apply(null, arguments));
  };
}
const Ve = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, Jd = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Qd = /^\((?:(\w[\w-]*):)?(.+)\)$/i, n_ = /^\d+\/\d+$/, r_ = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, o_ = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, i_ = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, s_ = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, a_ = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, io = (e) => n_.test(e), Nt = (e) => !!e && !Number.isNaN(Number(e)), pr = (e) => !!e && Number.isInteger(Number(e)), Ma = (e) => e.endsWith("%") && Nt(e.slice(0, -1)), tr = (e) => r_.test(e), l_ = () => !0, c_ = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  o_.test(e) && !i_.test(e)
), $d = () => !1, u_ = (e) => s_.test(e), d_ = (e) => a_.test(e), f_ = (e) => !at(e) && !lt(e), h_ = (e) => Vo(e, nf, $d), at = (e) => Jd.test(e), zr = (e) => Vo(e, rf, c_), za = (e) => Vo(e, __, Nt), eu = (e) => Vo(e, tf, $d), p_ = (e) => Vo(e, ef, d_), ms = (e) => Vo(e, of, u_), lt = (e) => Qd.test(e), Ho = (e) => jo(e, rf), v_ = (e) => jo(e, w_), nu = (e) => jo(e, tf), g_ = (e) => jo(e, nf), m_ = (e) => jo(e, ef), _s = (e) => jo(e, of, !0), Vo = (e, t, n) => {
  const r = Jd.exec(e);
  return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, jo = (e, t, n = !1) => {
  const r = Qd.exec(e);
  return r ? r[1] ? t(r[1]) : n : !1;
}, tf = (e) => e === "position" || e === "percentage", ef = (e) => e === "image" || e === "url", nf = (e) => e === "length" || e === "size" || e === "bg-size", rf = (e) => e === "length", __ = (e) => e === "number", w_ = (e) => e === "family-name", of = (e) => e === "shadow", b_ = () => {
  const e = Ve("color"), t = Ve("font"), n = Ve("text"), r = Ve("font-weight"), o = Ve("tracking"), i = Ve("leading"), s = Ve("breakpoint"), d = Ve("container"), a = Ve("spacing"), c = Ve("radius"), g = Ve("shadow"), h = Ve("inset-shadow"), p = Ve("text-shadow"), _ = Ve("drop-shadow"), w = Ve("blur"), x = Ve("perspective"), k = Ve("aspect"), y = Ve("ease"), R = Ve("animate"), A = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], S = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], u = () => [...S(), lt, at], T = () => ["auto", "hidden", "clip", "visible", "scroll"], I = () => ["auto", "contain", "none"], b = () => [lt, at, a], wt = () => [io, "full", "auto", ...b()], Pt = () => [pr, "none", "subgrid", lt, at], ut = () => ["auto", {
    span: ["full", pr, lt, at]
  }, pr, lt, at], E = () => [pr, "auto", lt, at], V = () => ["auto", "min", "max", "fr", lt, at], K = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], Y = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], Z = () => ["auto", ...b()], ot = () => [io, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...b()], P = () => [e, lt, at], tt = () => [...S(), nu, eu, {
    position: [lt, at]
  }], Q = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], Ct = () => ["auto", "cover", "contain", g_, h_, {
    size: [lt, at]
  }], te = () => [Ma, Ho, zr], kt = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    c,
    lt,
    at
  ], Dt = () => ["", Nt, Ho, zr], We = () => ["solid", "dashed", "dotted", "double"], Ue = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], jt = () => [Nt, Ma, nu, eu], qe = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    w,
    lt,
    at
  ], un = () => ["none", Nt, lt, at], $e = () => ["none", Nt, lt, at], dn = () => [Nt, lt, at], fn = () => [io, "full", ...b()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [tr],
      breakpoint: [tr],
      color: [l_],
      container: [tr],
      "drop-shadow": [tr],
      ease: ["in", "out", "in-out"],
      font: [f_],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [tr],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [tr],
      shadow: [tr],
      spacing: ["px", Nt],
      text: [tr],
      "text-shadow": [tr],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", io, at, lt, k]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Nt, at, lt, d]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": A()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": A()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: u()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: T()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": T()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": T()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: I()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": I()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": I()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: wt()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": wt()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": wt()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: wt()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: wt()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: wt()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: wt()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: wt()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: wt()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [pr, "auto", lt, at]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [io, "full", "auto", d, ...b()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [Nt, io, "auto", "initial", "none", at]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", Nt, lt, at]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", Nt, lt, at]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [pr, "first", "last", "none", lt, at]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": Pt()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ut()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": E()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": E()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": Pt()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ut()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": E()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": E()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": V()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": V()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: b()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": b()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": b()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...K(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...Y(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...Y()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...K()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...Y(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...Y(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": K()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...Y(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...Y()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: b()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: b()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: b()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: b()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: b()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: b()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: b()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: b()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: b()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: Z()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: Z()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: Z()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: Z()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: Z()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: Z()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: Z()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: Z()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: Z()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": b()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": b()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: ot()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [d, "screen", ...ot()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          d,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...ot()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          d,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [s]
          },
          ...ot()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...ot()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...ot()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...ot()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", n, Ho, zr]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [r, lt, za]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Ma, at]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [v_, at, t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [o, lt, at]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [Nt, "none", lt, za]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          i,
          ...b()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", lt, at]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", lt, at]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: P()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: P()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...We(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [Nt, "from-font", "auto", lt, zr]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: P()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [Nt, "auto", lt, at]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: b()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", lt, at]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", lt, at]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: tt()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: Q()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: Ct()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, pr, lt, at],
          radial: ["", lt, at],
          conic: [pr, lt, at]
        }, m_, p_]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: P()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: te()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: te()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: te()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: P()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: P()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: P()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: kt()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": kt()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": kt()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": kt()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": kt()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": kt()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": kt()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": kt()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": kt()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": kt()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": kt()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": kt()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": kt()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": kt()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": kt()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: Dt()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": Dt()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": Dt()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": Dt()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": Dt()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": Dt()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": Dt()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": Dt()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": Dt()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": Dt()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": Dt()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...We(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...We(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: P()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": P()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": P()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": P()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": P()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": P()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": P()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": P()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": P()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: P()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...We(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Nt, lt, at]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", Nt, Ho, zr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: P()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          g,
          _s,
          ms
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: P()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", h, _s, ms]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": P()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: Dt()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: P()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [Nt, zr]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": P()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": Dt()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": P()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", p, _s, ms]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": P()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [Nt, lt, at]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Ue(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Ue()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [Nt]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": jt()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": jt()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": P()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": P()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": jt()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": jt()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": P()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": P()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": jt()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": jt()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": P()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": P()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": jt()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": jt()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": P()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": P()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": jt()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": jt()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": P()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": P()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": jt()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": jt()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": P()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": P()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": jt()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": jt()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": P()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": P()
      }],
      "mask-image-radial": [{
        "mask-radial": [lt, at]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": jt()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": jt()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": P()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": P()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": S()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [Nt]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": jt()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": jt()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": P()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": P()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: tt()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: Q()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: Ct()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", lt, at]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          lt,
          at
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: qe()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [Nt, lt, at]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [Nt, lt, at]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          _,
          _s,
          ms
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": P()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", Nt, lt, at]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [Nt, lt, at]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", Nt, lt, at]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [Nt, lt, at]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", Nt, lt, at]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          lt,
          at
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": qe()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [Nt, lt, at]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [Nt, lt, at]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", Nt, lt, at]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [Nt, lt, at]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", Nt, lt, at]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [Nt, lt, at]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [Nt, lt, at]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", Nt, lt, at]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": b()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": b()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": b()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", lt, at]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [Nt, "initial", lt, at]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", y, lt, at]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [Nt, lt, at]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", R, lt, at]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [x, lt, at]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": u()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: un()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": un()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": un()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": un()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: $e()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": $e()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": $e()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": $e()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: dn()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": dn()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": dn()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [lt, at, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: u()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: fn()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": fn()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": fn()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": fn()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: P()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: P()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", lt, at]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": b()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": b()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": b()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": b()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": b()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": b()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": b()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": b()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": b()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": b()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": b()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": b()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": b()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": b()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": b()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": b()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": b()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": b()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", lt, at]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...P()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Nt, Ho, zr, za]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...P()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, y_ = /* @__PURE__ */ e_(b_);
function sf(...e) {
  return y_(Qo(e));
}
function x_(e, t) {
  Kt(t, !0);
  let n = W(t, "ref", 15, null), r = W(t, "sideOffset", 3, 4), o = W(t, "align", 3, "center"), i = /* @__PURE__ */ Cn(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "ref",
    "class",
    "sideOffset",
    "align",
    "portalProps"
  ]);
  var s = _t(), d = rt(s);
  Ur(d, () => Dv, (a, c) => {
    c(a, Rn(() => t.portalProps, {
      children: (g, h) => {
        var p = _t(), _ = rt(p);
        const w = /* @__PURE__ */ L(() => sf("tw:bg-popover tw:text-popover-foreground tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=open]:fade-in-0 tw:data-[state=closed]:zoom-out-95 tw:data-[state=open]:zoom-in-95 tw:data-[side=bottom]:slide-in-from-top-2 tw:data-[side=left]:slide-in-from-right-2 tw:data-[side=right]:slide-in-from-left-2 tw:data-[side=top]:slide-in-from-bottom-2 tw:origin-(--bits-popover-content-transform-origin) tw:outline-hidden tw:z-50 tw:w-full tw:border tw:border-black tw:p-4 tw:shadow-sm", t.class));
        Ur(_, () => zm, (x, k) => {
          k(x, Rn(
            {
              "data-slot": "popover-content",
              get sideOffset() {
                return r();
              },
              get align() {
                return o();
              },
              get class() {
                return l(w);
              }
            },
            () => i,
            {
              get ref() {
                return n();
              },
              set ref(y) {
                n(y);
              }
            }
          ));
        }), O(g, p);
      },
      $$slots: { default: !0 }
    }));
  }), O(e, s), Gt();
}
function S_(e, t) {
  Kt(t, !0);
  let n = W(t, "ref", 15, null), r = /* @__PURE__ */ Cn(t, [
    "$$slots",
    "$$events",
    "$$legacy",
    "ref",
    "class"
  ]);
  var o = _t(), i = rt(o);
  const s = /* @__PURE__ */ L(() => sf("", t.class));
  Ur(i, () => Bm, (d, a) => {
    a(d, Rn(
      {
        "data-slot": "popover-trigger",
        get class() {
          return l(s);
        }
      },
      () => r,
      {
        get ref() {
          return n();
        },
        set ref(c) {
          n(c);
        }
      }
    ));
  }), O(e, o), Gt();
}
const C_ = jm, A_ = Vm;
var k_ = (e, t, n) => t.onClick(n()), E_ = /* @__PURE__ */ j('<li class="tw:group tw:flex tw:flex-1 tw:flex-col tw:items-center xtw:gap-2 tw:@min-[16rem]:flex-row svelte-cz11mp"><button type="button" class="tw:relative tw:min-h-7.5 tw:min-w-7.5 tw:inline-flex tw:flex-col tw:items-center tw:gap-2 tw:align-middle tw:text-sm xtw:@min-[16rem]:flex-row tw:z-[1] tw:disabled:pointer-none tw:disabled:cursor-default"><div class="tw:min-w-7 tw:min-h-7 tw:flex tw:flex-col tw:items-center tw:@min-[16rem]:w-full tw:@min-[16rem]:inline-flex tw:@min-[16rem]:flex-wrap tw:@min-[16rem]:flex-row tw:text-xs tw:align-middle"><span class="tw:size-7 tw:rounded-full tw:flex tw:justify-center tw:items-center tw:shrink-0 tw:font-bold tw:bg-gray-100 tw:text-gray-800 tw:group-data-[state=completed]:bg-theme-btn-bg tw:group-data-[state=active]:bg-theme-btn-bg tw:group-data-[state=completed]:text-white tw:group-data-[state=active]:text-white"> </span></div> <div class="tw:grow tw:@min-[16rem]:grow-0 tw:text-left tw:relative"><span class="tw:absolute tw:translate-x-[-50%] tw:w-[max-content] tw:text-center tw:block tw:text-[0.675rem] tw:md:text-xs tw:font-medium tw:text-gray-800 tw:group-data-[state=completed]:text-theme-btn-bg tw:group-data-[state=active]:text-theme-btn-bg"><span class="tw:whitespace-pre-wrap tw:break-words tw:leading-none"> </span></span></div></button> <div data-line="" class="tw:@min-[16rem]:-translate-y-1 tw:-mx-2 tw:h-px tw:w-full tw:group-last:hidden tw:@max-[16rem]:mt-2 tw:@max-[16rem]:h-8 tw:@max-3xl:w-px tw:@min-[16rem]:flex-1 tw:bg-neutral-300 tw:group-data-[state=completed]:bg-theme-btn-bg"></div></li>'), O_ = /* @__PURE__ */ j('<div class="tw:@container tw:md:block"><ul class="tw:relative tw:p-0 tw:list-none tw:flex tw:flex-col tw:gap-2 tw:@min-[16rem]:flex-row tw:mt-0 tw:mb-4 svelte-cz11mp"></ul></div>');
function T_(e, t) {
  Kt(t, !0);
  const n = (i, s) => {
    let d = () => s == null ? void 0 : s().index;
    var a = E_();
    const c = /* @__PURE__ */ L(() => t.get_step_data(d()));
    var g = C(a);
    g.__click = [k_, t, d];
    var h = C(g), p = C(h), _ = C(p), w = F(h, 2), x = C(w), k = C(x), y = C(k);
    q(() => {
      B(a, "data-state", l(c).state), g.disabled = l(c).disabled, B(g, "aria-disabled", l(c).disabled), et(_, l(c).index + 1), et(y, l(c).text);
    }), O(i, a);
  };
  var r = O_(), o = C(r);
  we(o, 21, () => Array(t.total_steps), sn, (i, s, d) => {
    n(i, () => ({ index: d }));
  }), O(e, r), Gt();
}
Xn(["click"]);
const ru = (e, t) => {
  let n = /* @__PURE__ */ cr(() => qn(qn(t == null ? void 0 : t(), () => ({}), !0).className, "tw:size-5"));
  var r = P_();
  q(() => qt(r, 0, os(l(n)), "svelte-1p5uixs")), O(e, r);
}, Da = (e, t) => {
  let n = /* @__PURE__ */ cr(() => qn(qn(t == null ? void 0 : t(), () => ({}), !0).className, "tw:size-5"));
  var r = I_();
  q(() => qt(r, 0, l(n) + " tw:group-[[data-loading='true']]:hidden", "svelte-1p5uixs")), O(e, r);
}, Ba = (e, t) => {
  let n = /* @__PURE__ */ cr(() => qn(qn(t == null ? void 0 : t(), () => ({}), !0).className, "tw:size-5"));
  var r = N_();
  q(() => qt(r, 0, `${l(n)} tw:block tw:animate-[spin_0.7s_linear_infinite] tw:fill-current tw:group-[[data-loading='false']]:hidden`, "svelte-1p5uixs")), O(e, r);
}, ou = (e, t) => {
  let n = /* @__PURE__ */ cr(() => qn(qn(t == null ? void 0 : t(), () => ({}), !0).className, "tw:size-5"));
  var r = R_();
  q(() => qt(r, 0, os(l(n)), "svelte-1p5uixs")), O(e, r);
};
function iu(e, t) {
  t.wiz.prev();
}
function su(e, t, n) {
  !t.wiz.canGoNext && !n() || t.wiz.next();
}
function Va(e, t) {
  const n = e.target;
  n instanceof HTMLButtonElement && n.dispatchEvent(new CustomEvent("data:add-to-cart", {
    detail: {
      state: t.w.state_values,
      source_element: n
    },
    bubbles: !0
  }));
}
var P_ = /* @__PURE__ */ to('<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5"></path></svg>'), I_ = /* @__PURE__ */ to('<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5"></path></svg>'), N_ = /* @__PURE__ */ to('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z" data-original="#000000"></path></svg>'), R_ = /* @__PURE__ */ to('<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.148 11.479c-.101-1.428-.125-2.985-.296-4.57C15.577 4.37 14.372 2.64 12 2.64S8.423 4.37 8.148 6.908c-.171 1.586-.195 3.142-.296 4.57" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10" stroke-linejoin="bevel"></path><path d="M20.701 20.438V8.816H3.3v11.622H20.7z" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"></path></svg>'), F_ = /* @__PURE__ */ j('<button class="btn btn--smallb btn--secondary tw:py-2 tw:!min-h-[35px] tw:min-w-[100px]" type="button"><span class="tw:pointer-events-none"><span class="tw:flex tw:items-center tw:justify-center tw:gap-1 tw:w-full tw:translate-x-[4px]"><span class="tw:translate-y-px">Next</span> <!></span></span></button>'), L_ = /* @__PURE__ */ j('<button type="button" class="btn btn--small xbtn--full btn--primary tw:py-3 tw:px-0 tw:w-11 tw: tw:min-h-[30px] svelte-1p5uixs"><span class="tw:flex tw:items-center tw:justify-center tw:gap-1 tw:w-full tw:pointer-events-none"><span class="tw:sr-only">Next</span> <!></span></button>'), M_ = /* @__PURE__ */ j(`<div class="tailwindcss tw:block tw:md:hidden" data-portals-container="x-3d-product-options"><div><div class="tw:grid tw:gap-px" data-portals-container-content=""><div class="tw:flex tw:gap-px"><button type="button" class="btn btn--small xbtn--full btn--primary tw:py-3 tw:px-0 tw:w-11 tw: tw:min-h-[30px] svelte-1p5uixs"><span class="tw:flex tw:items-center tw:justify-center tw:gap-1 tw:w-full tw:pointer-events-none"><!> <span class="tw:sr-only">Back</span></span></button> <span class="tw:flex-grow tw:bg-[var(--color-background-button)] tw:text-[var(--color-text-button)] tw:uppercase tw:font-bold"><span class="tw:flex tw:items-center tw:justify-between tw:gap-2 tw:px-4 tw:w-full tw:h-full tw:translate-y-[1px]"><span> </span> <span> </span></span></span> <!> <button type="button" data-loading="false" data-btn-atc=""><span class="tw:pointer-events-none"><!> <span class="tw:flex tw:items-center tw:justify-center tw:gap-1 tw:w-full tw:group-[[data-loading='true']]:hidden"><span class="tw:sr-only">Add to Bag</span> <!></span></span></button></div> <div class="tw:w-full tw:bg-gray-300 tw:h-3.5 tw:overflow-hidden"><div class="tw:relative tw:h-4 tw:flex tw:items-center tw:justify-center"><span class="tw:bg-green-600 tw:absolute tw:inset-0 tw:h-4 f-full tw:transition-[width] tw:duration-300 tw:ease-out"></span> <span> </span></div></div></div></div></div>`), z_ = /* @__PURE__ */ j(`<div class="tw:hidden tw:md:block"><div><button class="btn btn--small btn--secondary tw:py-2 tw:!min-h-[35px] tw:min-w-[100px]" type="button"><span class="tw:pointer-events-none"><span class="tw:flex tw:items-center tw:justify-center tw:gap-1 tw:w-full tw:translate-x-[-4px]"><!> <span class="tw:translate-y-px">Back</span></span></span></button> <!> <button type="button" data-loading="false" data-btn-atc=""><span class="tw:pointer-events-none"><!> <span class="tw:flex tw:items-center tw:justify-center tw:gap-2 tw:w-full tw:group-[[data-loading='true']]:opacity-0 tw:group-[[data-loading='true']]:pointer-events-none"><span class="tw:translate-y-[1px]">Add to Bag</span> <!></span></span></button></div></div> <div><button type="button" data-loading="false" data-btn-atc=""><span class="tw:pointer-events-none"><!> <span class="tw:flex tw:items-center tw:justify-center tw:gap-2 tw:w-full tw:group-[[data-loading='true']]:opacity-0 tw:group-[[data-loading='true']]:pointer-events-none"><span class="tw:translate-y-[1px]">Add to Bag</span> <!></span></span></button></div> <!>`, 1);
function D_(e, t) {
  Kt(t, !0);
  function n() {
    var V;
    const E = (V = t.rootElement) == null ? void 0 : V.querySelector("input:invalid, select:invalid, textarea:invalid");
    return (E == null ? void 0 : E.reportValidity()) ?? !0;
  }
  let r = /* @__PURE__ */ ct(null), o = /* @__PURE__ */ ct(null);
  is(() => {
    z(o, document.querySelector(".product__primary-left"), !0), z(r, l(o) || t.portalsElement || document.body, !0);
  });
  const i = /* @__PURE__ */ L(() => !l(o));
  var s = z_(), d = rt(s), a = C(d);
  qt(a, 1, "tw:flex tw:justify-end tw:gap-2 tw:md:flex", "svelte-1p5uixs");
  var c = C(a);
  c.__click = [iu, t];
  var g = C(c), h = C(g), p = C(h);
  ru(p, () => ({ className: "tw:size-4" }));
  var _ = F(c, 2);
  {
    var w = (E) => {
      var V = F_();
      V.__click = [su, t, n];
      var K = C(V), Y = C(K), Z = F(C(Y), 2);
      Da(Z, () => ({ className: "tw:size-4" })), O(E, V);
    };
    U(_, (E) => {
      t.wiz.isLast || E(w);
    });
  }
  var x = F(_, 2);
  x.__click = [Va, t];
  var k = C(x), y = C(k);
  Ba(y, () => ({
    className: "tw:size-4 tw:pointer-events-none tw:absolute-center"
  }));
  var R = F(y, 2), A = F(C(R), 2);
  ou(A, () => ({ className: "tw:size-4" }));
  var S = F(d, 2), u = C(S);
  u.__click = [Va, t];
  var T = C(u), I = C(T);
  Ba(I, () => ({
    className: "tw:size-4 tw:pointer-events-none tw:absolute-center"
  }));
  var b = F(I, 2), wt = F(C(b), 2);
  ou(wt, () => ({ className: "tw:size-4" }));
  var Pt = F(S, 2);
  {
    var ut = (E) => {
      var V = M_(), K = C(V), Y = C(K), Z = C(Y), ot = C(Z);
      ot.__click = [iu, t];
      var P = C(ot), tt = C(P);
      ru(tt);
      var Q = F(ot, 2), Ct = C(Q), te = C(Ct), kt = C(te), Dt = F(te, 2), We = C(Dt), Ue = F(Q, 2);
      {
        var jt = (G) => {
          var pt = L_();
          pt.__click = [su, t, n];
          var Ot = C(pt), Et = F(C(Ot), 2);
          Da(Et), O(G, pt);
        };
        U(Ue, (G) => {
          t.wiz.isLast || G(jt);
        });
      }
      var qe = F(Ue, 2);
      qe.__click = [Va, t];
      var un = C(qe), $e = C(un);
      Ba($e);
      var dn = F($e, 2), fn = F(C(dn), 2);
      Da(fn);
      var Mn = F(Z, 2), Jn = C(Mn), zn = C(Jn), Dn = F(zn, 2), nt = C(Dn);
      Xu(V, () => ep(l(r))), q(
        (G) => {
          var pt;
          B(V, "data-portals-container-root-id", (pt = t.rootElement) == null ? void 0 : pt.id), qt(K, 1, `tw:p-0 tw:bg-white ${l(i) ? "tw:fixed" : "tw:relative"} tw:left-0 tw:bottom-0 tw:w-full tw:z-[2] tw:border-t tw:border-gray-200 tw:md:relative tw:md:hidden`, "svelte-1p5uixs"), ot.disabled = t.wiz.isFirst, et(kt, t.wiz.currentStep.id), et(We, G), qt(qe, 1, `btn btn--small xbtn--full btn--primary tw:py-3 tw:px-0 tw:w-11 tw: tw:group tw:min-h-[30px] tw:group ${t.wiz.isLast ? "" : "tw:!hidden"}`, "svelte-1p5uixs"), B(qe, "form", t.form_id), Br(zn, `width: ${t.wiz.percent_complete}%`), qt(Dn, 1, `tw:leading-none tw:translate-y-[1px] tw:text-[10px] tw:px-2 ${t.wiz.percent_complete > 55 ? "tw:text-white" : ""}`), et(nt, `${t.wiz.percent_complete ?? ""}%`);
        },
        [
          () => Je(t.w.pricing.total)
        ]
      ), O(E, V);
    };
    U(Pt, (E) => {
      l(r) && E(ut);
    });
  }
  q(() => {
    c.disabled = t.wiz.isFirst, qt(x, 1, `btn btn--small btn--primary tw:w-auto tw:group tw:min-h-[30px] ${t.wiz.isLast ? "" : "tw:!hidden"}`, "svelte-1p5uixs"), B(x, "form", t.form_id), qt(S, 1, `tw:md:hidden ${t.wiz.isLast ? "tw:block" : "tw:hidden"}`, "svelte-1p5uixs"), qt(u, 1, `btn btn--full btn--primary tw:group ${t.wiz.isLast ? "" : "tw:!hidden"}`, "svelte-1p5uixs"), B(u, "form", t.form_id);
  }), O(e, s), Gt();
}
Xn(["click"]);
var B_ = /* @__PURE__ */ j('<span class="t-opacity-70 tw:ml-1" data-option-value=""> </span>'), V_ = /* @__PURE__ */ j('<span class="t-opacity-70 tw:empty:hidden" data-option-value=""> </span>'), j_ = /* @__PURE__ */ j('<span class="t-opacity-70 tw:pr-0" data-option-value=""> </span>'), W_ = (e, t) => t(e.target.value), U_ = (e, t) => t(e.target.value, { report: !0 }), q_ = /* @__PURE__ */ j('<div class="input-wrapper tw:flex-grow tw:-mt-px"><input class="input svelte-18t4exc" type="text"/></div>'), K_ = (e, t) => {
  let r = e.target.value.replace("e", "");
  t(r);
}, G_ = (e, t) => t(e.target.value, { report: !0 }), H_ = /* @__PURE__ */ j('<div class="input-wrapper tw:flex-grow tw:mt-[-2px]"><input class="input svelte-18t4exc" type="text"/></div>'), Y_ = (e, t) => t(e.target.value, { report: !0 }), X_ = /* @__PURE__ */ j("<option> </option>"), Z_ = /* @__PURE__ */ j('<div class="select-wrapper"><select class="input"><option>Choose option</option><!></select></div>'), J_ = /* @__PURE__ */ j('<div><div><label class="mr-0 tw:inline-block product__label fs-body-100 tw:mr-1"> <!></label> <!> <!> <!></div> <!></div>');
function Q_(e, t) {
  Kt(t, !0);
  let n = W(t, "w", 7), r = /* @__PURE__ */ ct(void 0), o = /* @__PURE__ */ ct(void 0);
  const i = /* @__PURE__ */ L(() => An(t.field.id)), s = /* @__PURE__ */ L(() => t.field.minlength), d = /* @__PURE__ */ L(() => t.field.maxlength), a = /* @__PURE__ */ L(() => t.field.type === "numeric" && t.field.decimal && l(d) ? l(d) + 1 : l(d)), c = /* @__PURE__ */ L(() => Qe(t.field.price)), g = /* @__PURE__ */ L(() => t.field.required && l(c) > 0);
  function h(P, tt) {
    return P.type === "numeric" && P.decimal ? tt.replace(".", "").length : tt.length;
  }
  function p(P) {
    if (!l(d) || l(d) < 1) return P;
    let tt = "", Q = 0;
    for (const Ct of P) {
      if (t.field.type === "numeric" && t.field.decimal && Ct === ".") {
        tt.includes(".") || (tt += Ct);
        continue;
      }
      Q >= l(d) || (tt += Ct, Q++);
    }
    return tt;
  }
  function _(P, tt) {
    if (!tt.trim()) return !P.required;
    const Q = h(P, tt);
    if (P.minlength && Q < P.minlength || P.maxlength && Q > P.maxlength) return !1;
    if (P.type === "numeric") {
      const Ct = Number(tt);
      if (!Number.isFinite(Ct) || typeof P.min == "number" && Ct < P.min || typeof P.max == "number" && Ct > P.max) return !1;
    }
    return !0;
  }
  function w(P, tt) {
    if (!tt.trim()) return P.required ? `${P.label} is required.` : "";
    const Q = h(P, tt);
    if (P.minlength && Q < P.minlength)
      return `${P.label} must be at least ${P.minlength} characters.`;
    if (P.maxlength && Q > P.maxlength)
      return `${P.label} must be no more than ${P.maxlength} characters.`;
    if (P.type === "numeric") {
      const Ct = Number(tt);
      if (!Number.isFinite(Ct)) return `${P.label} must be a number.`;
      if (typeof P.min == "number" && Ct < P.min)
        return `${P.label} must be at least ${P.min}.`;
      if (typeof P.max == "number" && Ct > P.max)
        return `${P.label} must be no more than ${P.max}.`;
    }
    return "";
  }
  function x(P, { report: tt = !1 } = {}) {
    const Q = l(r) || l(o);
    Q && (Q.setCustomValidity(w(t.field, P)), tt && Q.reportValidity());
  }
  function k(P, { report: tt = !1 } = {}) {
    let Q = P;
    t.field.type === "numeric" && (Q = t.field.decimal === !1 ? Q.replace(/\D/g, "") : (
      // allow digit and decimal
      Q.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1")
    )), Q = p(Q), l(r) && (l(r).value = Q), x(Q, { report: tt });
    const Ct = n().dynamicFields.every((te) => {
      const kt = te.id === t.field.id ? Q : n().dynamicFieldValues[te.id] || "";
      return _(te, kt);
    });
    n().dynamicFieldValues[t.field.id] = Q, t.wiz.setFieldValue("seal_design", {
      touched: !0,
      valid: Ct,
      value: Ct ? n().selectedVariantCode : null
    });
  }
  is(() => {
    var tt, Q;
    const P = n().dynamicFieldValues[t.field.id] || "";
    t.index === 0 && !P && t.field.required && ((tt = l(r)) == null || tt.focus(), (Q = l(o)) == null || Q.focus());
  }), Ie(() => {
    const P = n().dynamicFieldValues[t.field.id] || "";
    x(P);
  });
  const y = /* @__PURE__ */ L(() => t.field.type === "select"), R = /* @__PURE__ */ L(() => !l(y));
  var A = J_(), S = C(A), u = C(S), T = C(u), I = F(T);
  {
    var b = (P) => {
      var tt = B_(), Q = C(tt);
      q((Ct) => et(Q, `+${Ct ?? ""}`), [
        () => Je(l(c), !0)
      ]), O(P, tt);
    };
    U(I, (P) => {
      l(g) && l(y) && P(b);
    });
  }
  var wt = F(u, 2);
  {
    var Pt = (P) => {
      var tt = V_(), Q = C(tt);
      q(() => et(Q, n().dynamicFieldValues[t.field.id] || "")), O(P, tt);
    };
    U(wt, (P) => {
      l(y) && P(Pt);
    });
  }
  var ut = F(wt, 2);
  {
    var E = (P) => {
      var tt = j_(), Q = C(tt);
      q((Ct) => et(Q, `+${Ct ?? ""}`), [
        () => Je(l(c), !0)
      ]), O(P, tt);
    };
    U(ut, (P) => {
      l(g) && !l(y) && P(E);
    });
  }
  var V = F(ut, 2);
  {
    var K = (P) => {
      var tt = q_(), Q = C(tt);
      Q.__input = [W_, k], Q.__change = [U_, k], co(Q, (Ct) => z(r, Ct), () => l(r)), q(() => {
        B(Q, "id", l(i)), Q.required = t.field.required, B(Q, "minlength", l(s) || void 0), B(Q, "maxlength", l(d) || void 0), ge(Q, n().dynamicFieldValues[t.field.id] || "");
      }), Jo("blur", Q, (Ct) => k(Ct.target.value, { report: !0 })), O(P, tt);
    }, Y = (P, tt) => {
      {
        var Q = (Ct) => {
          var te = H_(), kt = C(te);
          kt.__input = [K_, k], kt.__change = [G_, k], co(kt, (Dt) => z(r, Dt), () => l(r)), q(() => {
            B(kt, "id", l(i)), kt.required = t.field.required, B(kt, "inputmode", t.field.decimal ? "decimal" : "numeric"), B(kt, "min", t.field.min), B(kt, "max", t.field.max), B(kt, "minlength", l(s) || void 0), B(kt, "maxlength", l(a) || void 0), ge(kt, n().dynamicFieldValues[t.field.id] || ""), B(kt, "pattern", t.field.decimal === !1 ? "[0-9]*" : void 0);
          }), Jo("blur", kt, (Dt) => k(Dt.target.value, { report: !0 })), O(Ct, te);
        };
        U(
          P,
          (Ct) => {
            t.field.type === "numeric" && Ct(Q);
          },
          tt
        );
      }
    };
    U(V, (P) => {
      t.field.type === "text" ? P(K) : P(Y, !1);
    });
  }
  var Z = F(S, 2);
  {
    var ot = (P) => {
      var tt = Z_(), Q = C(tt);
      Pl(Q, () => n().dynamicFieldValues[t.field.id] || "");
      var Ct;
      Q.__change = [Y_, k];
      var te = C(Q);
      te.value = te.__value = "";
      var kt = F(te);
      we(kt, 17, () => t.field.options || [], sn, (Dt, We) => {
        var Ue = X_(), jt = {}, qe = C(Ue);
        q(() => {
          jt !== (jt = l(We).value) && (Ue.value = (Ue.__value = l(We).value) ?? ""), et(qe, l(We).label);
        }), O(Dt, Ue);
      }), co(Q, (Dt) => z(o, Dt), () => l(o)), q(() => {
        B(Q, "id", l(i)), Q.required = t.field.required, Ct !== (Ct = n().dynamicFieldValues[t.field.id] || "") && (Q.value = (Q.__value = n().dynamicFieldValues[t.field.id] || "") ?? "", oi(Q, n().dynamicFieldValues[t.field.id] || ""));
      }), Jo("blur", Q, (Dt) => k(Dt.target.value, { report: !0 })), O(P, tt);
    };
    U(Z, (P) => {
      t.field.type === "select" && P(ot);
    });
  }
  q(() => {
    B(A, "data-option", t.field.label), B(A, "data-value", n().dynamicFieldValues[t.field.id] || ""), B(A, "data-value-text", n().dynamicFieldValues[t.field.id] || ""), qt(A, 1, os(l(R) ? `inline-field-v2 ${l(y) ? "" : "inline-input"}` : ""), "svelte-18t4exc"), qt(S, 1, `product__label-wpper ${l(R) && !l(y) ? "tw:flex" : ""}`, "svelte-18t4exc"), B(u, "for", l(i)), et(T, `${t.field.label ?? ""}: `);
  }), O(e, A), Gt();
}
Xn(["input", "change"]);
function $_(e, t, n, r, o) {
  !t() || n() || e.target === l(r) && o();
}
var tw = /* @__PURE__ */ j('<header class="svlt-modal-header svelte-1nrr8az"><!></header>'), ew = /* @__PURE__ */ j('<footer class="svlt-modal-footer svelte-1nrr8az"><!></footer>'), nw = /* @__PURE__ */ j('<dialog><div class="svlt-modal-content svelte-1nrr8az"><button type="button" class="svlt-modal-close-btn svelte-1nrr8az" aria-label="Close modal"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="svlt-modal-close-btn-icon svelte-1nrr8az"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"></path></svg></button> <!> <main class="svlt-modal-body"><!></main> <!></div></dialog>');
function rw(e, t) {
  Kt(t, !0);
  let n = W(t, "open", 15, !1), r = W(t, "closeOnBackgroundClick", 3, !0), o = W(t, "closeOnEscape", 3, !0), i = W(t, "busy", 3, !1), s = /* @__PURE__ */ ct(null);
  Ie(() => {
    l(s) && (n() && !l(s).open ? l(s).showModal() : !n() && l(s).open && l(s).close());
  });
  function d() {
    var S;
    i() || (n(!1), (S = t.onclose) == null || S.call(t));
  }
  function a(S) {
    S.preventDefault(), !(!o() || i()) && d();
  }
  var c = nw();
  c.__click = [
    $_,
    r,
    i,
    s,
    d
  ];
  let g;
  var h = C(c), p = C(h);
  p.__click = d;
  var _ = F(p, 2);
  {
    var w = (S) => {
      var u = tw(), T = C(u);
      ie(T, () => t.header), O(S, u);
    };
    U(_, (S) => {
      t.header && S(w);
    });
  }
  var x = F(_, 2), k = C(x);
  {
    var y = (S) => {
      var u = _t(), T = rt(u);
      ie(T, () => t.children), O(S, u);
    };
    U(k, (S) => {
      t.children && S(y);
    });
  }
  var R = F(x, 2);
  {
    var A = (S) => {
      var u = ew(), T = C(u);
      ie(T, () => t.footer), O(S, u);
    };
    U(R, (S) => {
      t.footer && S(A);
    });
  }
  co(c, (S) => z(s, S), () => l(s)), q(
    (S) => {
      g = qt(c, 1, "svlt-modal svelte-1nrr8az", null, g, S), p.disabled = i();
    },
    [() => ({ busy: i() })]
  ), Jo("cancel", c, a), O(e, c), Gt();
}
Xn(["click"]);
class ow {
  constructor({ url: t }) {
    it(this, "_baseUrl");
    it(this, "_searchParams");
    this._baseUrl = new URL(t), this._searchParams = this._baseUrl.search || "?";
  }
  endpointUrl(t, n) {
    let r = typeof n == "string" ? new URLSearchParams(n) : n;
    r || (r = new URLSearchParams()), this._baseUrl.searchParams.forEach((i, s) => {
      r.set(s, i);
    });
    const o = `?${r.toString()}`;
    return `${this._baseUrl.origin}${t}${o}`;
  }
  async isSubscribed({ email: t, phone: n }) {
    var c, g;
    const r = new URLSearchParams();
    r.set("email", t), n && r.set("phone", n);
    const o = await fetch(this.endpointUrl("/v1/subscriptions", r), {
      method: "GET"
      // headers: { accept: 'application/json' },
    });
    if (!o.ok)
      return !1;
    const s = (c = (await o.json()).subscriptionEligibilities) == null ? void 0 : c[0], d = s == null ? void 0 : s.subscription, a = (g = s == null ? void 0 : s.eligibility) == null ? void 0 : g.isEligible;
    return !!(d && a);
  }
  async subscribe({ email: t, phone: n }) {
    const r = this.endpointUrl("/v1/subscriptions"), o = await fetch(r, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        signUpSourceId: "1432523",
        user: { email: t, phone: n },
        subscriptionType: "MARKETING"
      })
    });
    if (!o.ok)
      return console.error(`Error subscribing to Attentive: ${o.status}
`, await o.text()), !1;
    const s = (await o.json()).subscriptionResponses;
    let d = "";
    if (Array.isArray(s))
      for (let a = 0, c = s.length; a < c; a++) {
        const g = s[a];
        if (g.subscriptionCreationStatus) {
          d = g.subscriptionCreationStatus;
          break;
        }
      }
    return d ? !0 : (console.error(
      `Error subscribing to Attentive (unable to find "subscriptionCreationStatus"): ${o.status}
`,
      await o.text()
    ), !1);
  }
  async setAttributes({
    email: t,
    phone: n,
    attributes: r
  }) {
    const o = this.endpointUrl("/v1/attributes/custom"), i = await fetch(o, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        user: { email: t, phone: n },
        properties: r
      })
    });
    return i.ok ? !0 : (console.error(`Error setting Attentive attributes: ${i.status}
`, await i.text()), !1);
  }
  async beforeGeneratingSnapshotUrl({
    email: t,
    attributes: n,
    phone: r
  }) {
    try {
      return !(!await this.isSubscribed({ email: t, phone: r }) && !await this.subscribe({ email: t, phone: r }) || !await this.setAttributes({ email: t, attributes: n, phone: r }));
    } catch (o) {
      return console.error(o), !1;
    }
  }
}
const iw = new ow({
  url: "https://central-proxy.ziad-388.workers.dev/?__proxy=attentive&__shop=san-jose-jewelers"
});
var Hl = { exports: {} };
Hl.exports;
(function(e) {
  var t = function() {
    var n = String.fromCharCode, r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$", i = {};
    function s(a, c) {
      if (!i[a]) {
        i[a] = {};
        for (var g = 0; g < a.length; g++)
          i[a][a.charAt(g)] = g;
      }
      return i[a][c];
    }
    var d = {
      compressToBase64: function(a) {
        if (a == null) return "";
        var c = d._compress(a, 6, function(g) {
          return r.charAt(g);
        });
        switch (c.length % 4) {
          default:
          case 0:
            return c;
          case 1:
            return c + "===";
          case 2:
            return c + "==";
          case 3:
            return c + "=";
        }
      },
      decompressFromBase64: function(a) {
        return a == null ? "" : a == "" ? null : d._decompress(a.length, 32, function(c) {
          return s(r, a.charAt(c));
        });
      },
      compressToUTF16: function(a) {
        return a == null ? "" : d._compress(a, 15, function(c) {
          return n(c + 32);
        }) + " ";
      },
      decompressFromUTF16: function(a) {
        return a == null ? "" : a == "" ? null : d._decompress(a.length, 16384, function(c) {
          return a.charCodeAt(c) - 32;
        });
      },
      //compress into uint8array (UCS-2 big endian format)
      compressToUint8Array: function(a) {
        for (var c = d.compress(a), g = new Uint8Array(c.length * 2), h = 0, p = c.length; h < p; h++) {
          var _ = c.charCodeAt(h);
          g[h * 2] = _ >>> 8, g[h * 2 + 1] = _ % 256;
        }
        return g;
      },
      //decompress from uint8array (UCS-2 big endian format)
      decompressFromUint8Array: function(a) {
        if (a == null)
          return d.decompress(a);
        for (var c = new Array(a.length / 2), g = 0, h = c.length; g < h; g++)
          c[g] = a[g * 2] * 256 + a[g * 2 + 1];
        var p = [];
        return c.forEach(function(_) {
          p.push(n(_));
        }), d.decompress(p.join(""));
      },
      //compress into a string that is already URI encoded
      compressToEncodedURIComponent: function(a) {
        return a == null ? "" : d._compress(a, 6, function(c) {
          return o.charAt(c);
        });
      },
      //decompress from an output of compressToEncodedURIComponent
      decompressFromEncodedURIComponent: function(a) {
        return a == null ? "" : a == "" ? null : (a = a.replace(/ /g, "+"), d._decompress(a.length, 32, function(c) {
          return s(o, a.charAt(c));
        }));
      },
      compress: function(a) {
        return d._compress(a, 16, function(c) {
          return n(c);
        });
      },
      _compress: function(a, c, g) {
        if (a == null) return "";
        var h, p, _ = {}, w = {}, x = "", k = "", y = "", R = 2, A = 3, S = 2, u = [], T = 0, I = 0, b;
        for (b = 0; b < a.length; b += 1)
          if (x = a.charAt(b), Object.prototype.hasOwnProperty.call(_, x) || (_[x] = A++, w[x] = !0), k = y + x, Object.prototype.hasOwnProperty.call(_, k))
            y = k;
          else {
            if (Object.prototype.hasOwnProperty.call(w, y)) {
              if (y.charCodeAt(0) < 256) {
                for (h = 0; h < S; h++)
                  T = T << 1, I == c - 1 ? (I = 0, u.push(g(T)), T = 0) : I++;
                for (p = y.charCodeAt(0), h = 0; h < 8; h++)
                  T = T << 1 | p & 1, I == c - 1 ? (I = 0, u.push(g(T)), T = 0) : I++, p = p >> 1;
              } else {
                for (p = 1, h = 0; h < S; h++)
                  T = T << 1 | p, I == c - 1 ? (I = 0, u.push(g(T)), T = 0) : I++, p = 0;
                for (p = y.charCodeAt(0), h = 0; h < 16; h++)
                  T = T << 1 | p & 1, I == c - 1 ? (I = 0, u.push(g(T)), T = 0) : I++, p = p >> 1;
              }
              R--, R == 0 && (R = Math.pow(2, S), S++), delete w[y];
            } else
              for (p = _[y], h = 0; h < S; h++)
                T = T << 1 | p & 1, I == c - 1 ? (I = 0, u.push(g(T)), T = 0) : I++, p = p >> 1;
            R--, R == 0 && (R = Math.pow(2, S), S++), _[k] = A++, y = String(x);
          }
        if (y !== "") {
          if (Object.prototype.hasOwnProperty.call(w, y)) {
            if (y.charCodeAt(0) < 256) {
              for (h = 0; h < S; h++)
                T = T << 1, I == c - 1 ? (I = 0, u.push(g(T)), T = 0) : I++;
              for (p = y.charCodeAt(0), h = 0; h < 8; h++)
                T = T << 1 | p & 1, I == c - 1 ? (I = 0, u.push(g(T)), T = 0) : I++, p = p >> 1;
            } else {
              for (p = 1, h = 0; h < S; h++)
                T = T << 1 | p, I == c - 1 ? (I = 0, u.push(g(T)), T = 0) : I++, p = 0;
              for (p = y.charCodeAt(0), h = 0; h < 16; h++)
                T = T << 1 | p & 1, I == c - 1 ? (I = 0, u.push(g(T)), T = 0) : I++, p = p >> 1;
            }
            R--, R == 0 && (R = Math.pow(2, S), S++), delete w[y];
          } else
            for (p = _[y], h = 0; h < S; h++)
              T = T << 1 | p & 1, I == c - 1 ? (I = 0, u.push(g(T)), T = 0) : I++, p = p >> 1;
          R--, R == 0 && (R = Math.pow(2, S), S++);
        }
        for (p = 2, h = 0; h < S; h++)
          T = T << 1 | p & 1, I == c - 1 ? (I = 0, u.push(g(T)), T = 0) : I++, p = p >> 1;
        for (; ; )
          if (T = T << 1, I == c - 1) {
            u.push(g(T));
            break;
          } else I++;
        return u.join("");
      },
      decompress: function(a) {
        return a == null ? "" : a == "" ? null : d._decompress(a.length, 32768, function(c) {
          return a.charCodeAt(c);
        });
      },
      _decompress: function(a, c, g) {
        var h = [], p = 4, _ = 4, w = 3, x = "", k = [], y, R, A, S, u, T, I, b = { val: g(0), position: c, index: 1 };
        for (y = 0; y < 3; y += 1)
          h[y] = y;
        for (A = 0, u = Math.pow(2, 2), T = 1; T != u; )
          S = b.val & b.position, b.position >>= 1, b.position == 0 && (b.position = c, b.val = g(b.index++)), A |= (S > 0 ? 1 : 0) * T, T <<= 1;
        switch (A) {
          case 0:
            for (A = 0, u = Math.pow(2, 8), T = 1; T != u; )
              S = b.val & b.position, b.position >>= 1, b.position == 0 && (b.position = c, b.val = g(b.index++)), A |= (S > 0 ? 1 : 0) * T, T <<= 1;
            I = n(A);
            break;
          case 1:
            for (A = 0, u = Math.pow(2, 16), T = 1; T != u; )
              S = b.val & b.position, b.position >>= 1, b.position == 0 && (b.position = c, b.val = g(b.index++)), A |= (S > 0 ? 1 : 0) * T, T <<= 1;
            I = n(A);
            break;
          case 2:
            return "";
        }
        for (h[3] = I, R = I, k.push(I); ; ) {
          if (b.index > a)
            return "";
          for (A = 0, u = Math.pow(2, w), T = 1; T != u; )
            S = b.val & b.position, b.position >>= 1, b.position == 0 && (b.position = c, b.val = g(b.index++)), A |= (S > 0 ? 1 : 0) * T, T <<= 1;
          switch (I = A) {
            case 0:
              for (A = 0, u = Math.pow(2, 8), T = 1; T != u; )
                S = b.val & b.position, b.position >>= 1, b.position == 0 && (b.position = c, b.val = g(b.index++)), A |= (S > 0 ? 1 : 0) * T, T <<= 1;
              h[_++] = n(A), I = _ - 1, p--;
              break;
            case 1:
              for (A = 0, u = Math.pow(2, 16), T = 1; T != u; )
                S = b.val & b.position, b.position >>= 1, b.position == 0 && (b.position = c, b.val = g(b.index++)), A |= (S > 0 ? 1 : 0) * T, T <<= 1;
              h[_++] = n(A), I = _ - 1, p--;
              break;
            case 2:
              return k.join("");
          }
          if (p == 0 && (p = Math.pow(2, w), w++), h[I])
            x = h[I];
          else if (I === _)
            x = R + R.charAt(0);
          else
            return null;
          k.push(x), h[_++] = R + x.charAt(0), p--, R = x, p == 0 && (p = Math.pow(2, w), w++);
        }
      }
    };
    return d;
  }();
  e != null ? e.exports = t : typeof angular < "u" && angular != null && angular.module("LZString", []).factory("LZString", function() {
    return t;
  });
})(Hl);
var sw = Hl.exports;
const au = /* @__PURE__ */ Sp(sw);
class af {
  /**
   * Compresses all query parameters of a URL into a single `encconf` query parameter.
   */
  static encrypt(t) {
    const n = new URL(typeof t == "string" ? t : t.href), r = n.searchParams.toString();
    if (!r) return n;
    const o = au.compressToEncodedURIComponent(r);
    return n.search = `?encconf=${o}`, n;
  }
  /**
   * Decrypts the `encconf` query parameter back into standard search parameters.
   */
  static decrypt(t) {
    const n = new URL(typeof t == "string" ? t : t.href), r = n.searchParams.get("encconf");
    if (!r) return n;
    n.searchParams.delete("encconf");
    const o = au.decompressFromEncodedURIComponent(r);
    return o && new URLSearchParams(o).forEach((s, d) => {
      n.searchParams.append(d, s);
    }), n;
  }
}
const aw = (e, t) => {
  let n = /* @__PURE__ */ cr(() => qn(qn(t == null ? void 0 : t(), () => ({}), !0).className, "tw:size-4"));
  var r = cw();
  q(() => qt(r, 0, os(l(n)))), O(e, r);
};
async function lw(e, t, n) {
  l(t) && (await navigator.clipboard.writeText(l(t)), z(n, !0), setTimeout(() => z(n, !1), 5e3));
}
var cw = /* @__PURE__ */ to('<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"></path></svg>'), uw = /* @__PURE__ */ j("<h2>Generate Shareable Link</h2>"), dw = /* @__PURE__ */ j('<button type="submit" class="btn btn--small btn--primary tw:py-2 tw:!min-h-[35px] tw:min-w-[150px]"> </button>'), fw = (e, t) => {
  l(t) && z(t, "");
}, hw = /* @__PURE__ */ j('<p class="tw:text-red-800 tw:bg-red-50 tw:p-2 tw:text-sm tw:mt-2"> </p>'), pw = /* @__PURE__ */ j('<div class="tw:text-right"><p class="tw:text-xs tw:text-green-800 tw:bg-green-50 tw:p-2 tw:mt-2 tw:inline-block">Copied to clipboard!</p></div>'), vw = /* @__PURE__ */ j('<div class="tw:mt-4 tw:relative"><label>Generated URL</label> <div class="tw:relative"><input readonly="" class="input tw:mt-0" type="text"/> <button type="button" aria-label="Copy to clipboard" title="Copy to clipboard" class="tw:absolute tw:right-1 tw:top-1/2 tw:-translate-y-1/2 tw:cursor-pointer tw:text-gray-500 tw:hover:text-gray-700 tw:bg-white tw:flex tw:items-center tw:justify-center tw:p-2 tw:focus-visible:outline-1 tw:focus-visible:text-gray-700"><!></button></div> <!></div>'), gw = /* @__PURE__ */ j('<p>Please provide your email and we will generate a shareable link for the current snapshot:</p> <form class="tw:mt-4"><label>Email</label> <input class="input tw:mt-0" type="email" autocomplete="email" required/></form> <!> <!>', 1);
function mw(e, t) {
  Kt(t, !0);
  let n = W(t, "open", 15, !1), r = W(t, "closeOnBackgroundClick", 3, !0), o = W(t, "closeOnEscape", 3, !0), i = W(t, "busy", 3, !1), s = /* @__PURE__ */ ct(""), d = /* @__PURE__ */ ct(!1), a = /* @__PURE__ */ ct(""), c = /* @__PURE__ */ ct("");
  async function g() {
    if (!l(s)) return;
    z(d, !0), z(a, "");
    let k = new URL(t.w.current_url), y = k.toString(), R = !1;
    k.origin.includes("localhost") && (k = new URL(k), k.port = "", k.protocol = "https:", k.host = "www.sanjosewaco.com"), z(c, ""), y = af.encrypt(k.toString()).toString(), R = await iw.beforeGeneratingSnapshotUrl({
      email: l(s),
      attributes: {
        product_saved: "1",
        saved_product_url: k.toString()
      }
    }), R || z(c, "Please try again and ensure you have a valid email address."), z(d, !1), R && z(a, y, !0);
  }
  const h = /* @__PURE__ */ L(() => !l(s) || l(d) || !!l(a));
  Ie(() => {
    n() || z(a, "");
  });
  async function p(k) {
    k.preventDefault(), await g();
  }
  let _ = /* @__PURE__ */ ct(!1), w = Math.random().toString(36).slice(2);
  const x = /* @__PURE__ */ L(() => i() || l(d));
  rw(e, {
    get busy() {
      return l(x);
    },
    get closeOnBackgroundClick() {
      return r();
    },
    get closeOnEscape() {
      return o();
    },
    get onclose() {
      return t.onclose;
    },
    get open() {
      return n();
    },
    set open(R) {
      n(R);
    },
    header: (R) => {
      var A = uw();
      O(R, A);
    },
    footer: (R) => {
      var A = dw(), S = C(A);
      q(() => {
        B(A, "form", `form_${w}`), A.disabled = l(h), et(S, l(d) ? "Generating..." : "Generate URL");
      }), O(R, A);
    },
    children: (R, A) => {
      var S = gw(), u = F(rt(S), 2), T = C(u), I = F(T, 2);
      I.__input = [fw, a], qu(I, !0);
      var b = F(u, 2);
      {
        var wt = (E) => {
          var V = hw(), K = C(V);
          q(() => et(K, l(c))), O(E, V);
        };
        U(b, (E) => {
          l(c) && E(wt);
        });
      }
      var Pt = F(b, 2);
      {
        var ut = (E) => {
          var V = vw(), K = C(V), Y = F(K, 2), Z = C(Y), ot = F(Z, 2);
          ot.__click = [lw, a, _];
          var P = C(ot);
          aw(P, () => ({ className: "tw:size-4" }));
          var tt = F(Y, 2);
          {
            var Q = (Ct) => {
              var te = pw();
              O(Ct, te);
            };
            U(tt, (Ct) => {
              l(_) && Ct(Q);
            });
          }
          q(() => {
            B(K, "for", `url_${w}`), B(Z, "id", `url_${w}`), ge(Z, l(a));
          }), O(E, V);
        };
        U(Pt, (E) => {
          l(a) && E(ut);
        });
      }
      q(() => {
        B(u, "id", `form_${w}`), B(T, "for", `email_${w}`), B(I, "id", `email_${w}`);
      }), Jo("submit", u, p), td(I, () => l(s), (E) => z(s, E)), O(R, S);
    },
    $$slots: { header: !0, footer: !0, default: !0 }
  }), Gt();
}
Xn(["input", "click"]);
var _w = /* @__PURE__ */ j(" <!>", 1), ww = /* @__PURE__ */ j(`<pre style="    xwhite-space: normal;word-break: break-all; font-size: 10px;"> <!>
</pre>`), bw = /* @__PURE__ */ j("<option> </option>"), yw = /* @__PURE__ */ j("<option> </option>"), xw = /* @__PURE__ */ j("<option> </option>"), Sw = /* @__PURE__ */ j('<div class="tw:my-2 tw:grid tw:gap-4"></div>'), Cw = /* @__PURE__ */ j("<!> <!>", 1), Aw = /* @__PURE__ */ j("<option> </option>"), kw = /* @__PURE__ */ j("<img/>"), Ew = /* @__PURE__ */ j('<span class="tw:text-sm tw:text-gray-500"> </span>'), Ow = /* @__PURE__ */ j('<span class="tw:block tw:mt-1 tw:text-xs tw:text-gray-500">Only available in 2-tone</span>'), Tw = /* @__PURE__ */ j('<div><div data-option="Two-tone"><label class="tw:cursor-pointer tw:select-none">Two-tone seal <!></label> <!></div> <!></div>'), Pw = /* @__PURE__ */ j("<!> <!>", 1), Iw = /* @__PURE__ */ j('<div class="tw:my-2"><!></div>'), Nw = /* @__PURE__ */ j("<option> </option>"), Rw = /* @__PURE__ */ j("<option> </option>"), Fw = /* @__PURE__ */ j("<option> </option>"), Lw = /* @__PURE__ */ j("<option> <!></option>"), Mw = /* @__PURE__ */ j("<option> <!></option>"), zw = /* @__PURE__ */ j('<p class="tw:text-xs tw:text-red-800 tw:bg-red-50 tw:p-2 tw:m-2"> </p>'), Dw = /* @__PURE__ */ j('<span class="tw:text-sm tw:text-gray-500"> </span>'), Bw = /* @__PURE__ */ j('<div class="contact-form__input-wrapper animation--item"><label class="tw:hidden">Engraving <span class="tw:text-sm tw:text-gray-500"><!></span></label> <div class="tw:text-xs tw:text-gray-400 tw:mt-1">3 lines max - 4 characters per line</div> <textarea class="input tw:mt-0" placeholder="Line 1 Line 2 Line 3" rows="3" style="resize: none; font-family: monospace;"></textarea> <div class="tw:text-xs tw:text-gray-400 tw:mt-1"> </div></div>'), Vw = /* @__PURE__ */ j('<div class="tw:mt-2 tw:grid tw:gap-2"><div><div data-option="Two-tone"><label class="tw:cursor-pointer tw:select-none">Add engraving? <!></label> <!></div></div> <!></div>'), jw = /* @__PURE__ */ j('<span class="tw:inline-block tw:text-xs tw:text-gray-500 tw:-translate-x-px"> </span>'), Ww = /* @__PURE__ */ to('<svg class="tw:absolute tw:inset-0 tw:text-gray-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="0.5" stroke="currentColor" style="transform: scale(1.5)"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"></path></svg>'), Uw = /* @__PURE__ */ j('<span data-swatch-bg=""><span class="tw:sr-only"> </span></span> <!> <!>', 1), qw = /* @__PURE__ */ j('<span class="tw:inline-block tw:text-xs tw:text-gray-500 tw:-translate-x-px"> </span>'), Kw = /* @__PURE__ */ j('<span data-swatch-bg=""><span class="tw:sr-only"> </span></span> <!>', 1), Gw = /* @__PURE__ */ j('<span data-swatch-bg=""><span class="tw:sr-only"> </span></span>'), Hw = /* @__PURE__ */ j('<div data-option="Logo Color" role="group"><div class="product__label-wpper tw:mb-1"><span class="mr-0 tw:inline-block product__label fs-body-100 tw:mr-1">Logo Color:</span> <span class="t-opacity-70 tw:empty:hidden" data-option-value=""> </span></div> <!></div>'), Yw = /* @__PURE__ */ j('<div class="tw:@container tw:my-2"><div class="tw:flex tw:gap-y-4 tw:gap-x-12 tw:flex-wrap"><div role="group"><div class="product__label-wpper tw:mb-1"><span class="mr-0 tw:inline-block product__label fs-body-100 tw:mr-1"> </span> <span class="t-opacity-70 tw:empty:hidden" data-option-value=""> </span></div> <!></div> <div data-option="Seal Color" role="group"><div class="product__label-wpper tw:mb-1"><span class="mr-0 tw:inline-block product__label fs-body-100 tw:mr-1">Seal Color:</span> <span class="t-opacity-70 tw:empty:hidden" data-option-value=""> </span></div> <!></div> <!></div></div>'), Xw = /* @__PURE__ */ j('<span data-swatch-bg=""></span> <span class="tw:opacity-75 tw:text-xs tw:break-words"> </span>', 1), Zw = /* @__PURE__ */ j("<!> <!>", 1), Jw = /* @__PURE__ */ j('<div class="inline-field-v2"><div class="product__label-wpper tw:relative tw:z-[3]"><span class="mr-0 tw:inline-block product__label fs-body-100 tw:mr-1"> </span> <span class="t-opacity-70 tw:empty:hidden" data-option-value=""> </span></div> <!></div> <!>', 1), Qw = /* @__PURE__ */ j('<div class="tw:@container"><p class="tw:mb-1">Gemstone Colors:</p> <div class="tw:grid tw:gap-y-4 tw:gap-x-2 tw:grid-cols-1 tw:@sm:grid-cols-2"></div></div>'), $w = /* @__PURE__ */ j('<button type="button" class="tw:ml-auto tw:underline tw:bg-transparent tw:border-none tw:hover:opacity-75 tw:cursor-pointer">Edit</button>'), tb = /* @__PURE__ */ j('<span class="tw:text-gray-500 tw:text-xs tw:translate-y-[-1px]"> </span>'), eb = /* @__PURE__ */ j('<div class="tw:flex tw:gap-2"><span></span> <span class="tw:flex tw:items-end tw:gap-2"><span> </span> <!></span> <!></div>'), nb = /* @__PURE__ */ j('<div class="tw:flex tw:gap-2"><span></span> <span> </span> <!></div>'), rb = /* @__PURE__ */ j('<span class="tw:text-gray-500 tw:text-xs tw:translate-y-[-1px]"> </span>'), ob = /* @__PURE__ */ j('<div class="tw:flex tw:gap-2"><span></span> <span class="tw:flex tw:items-end tw:gap-2"><span> </span> <!></span> <!></div>'), ib = /* @__PURE__ */ j('<div class="tw:flex tw:gap-2"><span></span> <span> </span> <!></div>'), sb = /* @__PURE__ */ j('<span class="tw:text-gray-500 tw:text-xs tw:translate-y-[-1px]"> </span>'), ab = /* @__PURE__ */ j('<div class="tw:flex tw:gap-2"><span> </span> <span class="tw:flex tw:items-end tw:gap-2"><span> </span> <!></span> <!></div>'), lb = /* @__PURE__ */ j('<span class="tw:text-gray-500 tw:text-xs tw:translate-y-[-1px]"> </span>'), cb = /* @__PURE__ */ j('<div class="tw:flex tw:gap-2"><span></span> <span class="tw:flex tw:items-end tw:gap-2"><span> </span> <!></span> <!></div>'), ub = /* @__PURE__ */ j('<span class="tw:text-gray-500 tw:text-xs tw:translate-y-[-1px]"> </span>'), db = /* @__PURE__ */ j('<div class="tw:flex tw:gap-2"><span></span> <span class="tw:flex tw:items-end tw:gap-2"><span class="tw:text-gray-500 tw:whitespace-pre-line"> </span> <!></span> <!></div>'), fb = /* @__PURE__ */ j('<div class="tw:grid tw:gap-1"><!> <!></div>'), hb = /* @__PURE__ */ j('<div class="tw:grid tw:gap-6"><h4 class="ff-heading fs-heading-5-base tw:!m-0">Review your selections</h4> <div class="tw:grid tw:gap-6 tw:text-sm"><div class="tw:grid tw:gap-1"><div class="tw:flex tw:gap-2"><span>School:</span> <span> </span> <!></div> <div class="tw:flex tw:gap-2"><span>Seal Design:</span> <span> </span> <!></div> <div class="tw:flex tw:gap-2"><span> </span> <span> </span> <!></div> <div class="tw:flex tw:gap-2"><span>Size:</span> <span> </span> <!></div> <!> <div class="tw:flex tw:gap-2"><span> </span> <span> </span> <!></div> <div class="tw:flex tw:gap-2"><span></span> <span> </span> <!></div> <!></div> <div class="tw:grid tw:gap-1"><div class="tw:flex tw:gap-2"><span></span> <span> </span> <!></div> <!> <!> <!></div> <!> <div class="tw:grid tw:border-t tw:-mx-4 tw:px-4" data-summary=""><div class="tw:flex tw:gap-2 tw:pt-2 tw:text-base tw:pl-[2px]"><span class="tw:font-bold"></span> <span> </span></div></div></div></div>'), pb = (e, t) => {
  z(t, !0);
}, vb = /* @__PURE__ */ j('<input readonly="" type="text" name="properties[Band Style]" title="Band Style"/> <input readonly="" type="text" name="properties[_band_code]" title="Band Code"/>', 1), gb = /* @__PURE__ */ j('<input readonly="" type="text" name="properties[Ring Size]" title="Ring Size"/>'), mb = /* @__PURE__ */ j('<input readonly="" type="text" name="properties[Logo Color]" title="Logo Color"/>'), _b = /* @__PURE__ */ j('<input readonly="" type="text" title="Chain"/>'), wb = /* @__PURE__ */ j('<input readonly="" type="text"/>'), bb = /* @__PURE__ */ j('<input readonly="" type="text"/>'), yb = /* @__PURE__ */ j('<input readonly="" type="text" title="Engraving"/> <!>', 1), xb = /* @__PURE__ */ j('<input readonly="" type="text" name="properties[_part3]" title="_part3"/>'), Sb = /* @__PURE__ */ j('<input readonly="" type="text"/>'), Cb = /* @__PURE__ */ j('<input readonly="" type="text" title="3d viewer url"/>'), Ab = /* @__PURE__ */ j('<input readonly="" type="text"/>'), kb = /* @__PURE__ */ j('<input readonly="" type="text" name="properties[_part1]" title="_part1"/> <input readonly="" type="text" name="properties[_part2]" title="_part2"/> <!> <!> <!> <!>', 1), Eb = /* @__PURE__ */ j('<div class="tw:grid tw:gap-2 tw:opacity-50"><input readonly="" type="text"/> <input readonly="" type="text"/> <input readonly="" type="text"/> <input readonly="" type="text" name="properties[Metal / Stone]" title="Metal / Stone"/> <!> <!> <input readonly="" type="text"/> <input readonly="" type="text" name="properties[Seal Color]" title="Seal Color"/> <!> <!> <!> <!> <!></div>'), Ob = /* @__PURE__ */ j('<div class="tw:w-full tw:overflow-hidden"><pre class="tw:overflow-x-auto tw:text-xs tw:font-mono tw:mt-4 tw:wrap-break-word tw:whitespace-break-spaces"> </pre></div>'), Tb = /* @__PURE__ */ j('<div class="tw:w-full tw:overflow-hidden"><pre class="tw:overflow-x-auto tw:text-xs tw:font-mono tw:mt-4 tw:wrap-break-word tw:whitespace-break-spaces"> </pre></div>'), Pb = /* @__PURE__ */ j('<!> <div class="product__controls-group product__block product__block--medium tw:isolate"><div class="tw:grid tw:gap-4 tw:border"><div class="tw:border-b tw:px-4 tw:py-4 tw:md:py-6"><!></div> <div class="tw:grid tw:gap-4 tw:px-4"><!> <!></div> <div><!></div></div> <div class="tw:px-4 tw:py-1" data-save-url-trigger-container=""><div class="tw:text-right"><button type="button" class="tw:underline tw:text-xs tw:text-gray-500 tw:hover:text-gray-700 tw:focus-visible:text-gray-700 tw:inline-flex tw:gap-1 tw:items-center"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"></path></svg> Save current snapshot url</button></div></div></div> <!> <!> <!> <!>', 1);
function Ib(e, t) {
  Kt(t, !0);
  const n = new URL(window.location.href), r = n.searchParams;
  let o = /* @__PURE__ */ Cn(t, ["$$slots", "$$events", "$$legacy"]), {
    schools_data: i,
    rootElement: s,
    portalsElement: d,
    widget_for: a,
    form_id: c,
    debug: g,
    update_url_params: h = !1,
    initial_query_string: p,
    bands_hashmap: _
  } = o;
  const w = t.addons_pricing.engraving, x = window.IS_DEV_ENV, y = Cc(n.searchParams.get("_debug")) || g, R = Cc(n.searchParams.get("_debug_state")) || x, A = p ? new URLSearchParams(p) : null;
  let S = /* @__PURE__ */ ct(void 0);
  Ie(() => {
    l(S) && (l(S).placeholder = `Line 1
Line 2
Line 3`);
  });
  const u = op(o, {
    rootElement: s,
    initial: A ? {
      variantCode: A.get("school_id"),
      shape: A.get("item_shape"),
      twoTone: A.get("is2tone") === "true",
      p1Code: A.get("p1code"),
      p1Color: A.get("p1color"),
      p2Color: A.get("p2color"),
      p3Color: A.get("p3color"),
      p1g1: A.get("p1g1"),
      p1g2: A.get("p1g2"),
      p1g3: A.get("p1g3"),
      p1g4: A.get("p1g4"),
      metal: A.get("metal_type"),
      stone: A.get("stone_type"),
      bandStyle: A.get("band_style"),
      ringSize: A.get("ring_size"),
      chainMetal: A.get("chain_metal"),
      chainColor: A.get("chain_color"),
      chainLength: A.get("chain_length"),
      engraving: A.get("engraving")
    } : void 0
  }), T = /* @__PURE__ */ L(() => a === "ring" && u.part1Item && Array.isArray(u.part1Item.bands) && u.part1Item.bands.length > 0), I = /* @__PURE__ */ L(() => {
    var Et;
    const nt = ((Et = u.part1Item) == null ? void 0 : Et.gemstone_groups_count) || 0, G = Array.from({ length: nt }, (Mt, Ft) => `gemstone_colors[${Ft}]`), pt = u.can_select_stone;
    return ip([
      {
        id: "Seal",
        // fields: ['school', 'style', 'seal_design', 'seal_size', w.shape.twoTone !== 'none' ? 'two_tone' : ''],
        fields: [
          "school",
          "style",
          "seal_design",
          "seal_size"
        ]
      },
      {
        id: "Band",
        // empty ids gets filtered out
        fields: [
          l(T) ? "band_style" : "",
          a === "ring" ? "ring_size" : ""
        ]
      },
      {
        id: "Metal",
        fields: ["metal", "seal_colors"]
      },
      {
        id: "Stone",
        fields: [pt ? "stone" : "", ...G]
      },
      {
        id: "Other",
        fields: [
          a === "pendant" ? "chain" : "",
          w ? "engraving" : ""
        ]
      },
      { id: "Review", fields: [], never_skip: !0 }
    ].filter((Mt) => !0));
  }), b = sp({
    ...l(I),
    initialIndex: 0
    /*steps.steps.length - 1*/
  });
  Ie(() => {
    // SJ patch: always expose controller for the stone-pattern enhancer (was debug-only)
    s.__w = u, s.__wiz = b, x && (window.w = u, window.wiz = b, window.props = o);
  }), _n(() => {
    const nt = u.metal, G = u.stone;
    b.setFieldValue("metal", { touched: !0, valid: !!nt, value: nt }), b.setFieldValue("stone", { touched: !0, valid: !!G, value: G }), oe(() => {
      u.user_interacted || (u.user_interacted = !0);
    });
  }), _n(() => {
    var Mt, Ft, be;
    const nt = (Mt = u.part1Color) == null ? void 0 : Mt.value, G = (Ft = u.part2Color) == null ? void 0 : Ft.value, pt = (be = u.part3Color) == null ? void 0 : be.value, Ot = u.twoToneSelected;
    let Et = "";
    nt && G && (Ot ? pt && (Et = `${nt} / ${G} / ${pt}`) : Et = `${nt} / ${G}`), b.setFieldValue("seal_colors", { touched: !0, valid: !!Et, value: Et });
  }), _n(() => {
    const nt = u.selected_band, G = u.ring_size;
    b.setFieldValue("band_style", {
      touched: !0,
      valid: !!nt,
      value: nt || ""
    }), b.setFieldValue("ring_size", {
      touched: !0,
      valid: !!G,
      value: G || ""
    });
  }), _n(() => {
    const nt = u.selectedVariantCode, G = u.dynamicFieldsRequiredComplete;
    b.setFieldValue("seal_design", {
      touched: !0,
      valid: G,
      value: G ? nt : null
    });
  });
  const wt = /* @__PURE__ */ L(() => {
    const nt = u.pricing;
    let G = 0, pt = b.steps.findLastIndex((Ot) => !Ot.never_skip && Ot.fields.length > 0 && Ot.fields.every((Et) => b.fields_state[Et].touched));
    if (pt > -1)
      for (let Ot = 0; Ot <= pt; Ot++) {
        const Et = b.steps[Ot];
        for (let Mt = 0; Mt < Et.fields.length; Mt++) {
          const Ft = Et.fields[Mt];
          b.fields_state[Ft].touched && (Ft === "chain" ? G += Qe(nt.chain) : Ft === "engraving" ? G += Qe(nt.engraving) : Ft === "band_style" ? G += Qe(nt.band) : Ft === "stone" ? G += Qe(nt.style_metal_stone) : Ft === "seal_design" && (G += Qe(nt.dynamic_fields)));
        }
      }
    return G;
  });
  _n(() => {
    b.resetSteps(l(I));
  }), _n(() => {
    b.stepIndex;
    const nt = b.currentStep;
    oe(() => {
      for (let G = 0, pt = nt.fields.length; G < pt; G++) {
        const Ot = nt.fields[G];
        if (Ot === "seal_design") {
          const Mt = u.dynamicFieldsRequiredComplete;
          b.setFieldValue(Ot, {
            touched: !0,
            valid: Mt,
            value: Mt ? u.selectedVariantCode : null
          });
          continue;
        }
        const Et = Ot in u.state_values ? u.state_values[Ot] : null;
        Et != null && b.setFieldValue(Ot, { touched: !0, valid: !0, value: Et });
      }
    }), oe(() => {
      u.engraving_show && !u.engraving ? u.engraving_show = !1 : u.engraving_show || (u.engraving = "");
    });
  });
  const Pt = [
    "p1code",
    "p1color",
    "p2color",
    "p3color",
    "metal_type",
    "stone_type",
    "band_style",
    "ring_size",
    "chain_metal",
    "chain_color",
    "chain_length",
    "engraving",
    "school_id",
    "item_shape",
    "is2tone",
    "p1g1",
    "p1g2",
    "p1g3",
    "p1g4"
  ];
  Ie(() => {
    var Mt, Ft, be, fe;
    let nt = u.variant.code, G = (Mt = u.shape) == null ? void 0 : Mt.value, pt = u.twoToneSelected ? "true" : "false", Ot = u.part1Item.value;
    if (vn(r, "p1code", Ot), vn(r, "p1color", (Ft = u.part1Color) == null ? void 0 : Ft.value), vn(r, "p2color", (be = u.part2Color) == null ? void 0 : be.value), vn(r, "p3color", (fe = u.part3Color) == null ? void 0 : fe.value), vn(r, "metal_type", u.metal), vn(r, "stone_type", u.stone), vn(r, "band_style", l(T) ? u.selected_band : null), vn(r, "ring_size", a === "ring" ? u.ring_size : null), vn(r, "chain_metal", a === "pendant" && u.chain_root ? u.chain.metal : null), vn(r, "chain_color", a === "pendant" && u.chain_root ? u.chain.color : null), vn(r, "chain_length", a === "pendant" && u.chain_root ? u.chain.length : null), vn(r, "engraving", u.engraving_show && u.engraving ? ys(u.engraving, { finalTrim: !0 }) : null), nt ? (r.set("school_id", nt), r.set("item_shape", G), r.set("is2tone", pt)) : (r.delete("school_id"), r.delete("item_shape"), r.delete("is2tone")), u.gemstone_colors.length > 0)
      for (let ye = 0, ue = u.gemstone_colors.length; ye < ue; ye++)
        vn(r, `p1g${ye + 1}`, u.gemstone_colors[ye].value);
    const Et = `${window.location.origin}${window.location.pathname}`;
    u.current_url = `${Et}?${r.toString()}`, h && history.replaceState(null, "", `?${r.toString()}`);
  }), h || is(() => {
    Pt.forEach((nt) => {
      vn(r, nt, "");
    }), history.replaceState(null, "", `?${r.toString()}`);
  });
  let ut = /* @__PURE__ */ ct(!1);
  var E = Pb(), V = rt(E);
  {
    var K = (nt) => {
      var G = ww(), pt = C(G), Ot = F(pt);
      we(Ot, 17, () => b.currentStep.fields, sn, (Et, Mt) => {
        var Ft = _w(), be = rt(Ft), fe = F(be);
        Nh(fe, () => `
  `), q((ye) => et(be, `${l(Mt) ?? ""}: ${ye ?? ""}`), [
          () => JSON.stringify(b.fields_state[l(Mt)].value ?? "<null>")
        ]), O(Et, Ft);
      }), q(
        (Et, Mt) => et(pt, `
  price: ${Et ?? ""}
  price_till_step: ${Mt ?? ""}

  `),
        [
          () => Je(u.pricing.total),
          () => Je(l(wt))
        ]
      ), O(nt, G);
    };
    U(V, (nt) => {
      R && nt(K);
    });
  }
  var Y = F(V, 2), Z = C(Y), ot = C(Z), P = C(ot);
  T_(P, {
    get total_steps() {
      return b.steps.length;
    },
    get_step_data: (nt) => {
      const G = b.steps[nt];
      return {
        state: b.stepIndex === nt ? "active" : nt < b.stepIndex ? "completed" : "inactive",
        index: nt,
        text: G.id,
        disabled: !1
      };
    },
    onClick: (nt) => {
      nt !== b.stepIndex && b.goToStep(nt);
    }
  });
  var tt = F(ot, 2), Q = C(tt);
  we(Q, 17, () => b.steps[b.stepIndex].fields, sn, (nt, G) => {
    var pt = _t(), Ot = rt(pt);
    {
      var Et = (Ft) => {
        $n(Ft, {
          optionName: "School",
          label: "School",
          get valueText() {
            return u.school.name;
          },
          get totalOptionsCount() {
            return i.length;
          },
          onChange: (fe) => {
            u.set_school(fe) && b.setFieldValue(l(G), { touched: !0, valid: !0, value: fe });
          },
          get value() {
            return u.selectedPart1Code;
          },
          set value(fe) {
            u.selectedPart1Code = fe;
          },
          optionsSnippet: (fe) => {
            var ye = _t(), ue = rt(ye);
            we(ue, 17, () => i, ([Fe, Ke]) => Ke, (Fe, Ke) => {
              var hn = /* @__PURE__ */ L(() => ka(l(Ke), 2));
              let Zt = () => l(hn)[1];
              var he = bw(), ke = {}, Le = C(he);
              q(() => {
                ke !== (ke = Zt().name) && (he.value = (he.__value = Zt().name) ?? ""), er(he, Zt().name === u.selectedSchool), et(Le, Zt().name);
              }), O(Fe, he);
            }), O(fe, ye);
          },
          $$slots: { optionsSnippet: !0 }
        });
      }, Mt = (Ft, be) => {
        {
          var fe = (ue) => {
            const Fe = /* @__PURE__ */ L(() => `${u.pendant_or_ring} Style`), Ke = /* @__PURE__ */ L(() => `${u.pendant_or_ring} Style`);
            $n(ue, {
              get optionName() {
                return l(Fe);
              },
              get label() {
                return l(Ke);
              },
              get valueText() {
                return u.part1ItemDisplayText;
              },
              get totalOptionsCount() {
                return u.part1List.length;
              },
              onChange: (Zt) => {
                b.setFieldValue(l(G), { touched: !0, valid: !0, value: Zt });
              },
              get value() {
                return u.selectedPart1Code;
              },
              set value(Zt) {
                u.selectedPart1Code = Zt;
              },
              optionsSnippet: (Zt) => {
                var he = _t(), ke = rt(he);
                we(ke, 17, () => u.part1List, ([Le, me]) => me.value, (Le, me) => {
                  var Ee = /* @__PURE__ */ L(() => ka(l(me), 2));
                  let Bt = () => l(Ee)[1];
                  var $ = yw();
                  const m = /* @__PURE__ */ L(() => Bt().label !== Bt().value ? `${Bt().label} (${Bt().value})` : Bt().value);
                  var M = {}, D = C($);
                  q(() => {
                    M !== (M = Bt().value) && ($.value = ($.__value = Bt().value) ?? ""), er($, Bt().value === u.selectedPart1Code), et(D, l(m));
                  }), O(Le, $);
                }), O(Zt, he);
              },
              $$slots: { optionsSnippet: !0 }
            });
          }, ye = (ue, Fe) => {
            {
              var Ke = (Zt) => {
                var he = Cw(), ke = rt(he);
                $n(ke, {
                  optionName: "Seal Design",
                  label: "Seal Design",
                  get valueText() {
                    return u.variant.name;
                  },
                  get totalOptionsCount() {
                    return u.school.variants.length;
                  },
                  placeholder: "Choose option",
                  onChange: (Bt) => {
                    const m = (t.dynamic_fields && !Array.isArray(t.dynamic_fields) ? t.dynamic_fields[Bt] || [] : []).every((M) => !M.required || !!(u.dynamicFieldValues[M.id] || "").trim());
                    b.setFieldValue(l(G), {
                      touched: !0,
                      valid: m,
                      value: m ? Bt : null
                    });
                  },
                  get value() {
                    return u.selectedVariantCode;
                  },
                  set value(Bt) {
                    u.selectedVariantCode = Bt;
                  },
                  optionsSnippet: (Bt) => {
                    var $ = _t(), m = rt($);
                    we(m, 17, () => u.school.variants, sn, (M, D) => {
                      var J = xw(), X = {}, dt = C(J);
                      q(() => {
                        X !== (X = l(D).code) && (J.value = (J.__value = l(D).code) ?? ""), er(J, l(D).code === u.selectedVariantCode), et(dt, l(D).name);
                      }), O(M, J);
                    }), O(Bt, $);
                  },
                  $$slots: { optionsSnippet: !0 }
                });
                var Le = F(ke, 2);
                {
                  var me = (Ee) => {
                    var Bt = Sw();
                    we(Bt, 21, () => u.dynamicFields, sn, ($, m, M) => {
                      Q_($, {
                        get field() {
                          return l(m);
                        },
                        get wiz() {
                          return b;
                        },
                        get w() {
                          return u;
                        },
                        get form_id() {
                          return c;
                        },
                        get rootElement() {
                          return s;
                        },
                        get portalsElement() {
                          return d;
                        },
                        index: M
                      });
                    }), O(Ee, Bt);
                  };
                  U(Le, (Ee) => {
                    u.dynamicFields.length > 0 && Ee(me);
                  });
                }
                O(Zt, he);
              }, hn = (Zt, he) => {
                {
                  var ke = (me) => {
                    var Ee = Iw(), Bt = C(Ee);
                    const $ = /* @__PURE__ */ L(() => {
                      var M;
                      return Vr(((M = u.shape) == null ? void 0 : M.value) || "");
                    }), m = /* @__PURE__ */ L(() => {
                      var M;
                      return (M = u.shape) == null ? void 0 : M.value;
                    });
                    $n(Bt, {
                      optionName: "Seal Size",
                      label: "Seal Size",
                      get valueText() {
                        return l($);
                      },
                      get value() {
                        return l(m);
                      },
                      get totalOptionsCount() {
                        return u.shapes.length;
                      },
                      inlineLabel: !1,
                      hidden: !0,
                      placeholder: "Choose option",
                      onChange: (J) => {
                        u.set_shape(J) && b.setFieldValue(l(G), { touched: !0, valid: !0, value: J });
                      },
                      optionsSnippet: (J) => {
                        var X = _t(), dt = rt(X);
                        we(dt, 17, () => u.shapes, sn, (bt, xt) => {
                          var ft = Aw(), gt = {}, At = C(ft);
                          q(
                            (Lt) => {
                              gt !== (gt = l(xt).value) && (ft.value = (ft.__value = l(xt).value) ?? ""), et(At, Lt);
                            },
                            [() => Vr(l(xt).value)]
                          ), O(bt, ft);
                        }), O(J, X);
                      },
                      afterOptionsSnippet: (J) => {
                        var X = Pw(), dt = rt(X);
                        Go(dt, {
                          get value() {
                            return u.shape;
                          },
                          setValue: (gt) => {
                            u.set_shape(gt), b.setFieldValue(l(G), { touched: !0, valid: !0, value: gt.value });
                          },
                          valueToString: (gt) => gt.value,
                          get values() {
                            return u.shapes;
                          },
                          children: (gt, At) => {
                            let Lt = () => At == null ? void 0 : At().value, St = () => At == null ? void 0 : At().checked;
                            var It = kw();
                            const Jt = /* @__PURE__ */ L(() => Vr(Lt().value));
                            q(() => {
                              B(It, "src", Lt().value === "N" ? "https://cdn.shopify.com/s/files/1/1322/7527/files/N.png?v=1748971655" : Lt().value === "E" ? "https://cdn.shopify.com/s/files/1/1322/7527/files/E.png?v=1748971207" : Lt().value === "L" ? "https://cdn.shopify.com/s/files/1/1322/7527/files/L.png?v=1748971208" : ""), B(It, "alt", l(Jt)), qt(It, 1, `tw:w-20 tw:h-20 tw:cursor-pointer  ${St() ? "tw:border-2 tw:border-solid tw:border-gray-800" : "tw:border-gray-300"}`);
                            }), O(gt, It);
                          },
                          $$slots: { default: !0 }
                        });
                        var bt = F(dt, 2);
                        {
                          var xt = (ft) => {
                            var gt = Tw(), At = C(gt);
                            qt(At, 1, "tw:flex tw:gap-4 tw:items-center");
                            var Lt = C(At), St = F(C(Lt));
                            {
                              var It = (Rt) => {
                                var ve = Ew(), ne = C(ve);
                                q((_e) => et(ne, `+${_e ?? ""}`), [
                                  () => Je(t.addons_pricing.two_tone, !0)
                                ]), O(Rt, ve);
                              };
                              U(St, (Rt) => {
                                u.shape.twoTone === "optional" && Rt(It);
                              });
                            }
                            var Jt = F(Lt, 2);
                            const xe = /* @__PURE__ */ L(() => u.shape.twoTone === "only" ? "tw:opacity-70" : ""), Ht = /* @__PURE__ */ L(() => An("two-tone")), ee = /* @__PURE__ */ L(() => u.shape.twoTone === "only");
                            Ec(Jt, {
                              get class() {
                                return l(xe);
                              },
                              get id() {
                                return l(Ht);
                              },
                              get disabled() {
                                return l(ee);
                              },
                              get checked() {
                                return u.twoToneSelected;
                              },
                              set checked(Rt) {
                                u.twoToneSelected = Rt;
                              }
                            });
                            var pe = F(At, 2);
                            {
                              var Me = (Rt) => {
                                var ve = Ow();
                                O(Rt, ve);
                              };
                              U(pe, (Rt) => {
                                u.shape.twoTone === "only" && Rt(Me);
                              });
                            }
                            q(
                              (Rt) => {
                                qt(gt, 1, `tw:mt-4 ${u.shape.twoTone === "only" ? "tw:pointer-events-none" : ""}`), B(At, "data-value", u.twoToneSelected ? "true" : "false"), B(Lt, "for", Rt);
                              },
                              [() => An("two-tone")]
                            ), O(ft, gt);
                          };
                          U(bt, (ft) => {
                            u.shape.twoTone !== "none" && ft(xt);
                          });
                        }
                        O(J, X);
                      },
                      $$slots: {
                        optionsSnippet: !0,
                        afterOptionsSnippet: !0
                      }
                    }), O(me, Ee);
                  }, Le = (me, Ee) => {
                    {
                      var Bt = (m) => {
                        $n(m, {
                          optionName: "Metal Type",
                          label: "Metal Type",
                          get valueText() {
                            return u.metal;
                          },
                          get totalOptionsCount() {
                            return u.metal_stones.metals.length;
                          },
                          placeholder: "Choose option",
                          onChange: (D, J) => {
                            const X = J.target;
                            lo().then(() => {
                              X.value != u.metal && (X.value = u.metal);
                            }), b.setFieldValue(l(G), {
                              touched: !0,
                              valid: !!u.metal,
                              value: u.metal
                            });
                          },
                          get value() {
                            return u.metal;
                          },
                          set value(D) {
                            u.metal = D;
                          },
                          optionsSnippet: (D) => {
                            var J = _t(), X = rt(J);
                            we(X, 17, () => u.metal_stones.metals, (dt) => dt.value, (dt, bt) => {
                              var xt = Nw(), ft = {}, gt = C(xt);
                              q(() => {
                                ft !== (ft = l(bt).value) && (xt.value = (xt.__value = l(bt).value) ?? ""), er(xt, l(bt).selected), xt.disabled = l(bt).disabled, et(gt, l(bt).value);
                              }), O(dt, xt);
                            }), O(D, J);
                          },
                          $$slots: { optionsSnippet: !0 }
                        });
                      }, $ = (m, M) => {
                        {
                          var D = (X) => {
                            const dt = /* @__PURE__ */ L(() => `${u.stone}`);
                            $n(X, {
                              optionName: "Stone Type",
                              label: "Stone Type",
                              get valueText() {
                                return l(dt);
                              },
                              get totalOptionsCount() {
                                return u.metal_stones.stones.length;
                              },
                              placeholder: "Choose option",
                              onChange: (xt, ft) => {
                                const gt = ft.target;
                                lo().then(() => {
                                  gt.value != u.stone && (gt.value = u.stone);
                                }), b.setFieldValue(l(G), {
                                  touched: !0,
                                  valid: !0,
                                  value: u.metal_stone
                                });
                              },
                              get value() {
                                return u.stone;
                              },
                              set value(xt) {
                                u.stone = xt;
                              },
                              optionsSnippet: (xt) => {
                                var ft = _t(), gt = rt(ft);
                                we(gt, 17, () => u.metal_stones.stones, (At) => At.value, (At, Lt) => {
                                  var St = Rw(), It = {}, Jt = C(St);
                                  q(() => {
                                    It !== (It = l(Lt).value) && (St.value = (St.__value = l(Lt).value) ?? ""), er(St, l(Lt).selected), St.disabled = l(Lt).disabled, et(Jt, l(Lt).value);
                                  }), O(At, St);
                                }), O(xt, ft);
                              },
                              $$slots: { optionsSnippet: !0 }
                            });
                          }, J = (X, dt) => {
                            {
                              var bt = (ft) => {
                                const gt = /* @__PURE__ */ L(() => `${u.ring_size}`);
                                $n(ft, {
                                  optionName: "Ring Size",
                                  label: "Ring Size",
                                  get valueText() {
                                    return l(gt);
                                  },
                                  get totalOptionsCount() {
                                    return t.ring_sizes.length;
                                  },
                                  placeholder: "Choose option",
                                  get value() {
                                    return u.ring_size;
                                  },
                                  set value(Lt) {
                                    u.ring_size = Lt;
                                  },
                                  optionsSnippet: (Lt) => {
                                    var St = _t(), It = rt(St);
                                    we(It, 16, () => t.ring_sizes, (Jt) => Jt, (Jt, xe) => {
                                      var Ht = Fw(), ee = {}, pe = C(Ht);
                                      q(() => {
                                        ee !== (ee = xe) && (Ht.value = (Ht.__value = xe) ?? ""), er(Ht, xe === u.ring_size), et(pe, xe);
                                      }), O(Jt, Ht);
                                    }), O(Lt, St);
                                  },
                                  $$slots: { optionsSnippet: !0 }
                                });
                              }, xt = (ft, gt) => {
                                {
                                  var At = (St) => {
                                    var It = _t(), Jt = rt(It);
                                    {
                                      var xe = (Ht) => {
                                        const ee = /* @__PURE__ */ L(() => u.part1Item.bands), pe = /* @__PURE__ */ L(() => {
                                          var Me;
                                          return ((Me = u.band) == null ? void 0 : Me.label) || "";
                                        });
                                        $n(Ht, {
                                          optionName: "Band Style",
                                          label: "Band Style",
                                          get valueText() {
                                            return l(pe);
                                          },
                                          get totalOptionsCount() {
                                            return l(ee).length;
                                          },
                                          placeholder: "Choose option",
                                          onChange: (Rt) => {
                                            u.selected_band = Rt;
                                          },
                                          get value() {
                                            return u.selected_band;
                                          },
                                          set value(Rt) {
                                            u.selected_band = Rt;
                                          },
                                          optionsSnippet: (Rt) => {
                                            var ve = _t(), ne = rt(ve);
                                            we(ne, 16, () => l(ee), (_e) => _e, (_e, Oe) => {
                                              var Ge = Lw();
                                              const pn = /* @__PURE__ */ L(() => u.selected_band === Oe);
                                              var ze = {}, Pe = C(Ge), Ze = F(Pe);
                                              U(Ze, (nn) => {
                                              }), q(() => {
                                                var nn;
                                                ze !== (ze = Oe) && (Ge.value = (Ge.__value = Oe) ?? ""), er(Ge, l(pn)), et(Pe, `${(((nn = _[Oe]) == null ? void 0 : nn.label) || Oe) ?? ""} `);
                                              }), O(_e, Ge);
                                            }), O(Rt, ve);
                                          },
                                          $$slots: { optionsSnippet: !0 }
                                        });
                                      };
                                      U(Jt, (Ht) => {
                                        u.part1Item && Array.isArray(u.part1Item.bands) && u.part1Item.bands.length > 0 && Ht(xe);
                                      });
                                    }
                                    O(St, It);
                                  }, Lt = (St, It) => {
                                    {
                                      var Jt = (Ht) => {
                                        var ee = _t(), pe = rt(ee);
                                        we(pe, 17, () => u.chain_facet.keys, sn, (Me, Rt) => {
                                          var ve = _t();
                                          const ne = /* @__PURE__ */ L(() => l(Rt)), _e = /* @__PURE__ */ L(() => ({
                                            metal: "Chain Metal",
                                            color: "Chain Color",
                                            length: "Chain Length"
                                          })[l(ne)]), Oe = /* @__PURE__ */ L(() => l(ne) === u.chain_facet.keys[u.chain_facet.keys.length - 1]);
                                          var Ge = rt(ve);
                                          {
                                            var pn = (Pe) => {
                                              const Ze = /* @__PURE__ */ L(() => u.chain_facet.facetOptions[l(ne)]), nn = /* @__PURE__ */ L(() => `${u.chain[l(ne)]}${l(ne) === "length" ? '"' : ""}`);
                                              $n(Pe, {
                                                get optionName() {
                                                  return l(_e);
                                                },
                                                get label() {
                                                  return l(_e);
                                                },
                                                get value() {
                                                  return u.chain[l(ne)];
                                                },
                                                get valueText() {
                                                  return l(nn);
                                                },
                                                get totalOptionsCount() {
                                                  return l(Ze).filterOptions.length;
                                                },
                                                placeholder: "Choose option",
                                                onChange: (ae, He) => {
                                                  const de = u.chain_root, De = !!de, ht = de ? de.formatted_text : "";
                                                  b.setFieldValue(l(G), { touched: !0, valid: De, value: ht }), u.chain_facet.setFilterValue(l(ne), ae), u.chain_facet.keys.forEach((Tt) => {
                                                    const Vt = u.chain_facet.getFilterValue(Tt);
                                                    u.chain[Tt] = Vt;
                                                  });
                                                },
                                                optionsSnippet: (ae) => {
                                                  var He = _t(), de = rt(He);
                                                  we(de, 16, () => l(Ze).filterOptions, (De) => De, (De, ht) => {
                                                    var Tt = Mw();
                                                    const Vt = /* @__PURE__ */ L(() => u.chain[l(ne)] === ht), Wt = /* @__PURE__ */ L(() => {
                                                      var yt;
                                                      return l(Oe) ? (yt = u.chain_facet.getRootNode({ [l(ne)]: ht })) == null ? void 0 : yt.price : null;
                                                    });
                                                    var Se = {}, zt = C(Tt), st = F(zt);
                                                    {
                                                      var mt = (yt) => {
                                                        var Yt = Oa();
                                                        q((Ut) => et(Yt, Ut), [
                                                          () => Hh(Je(l(Wt), !0))
                                                        ]), O(yt, Yt);
                                                      };
                                                      U(st, (yt) => {
                                                        l(Oe) && l(Wt) && yt(mt);
                                                      });
                                                    }
                                                    q(() => {
                                                      Se !== (Se = ht) && (Tt.value = (Tt.__value = ht) ?? ""), er(Tt, l(Vt)), et(zt, `${ht ?? ""}${l(ne) === "length" ? '"' : ""} `);
                                                    }), O(De, Tt);
                                                  }), O(ae, He);
                                                },
                                                $$slots: { optionsSnippet: !0 }
                                              });
                                            }, ze = (Pe) => {
                                              var Ze = zw(), nn = C(Ze);
                                              q(() => et(nn, `"${l(ne) ?? ""}" is not defined on chain`)), O(Pe, Ze);
                                            };
                                            U(Ge, (Pe) => {
                                              l(_e) ? Pe(pn) : Pe(ze, !1);
                                            });
                                          }
                                          O(Me, ve);
                                        }), O(Ht, ee);
                                      }, xe = (Ht, ee) => {
                                        {
                                          var pe = (Rt) => {
                                            var ve = Vw();
                                            const ne = /* @__PURE__ */ L(() => An(l(G))), _e = /* @__PURE__ */ L(() => An(l(G) + "-checkbox"));
                                            var Oe = C(ve), Ge = C(Oe);
                                            qt(Ge, 1, "tw:flex tw:gap-4 tw:items-center");
                                            var pn = C(Ge), ze = F(C(pn));
                                            {
                                              var Pe = (ae) => {
                                                var He = Dw(), de = C(He);
                                                q((De) => et(de, `+${De ?? ""}`), [() => Je(w, !0)]), O(ae, He);
                                              };
                                              U(ze, (ae) => {
                                                w && ae(Pe);
                                              });
                                            }
                                            var Ze = F(pn, 2);
                                            Ec(Ze, {
                                              get id() {
                                                return l(_e);
                                              },
                                              onchange: (ae) => {
                                                const de = ae.target.checked, De = de && u.engraving ? u.engraving : "";
                                                if (b.setFieldValue(l(G), { touched: !0, valid: !0, value: De }), de) {
                                                  const ht = document.getElementById(l(ne));
                                                  ht && requestAnimationFrame(() => {
                                                    ht.focus();
                                                  });
                                                }
                                              },
                                              get checked() {
                                                return u.engraving_show;
                                              },
                                              set checked(ae) {
                                                u.engraving_show = ae;
                                              }
                                            });
                                            var nn = F(Oe, 2);
                                            {
                                              var Rr = (ae) => {
                                                var He = Bw(), de = C(He), De = F(C(de)), ht = C(De);
                                                {
                                                  var Tt = (st) => {
                                                    var mt = Oa();
                                                    q((yt) => et(mt, `(Optional + ${yt ?? ""})`), [() => Je(w, !0)]), O(st, mt);
                                                  }, Vt = (st) => {
                                                    var mt = Oa("(Optional)");
                                                    O(st, mt);
                                                  };
                                                  U(ht, (st) => {
                                                    w ? st(Tt) : st(Vt, !1);
                                                  });
                                                }
                                                var Wt = F(de, 4);
                                                Wt.__input = (st) => {
                                                  const mt = st.target, yt = ys(mt.value);
                                                  u.engraving = yt, mt.value = yt, b.setFieldValue(l(G), {
                                                    touched: !0,
                                                    valid: !0,
                                                    value: yt
                                                  });
                                                }, Wt.__change = (st) => {
                                                  const mt = st.target, yt = ys(mt.value, { finalTrim: !0 });
                                                  u.engraving = yt, mt.value = yt, b.setFieldValue(l(G), {
                                                    touched: !0,
                                                    valid: !0,
                                                    value: yt
                                                  });
                                                }, co(Wt, (st) => z(S, st), () => l(S));
                                                var Se = F(Wt, 2), zt = C(Se);
                                                q(
                                                  (st) => {
                                                    B(de, "for", l(ne)), B(Wt, "id", l(ne)), et(zt, `${st ?? ""} / 3 lines used`);
                                                  },
                                                  [
                                                    () => u.engraving.split(`
`).filter(Boolean).length
                                                  ]
                                                ), td(Wt, () => u.engraving, (st) => u.engraving = st), O(ae, He);
                                              };
                                              U(nn, (ae) => {
                                                u.engraving_show && ae(Rr);
                                              });
                                            }
                                            q(() => {
                                              B(Ge, "data-value", u.twoToneSelected ? "true" : "false"), B(pn, "for", l(_e));
                                            }), O(Rt, ve);
                                          }, Me = (Rt, ve) => {
                                            {
                                              var ne = (Oe) => {
                                                var Ge = Yw(), pn = C(Ge), ze = C(pn), Pe = C(ze), Ze = C(Pe), nn = C(Ze), Rr = F(Ze, 2), ae = C(Rr), He = F(Pe, 2);
                                                Go(He, {
                                                  get value() {
                                                    return u.part1Color;
                                                  },
                                                  setValue: (st) => {
                                                    u.part1Color = st;
                                                  },
                                                  valueToString: (st) => st.value,
                                                  disabled: (st) => u.metal_stone === Dr && st.value !== "white",
                                                  get values() {
                                                    return u.COLORS.PARTS;
                                                  },
                                                  class: "tw:max-w-[60px]",
                                                  children: (st, mt) => {
                                                    let yt = () => mt == null ? void 0 : mt().value, Yt = () => mt == null ? void 0 : mt().checked, Ut = () => mt == null ? void 0 : mt().disabled;
                                                    var le = Uw();
                                                    const Qt = /* @__PURE__ */ L(() => {
                                                      var tn, rn;
                                                      return (rn = (tn = t.addons_pricing.metal_color_additional_price) == null ? void 0 : tn[u.metal_stone]) == null ? void 0 : rn[yt().value];
                                                    });
                                                    var re = rt(le), Ce = C(re), Ae = C(Ce), Be = F(re, 2);
                                                    {
                                                      var Ye = (tn) => {
                                                        var rn = jw(), ds = C(rn);
                                                        q((Sa) => et(ds, `+${Sa ?? ""}`), [() => Je(l(Qt), !0)]), O(tn, rn);
                                                      };
                                                      U(Be, (tn) => {
                                                        l(Qt) && !Ut() && tn(Ye);
                                                      });
                                                    }
                                                    var Te = F(Be, 2);
                                                    {
                                                      var Qn = (tn) => {
                                                        var rn = Ww();
                                                        O(tn, rn);
                                                      };
                                                      U(Te, (tn) => {
                                                        Ut() && tn(Qn);
                                                      });
                                                    }
                                                    q(() => {
                                                      qt(re, 1, `tw:mx-auto tw:w-10 tw:h-10 tw:block tw:rounded-full tw:border tw:border-solid tw:cursor-pointer ${Yt() ? "tw:border-gray-800" : "tw:border-gray-300"} ${Ut() ? "tw:opacity-40" : ""}`), Br(re, `background-color: ${yt().hex}`), et(Ae, yt().label);
                                                    }), O(st, le);
                                                  },
                                                  $$slots: { default: !0 }
                                                });
                                                var de = F(ze, 2), De = C(de), ht = F(C(De), 2), Tt = C(ht), Vt = F(De, 2);
                                                Go(Vt, {
                                                  get value() {
                                                    return u.part2Color;
                                                  },
                                                  setValue: (st) => {
                                                    u.part2Color = st;
                                                  },
                                                  valueToString: (st) => st.value,
                                                  get values() {
                                                    return u.SEAL_COLORS;
                                                  },
                                                  class: "tw:max-w-[60px]",
                                                  children: (st, mt) => {
                                                    let yt = () => mt == null ? void 0 : mt().value, Yt = () => mt == null ? void 0 : mt().checked, Ut = () => mt == null ? void 0 : mt().disabled;
                                                    var le = Kw();
                                                    const Qt = /* @__PURE__ */ L(() => {
                                                      var Te, Qn, tn, rn;
                                                      return ((Qn = (Te = t.addons_pricing.seal_color_additional_price) == null ? void 0 : Te[u.metal_stone]) == null ? void 0 : Qn[yt().value]) || ((rn = (tn = t.addons_pricing.seal_color_additional_price) == null ? void 0 : tn[u.metal]) == null ? void 0 : rn[yt().value]);
                                                    });
                                                    var re = rt(le), Ce = C(re), Ae = C(Ce), Be = F(re, 2);
                                                    {
                                                      var Ye = (Te) => {
                                                        var Qn = qw(), tn = C(Qn);
                                                        q((rn) => et(tn, `+${rn ?? ""}`), [() => Je(l(Qt), !0)]), O(Te, Qn);
                                                      };
                                                      U(Be, (Te) => {
                                                        l(Qt) && !Ut() && Te(Ye);
                                                      });
                                                    }
                                                    q(() => {
                                                      qt(re, 1, `tw:mx-auto tw:w-10 tw:h-10 tw:block tw:rounded-full tw:border tw:border-solid tw:cursor-pointer ${Yt() ? "tw:border-gray-800" : "tw:border-gray-300"}`), Br(re, `background-color: ${yt().hex}`), et(Ae, yt().label);
                                                    }), O(st, le);
                                                  },
                                                  $$slots: { default: !0 }
                                                });
                                                var Wt = F(de, 2);
                                                {
                                                  var Se = (zt) => {
                                                    var st = Hw(), mt = C(st), yt = F(C(mt), 2), Yt = C(yt), Ut = F(mt, 2);
                                                    Go(Ut, {
                                                      get value() {
                                                        return u.part3Color;
                                                      },
                                                      setValue: (Qt) => {
                                                        u.part3Color = Qt;
                                                      },
                                                      valueToString: (Qt) => Qt.value,
                                                      get values() {
                                                        return u.COLORS.PARTS;
                                                      },
                                                      class: "tw:max-w-[60px]",
                                                      children: (Qt, re) => {
                                                        let Ce = () => re == null ? void 0 : re().value, Ae = () => re == null ? void 0 : re().checked;
                                                        var Be = Gw(), Ye = C(Be), Te = C(Ye);
                                                        q(() => {
                                                          qt(Be, 1, `tw:mx-auto tw:w-10 tw:h-10 tw:block tw:rounded-full tw:border tw:border-solid tw:cursor-pointer ${Ae() ? "tw:border-gray-800" : "tw:border-gray-300"}`), Br(Be, `background-color: ${Ce().hex}`), et(Te, Ce().label);
                                                        }), O(Qt, Be);
                                                      },
                                                      $$slots: { default: !0 }
                                                    }), q(
                                                      (le, Qt, re) => {
                                                        var Ce, Ae;
                                                        B(st, "data-value", ((Ce = u.part3Color) == null ? void 0 : Ce.value) || ""), B(st, "data-value-text", ((Ae = u.part3Color) == null ? void 0 : Ae.label) || ""), B(st, "aria-labelledby", le), B(mt, "id", Qt), et(Yt, re);
                                                      },
                                                      [
                                                        () => An("logo-tone"),
                                                        () => An("logo-tone"),
                                                        () => {
                                                          var le;
                                                          return u.get_color_name_with_metal((le = u.part3Color) == null ? void 0 : le.label, "logo");
                                                        }
                                                      ]
                                                    ), O(zt, st);
                                                  };
                                                  U(Wt, (zt) => {
                                                    u.twoToneSelected && zt(Se);
                                                  });
                                                }
                                                q(
                                                  (zt, st, mt, yt, Yt, Ut) => {
                                                    var le, Qt, re, Ce;
                                                    B(ze, "data-option", `${u.pendant_or_ring} Color`), B(ze, "data-value", ((le = u.part1Color) == null ? void 0 : le.value) || ""), B(ze, "data-value-text", ((Qt = u.part1Color) == null ? void 0 : Qt.label) || ""), B(ze, "aria-labelledby", zt), B(Pe, "id", st), et(nn, `${u.pendant_or_ring ?? ""} Color:`), et(ae, mt), B(de, "data-value", ((re = u.part2Color) == null ? void 0 : re.value) || ""), B(de, "data-value-text", ((Ce = u.part2Color) == null ? void 0 : Ce.label) || ""), B(de, "aria-labelledby", yt), B(De, "id", Yt), et(Tt, Ut);
                                                  },
                                                  [
                                                    () => An(`${a}-color`),
                                                    () => An(`${a}-color`),
                                                    () => {
                                                      var zt;
                                                      return u.get_color_name_with_metal((zt = u.part1Color) == null ? void 0 : zt.label, "base");
                                                    },
                                                    () => An("seal-color"),
                                                    () => An("seal-color"),
                                                    () => {
                                                      var zt;
                                                      return u.get_color_name_with_metal((zt = u.part2Color) == null ? void 0 : zt.label, "seal");
                                                    }
                                                  ]
                                                ), O(Oe, Ge);
                                              }, _e = (Oe, Ge) => {
                                                {
                                                  var pn = (ze) => {
                                                    var Pe = Qw(), Ze = F(C(Pe), 2);
                                                    we(Ze, 21, () => ({ length: u.part1Item.gemstone_groups_count }), sn, (nn, Rr, ae) => {
                                                      var He = _t();
                                                      const de = /* @__PURE__ */ L(() => `Group ${ae + 1}`), De = /* @__PURE__ */ L(() => `${An("gemstone-color")}-${ae + 1}`), ht = /* @__PURE__ */ L(() => `${l(De)}-parent`), Tt = /* @__PURE__ */ L(() => u.gemstone_colors[ae]);
                                                      var Vt = rt(He);
                                                      Ur(Vt, () => C_, (Wt, Se) => {
                                                        Se(Wt, {
                                                          children: (zt, st) => {
                                                            var mt = Jw(), yt = rt(mt), Yt = C(yt), Ut = C(Yt), le = C(Ut), Qt = F(Ut, 2), re = C(Qt), Ce = F(Yt, 2);
                                                            Ur(Ce, () => S_, (Ye, Te) => {
                                                              Te(Ye, {
                                                                class: "tw:absolute tw:inset-0 tw:z-[4] tw:focus-visible:outline-offset-1 tw:focus-visible:outline-1"
                                                              });
                                                            });
                                                            var Ae = F(yt, 2);
                                                            const Be = /* @__PURE__ */ L(() => ({ to: d }));
                                                            Ur(Ae, () => x_, (Ye, Te) => {
                                                              Te(Ye, {
                                                                get portalProps() {
                                                                  return l(Be);
                                                                },
                                                                align: "start",
                                                                sideOffset: 0,
                                                                children: (Qn, tn) => {
                                                                  var rn = Zw(), ds = rt(rn);
                                                                  Go(ds, {
                                                                    get value() {
                                                                      return u.gemstone_colors[ae];
                                                                    },
                                                                    setValue: (hr) => {
                                                                      u.gemstone_colors[ae] = hr, b.setFieldValue(`gemstone_colors[${ae}]`, { touched: !0, valid: !0, value: hr.value });
                                                                    },
                                                                    valueToString: (hr) => hr.value,
                                                                    get values() {
                                                                      return u.COLORS.GEMS;
                                                                    },
                                                                    class: "tw:text-center tw:max-w-[60px]",
                                                                    children: (hr, eo) => {
                                                                      let oc = () => eo == null ? void 0 : eo().value, cf = () => eo == null ? void 0 : eo().checked;
                                                                      var ic = Xw(), Ca = rt(ic), uf = F(Ca, 2), df = C(uf);
                                                                      q(() => {
                                                                        qt(Ca, 1, `tw:mx-auto tw:w-10 tw:h-10 tw:block tw:rounded-full tw:border tw:border-solid tw:cursor-pointer ${cf() ? "tw:border-gray-800" : "tw:border-gray-300"}`), Br(Ca, `background-color: ${oc().hex}`), et(df, oc().label);
                                                                      }), O(hr, ic);
                                                                    },
                                                                    $$slots: { default: !0 }
                                                                  });
                                                                  var Sa = F(ds, 2);
                                                                  Ur(Sa, () => A_, (rc, hr) => {
                                                                    hr(rc, {});
                                                                  }), O(Qn, rn);
                                                                },
                                                                $$slots: { default: !0 }
                                                              });
                                                            }), q(() => {
                                                              var Ye, Te;
                                                              B(yt, "data-option", l(de)), B(yt, "data-value", ((Ye = l(Tt)) == null ? void 0 : Ye.value) || ""), B(yt, "data-total-options-count", u.COLORS.GEMS.length), B(yt, "id", l(ht)), et(le, `${l(de) ?? ""}:`), et(re, ((Te = l(Tt)) == null ? void 0 : Te.label) || "");
                                                            }), O(zt, mt);
                                                          },
                                                          $$slots: { default: !0 }
                                                        });
                                                      }), O(nn, He);
                                                    }), O(ze, Pe);
                                                  };
                                                  U(
                                                    Oe,
                                                    (ze) => {
                                                      l(G) === "gemstone_colors[0]" && u.part1Item.gemstone_groups_count > 0 && u.COLORS.GEMS.length > 0 && ze(pn);
                                                    },
                                                    Ge
                                                  );
                                                }
                                              };
                                              U(
                                                Rt,
                                                (Oe) => {
                                                  l(G) === "seal_colors" ? Oe(ne) : Oe(_e, !1);
                                                },
                                                ve
                                              );
                                            }
                                          };
                                          U(
                                            Ht,
                                            (Rt) => {
                                              l(G) === "engraving" ? Rt(pe) : Rt(Me, !1);
                                            },
                                            ee
                                          );
                                        }
                                      };
                                      U(
                                        St,
                                        (Ht) => {
                                          l(G) === "chain" ? Ht(Jt) : Ht(xe, !1);
                                        },
                                        It
                                      );
                                    }
                                  };
                                  U(
                                    ft,
                                    (St) => {
                                      l(G) === "band_style" ? St(At) : St(Lt, !1);
                                    },
                                    gt
                                  );
                                }
                              };
                              U(
                                X,
                                (ft) => {
                                  l(G) === "ring_size" ? ft(bt) : ft(xt, !1);
                                },
                                dt
                              );
                            }
                          };
                          U(
                            m,
                            (X) => {
                              l(G) === "stone" ? X(D) : X(J, !1);
                            },
                            M
                          );
                        }
                      };
                      U(
                        me,
                        (m) => {
                          l(G) === "metal" ? m(Bt) : m($, !1);
                        },
                        Ee
                      );
                    }
                  };
                  U(
                    Zt,
                    (me) => {
                      l(G) === "seal_size" ? me(ke) : me(Le, !1);
                    },
                    he
                  );
                }
              };
              U(
                ue,
                (Zt) => {
                  l(G) === "seal_design" ? Zt(Ke) : Zt(hn, !1);
                },
                Fe
              );
            }
          };
          U(
            Ft,
            (ue) => {
              l(G) === "style" ? ue(fe) : ue(ye, !1);
            },
            be
          );
        }
      };
      U(Ot, (Ft) => {
        l(G) === "school" ? Ft(Et) : Ft(Mt, !1);
      });
    }
    O(nt, pt);
  });
  var Ct = F(Q, 2);
  {
    var te = (nt) => {
      var G = hb();
      const pt = (ht, Tt = Re) => {
        var Vt = $w();
        Vt.__click = () => {
          b.goToStep(Tt()), window.innerWidth < 768 && lo().then(() => {
            s.scrollIntoView({ behavior: "smooth", block: "start" });
          });
        }, O(ht, Vt);
      };
      var Ot = F(C(G), 2), Et = C(Ot), Mt = C(Et), Ft = F(C(Mt), 2), be = C(Ft), fe = F(Ft, 2);
      {
        var ye = (ht) => {
          pt(ht, () => l(I).stepIndexByField.school);
        };
        U(fe, (ht) => {
          i.length > 1 && ht(ye);
        });
      }
      var ue = F(Mt, 2), Fe = F(C(ue), 2), Ke = C(Fe), hn = F(Fe, 2);
      {
        var Zt = (ht) => {
          pt(ht, () => l(I).stepIndexByField.seal_design);
        };
        U(hn, (ht) => {
          u.school.variants.length > 1 && ht(Zt);
        });
      }
      var he = F(ue, 2), ke = C(he), Le = C(ke), me = F(ke, 2), Ee = C(me), Bt = F(me, 2);
      pt(Bt, () => l(I).stepIndexByField.style);
      var $ = F(he, 2), m = F(C($), 2), M = C(m), D = F(m, 2);
      pt(D, () => l(I).stepIndexByField.seal_size);
      var J = F($, 2);
      {
        var X = (ht) => {
          var Tt = eb(), Vt = C(Tt);
          Vt.textContent = "Band:";
          var Wt = F(Vt, 2), Se = C(Wt), zt = C(Se), st = F(Se, 2);
          {
            var mt = (Yt) => {
              var Ut = tb(), le = C(Ut);
              q((Qt) => et(le, `(${Qt ?? ""})`), [() => Je(u.band.price, !0)]), O(Yt, Ut);
            };
            U(st, (Yt) => {
              u.band.price;
            });
          }
          var yt = F(Wt, 2);
          pt(yt, () => l(I).stepIndexByField.band_style), q(() => et(zt, u.band.label)), O(ht, Tt);
        };
        U(J, (ht) => {
          u.band && ht(X);
        });
      }
      var dt = F(J, 2), bt = C(dt), xt = C(bt), ft = F(bt, 2), gt = C(ft), At = F(ft, 2);
      pt(At, () => l(I).stepIndexByField.seal_colors);
      var Lt = F(dt, 2), St = C(Lt);
      St.textContent = "Seal Color:";
      var It = F(St, 2), Jt = C(It), xe = F(It, 2);
      pt(xe, () => l(I).stepIndexByField.seal_colors);
      var Ht = F(Lt, 2);
      {
        var ee = (ht) => {
          var Tt = nb(), Vt = C(Tt);
          Vt.textContent = "Logo Color:";
          var Wt = F(Vt, 2), Se = C(Wt), zt = F(Wt, 2);
          pt(zt, () => l(I).stepIndexByField.seal_colors), q((st) => et(Se, st), [
            () => {
              var st;
              return u.get_color_name_with_metal((st = u.part3Color) == null ? void 0 : st.label, "logo");
            }
          ]), O(ht, Tt);
        };
        U(Ht, (ht) => {
          var Tt;
          u.twoToneSelected && ((Tt = u.part3Color) != null && Tt.label) && ht(ee);
        });
      }
      var pe = F(Et, 2), Me = C(pe), Rt = C(Me);
      Rt.textContent = "Metal Type:";
      var ve = F(Rt, 2), ne = C(ve), _e = F(ve, 2);
      pt(_e, () => l(I).stepIndexByField.metal);
      var Oe = F(Me, 2);
      {
        var Ge = (ht) => {
          var Tt = ob(), Vt = C(Tt);
          Vt.textContent = "Stone Type:";
          var Wt = F(Vt, 2), Se = C(Wt), zt = C(Se), st = F(Se, 2);
          {
            var mt = (Yt) => {
              var Ut = rb(), le = C(Ut);
              q((Qt) => et(le, `(${Qt ?? ""})`), [
                () => Je(u.pricing.style_metal_stone, !0)
              ]), O(Yt, Ut);
            };
            U(st, (Yt) => {
              u.pricing.style_metal_stone;
            });
          }
          var yt = F(Wt, 2);
          pt(yt, () => l(I).stepIndexByField.stone), q(() => et(zt, u.stone)), O(ht, Tt);
        };
        U(Oe, (ht) => {
          var Tt;
          ((Tt = u.part1Item) != null && Tt.has_stones || u.can_select_stone) && ht(Ge);
        });
      }
      var pn = F(Oe, 2);
      {
        var ze = (ht) => {
          var Tt = _t(), Vt = rt(Tt);
          we(Vt, 17, () => u.gemstone_colors, sn, (Wt, Se, zt) => {
            var st = ib(), mt = C(st);
            mt.textContent = `${`Gemstone Color ${zt + 1}`}:`;
            var yt = F(mt, 2), Yt = C(yt), Ut = F(yt, 2);
            pt(Ut, () => l(I).stepIndexByField["gemstone_colors[0]"]), q(() => et(Yt, u.gemstone_colors[zt].label)), O(Wt, st);
          }), O(ht, Tt);
        };
        U(pn, (ht) => {
          u.part1Item.gemstone_groups_count > 0 && u.COLORS.GEMS.length > 0 && ht(ze);
        });
      }
      var Pe = F(pn, 2);
      we(Pe, 17, () => u.dynamicFieldEntries, sn, (ht, Tt) => {
        let Vt = () => l(Tt).field, Wt = () => l(Tt).value;
        var Se = ab();
        const zt = /* @__PURE__ */ L(() => Qe(Vt().price));
        var st = C(Se), mt = C(st), yt = F(st, 2), Yt = C(yt), Ut = C(Yt), le = F(Yt, 2);
        {
          var Qt = (Ce) => {
            var Ae = sb(), Be = C(Ae);
            q((Ye) => et(Be, `(${Ye ?? ""})`), [
              () => Je(l(zt), !0)
            ]), O(Ce, Ae);
          };
          U(le, (Ce) => {
            !Vt().required && l(zt) > 0 && Ce(Qt);
          });
        }
        var re = F(yt, 2);
        pt(re, () => l(I).stepIndexByField.seal_design), q(() => {
          et(mt, `${Vt().label ?? ""}:`), et(Ut, Wt());
        }), O(ht, Se);
      });
      var Ze = F(pe, 2);
      {
        var nn = (ht) => {
          var Tt = fb(), Vt = C(Tt);
          {
            var Wt = (st) => {
              var mt = cb(), yt = C(mt);
              yt.textContent = "Chain:";
              var Yt = F(yt, 2), Ut = C(Yt), le = C(Ut), Qt = F(Ut, 2);
              {
                var re = (Ae) => {
                  var Be = lb(), Ye = C(Be);
                  q((Te) => et(Ye, `(${Te ?? ""})`), [() => Je(u.pricing.chain, !0)]), O(Ae, Be);
                };
                U(Qt, (Ae) => {
                  u.pricing.chain;
                });
              }
              var Ce = F(Yt, 2);
              pt(Ce, () => l(I).stepIndexByField.chain), q(() => {
                var Ae;
                return et(le, (Ae = u.chain_root) == null ? void 0 : Ae.formatted_text);
              }), O(st, mt);
            };
            U(Vt, (st) => {
              u.chain_root && st(Wt);
            });
          }
          var Se = F(Vt, 2);
          {
            var zt = (st) => {
              var mt = db(), yt = C(mt);
              yt.textContent = "Engraving:";
              var Yt = F(yt, 2), Ut = C(Yt), le = C(Ut), Qt = F(Ut, 2);
              {
                var re = (Ae) => {
                  var Be = ub(), Ye = C(Be);
                  q((Te) => et(Ye, `(${Te ?? ""})`), [
                    () => Je(u.pricing.engraving, !0)
                  ]), O(Ae, Be);
                };
                U(Qt, (Ae) => {
                  u.pricing.engraving;
                });
              }
              var Ce = F(Yt, 2);
              pt(Ce, () => l(I).stepIndexByField.engraving), q(() => {
                B(Ut, "title", u.engraving), et(le, u.engraving);
              }), O(st, mt);
            };
            U(Se, (st) => {
              u.engraving_show && u.engraving && st(zt);
            });
          }
          O(ht, Tt);
        };
        U(Ze, (ht) => {
          (u.chain_root || u.engraving) && ht(nn);
        });
      }
      var Rr = F(Ze, 2), ae = C(Rr), He = C(ae);
      He.textContent = "Total:";
      var de = F(He, 2), De = C(de);
      q(
        (ht, Tt, Vt, Wt) => {
          et(be, u.school.name), et(Ke, u.variant.name), et(Le, `${u.pendant_or_ring ?? ""} Style:`), et(Ee, u.part1ItemDisplayText), et(M, ht), et(xt, `${`${u.pendant_or_ring} Color`}:`), et(gt, Tt), et(Jt, Vt), et(ne, u.metal), et(De, Wt);
        },
        [
          () => {
            var ht;
            return `${Vr(((ht = u.shape) == null ? void 0 : ht.value) || "")}${u.twoToneSelected ? " (2-tone)" : ""}`;
          },
          () => {
            var ht;
            return u.get_color_name_with_metal((ht = u.part1Color) == null ? void 0 : ht.label, "base");
          },
          () => {
            var ht;
            return u.get_color_name_with_metal((ht = u.part2Color) == null ? void 0 : ht.label, "seal");
          },
          () => Je(u.pricing.total)
        ]
      ), O(nt, G);
    };
    U(Ct, (nt) => {
      b.currentStep.id === "Review" && nt(te);
    });
  }
  var kt = F(tt, 2), Dt = C(kt);
  const We = /* @__PURE__ */ L(() => c || void 0);
  D_(Dt, {
    get wiz() {
      return b;
    },
    get w() {
      return u;
    },
    get portalsElement() {
      return d;
    },
    get rootElement() {
      return s;
    },
    get form_id() {
      return l(We);
    }
  });
  var Ue = F(Z, 2), jt = C(Ue), qe = C(jt);
  qe.__click = [pb, ut];
  var un = C(qe);
  qt(un, 0, "tw:size-2.5");
  var $e = F(Y, 2);
  mw($e, {
    get w() {
      return u;
    },
    get open() {
      return l(ut);
    },
    set open(nt) {
      z(ut, nt, !0);
    }
  });
  var dn = F($e, 2);
  {
    var fn = (nt) => {
      var G = Eb(), pt = C(G);
      B(pt, "name", "properties[School]"), B(pt, "title", "School");
      var Ot = F(pt, 2), Et = F(Ot, 2);
      B(Et, "name", "properties[Seal Size]"), B(Et, "title", "Seal Size");
      var Mt = F(Et, 2), Ft = F(Mt, 2);
      {
        var be = ($) => {
          var m = vb(), M = rt(m), D = F(M, 2);
          q(() => {
            ge(M, u.band.label), B(M, "form", c || void 0), ge(D, u.band.code), B(D, "form", c || void 0);
          }), O($, m);
        };
        U(Ft, ($) => {
          u.part1Item && Array.isArray(u.part1Item.bands) && u.part1Item.bands.length > 0 && u.band && $(be);
        });
      }
      var fe = F(Ft, 2);
      {
        var ye = ($) => {
          var m = gb();
          q(() => {
            ge(m, u.ring_size), B(m, "form", c || void 0);
          }), O($, m);
        };
        U(fe, ($) => {
          t.widget_for === "ring" && $(ye);
        });
      }
      var ue = F(fe, 2), Fe = F(ue, 2), Ke = F(Fe, 2);
      {
        var hn = ($) => {
          var m = mb();
          q(
            (M) => {
              ge(m, M), B(m, "form", c || void 0);
            },
            [
              () => {
                var M;
                return u.get_color_name_with_metal((M = u.part3Color) == null ? void 0 : M.label, "logo");
              }
            ]
          ), O($, m);
        };
        U(Ke, ($) => {
          u.twoToneSelected && $(hn);
        });
      }
      var Zt = F(Ke, 2);
      {
        var he = ($) => {
          var m = _b();
          B(m, "name", "properties[Chain]"), q(() => {
            var M;
            ge(m, (M = u.chain_root) == null ? void 0 : M.formatted_text), B(m, "form", c || void 0);
          }), O($, m);
        };
        U(Zt, ($) => {
          var m;
          (m = u.chain_root) != null && m.formatted_text && $(he);
        });
      }
      var ke = F(Zt, 2);
      we(ke, 17, () => u.dynamicFieldEntries, sn, ($, m) => {
        let M = () => l(m).field, D = () => l(m).value;
        var J = wb();
        q(() => {
          B(J, "name", `properties[${M().id}]`), B(J, "title", M().label), ge(J, D()), B(J, "form", c || void 0);
        }), O($, J);
      });
      var Le = F(ke, 2);
      {
        var me = ($) => {
          var m = yb(), M = rt(m);
          B(M, "name", "properties[Engraving ]");
          var D = F(M, 2);
          {
            var J = (X) => {
              var dt = _t(), bt = rt(dt);
              we(bt, 17, () => u.engraving_lines, sn, (xt, ft, gt) => {
                var At = bb();
                B(At, "name", `properties[_Engraving Line ${gt + 1}]`), B(At, "title", `Engraving Line ${gt + 1}`), q(() => {
                  ge(At, l(ft)), B(At, "form", c || void 0);
                }), O(xt, At);
              }), O(X, dt);
            };
            U(D, (X) => {
              u.engraving_lines.length > 0 && X(J);
            });
          }
          q(
            (X) => {
              ge(M, X), B(M, "form", c || void 0);
            },
            [() => u.engraving_lines.join(" | ")]
          ), O($, m);
        };
        U(Le, ($) => {
          u.engraving && $(me);
        });
      }
      var Ee = F(Le, 2);
      {
        var Bt = ($) => {
          var m = kb();
          const M = /* @__PURE__ */ L(() => u.iframeData.data.parts);
          var D = rt(m), J = F(D, 2), X = F(J, 2);
          {
            var dt = (St) => {
              var It = xb();
              q(() => {
                ge(It, `${l(M).part3.part} (${l(M).part3.color})`), B(It, "form", c || void 0);
              }), O(St, It);
            };
            U(X, (St) => {
              l(M).part3.part && St(dt);
            });
          }
          var bt = F(X, 2);
          {
            var xt = (St) => {
              var It = _t(), Jt = rt(It);
              we(Jt, 17, () => Object.entries(l(M).part1.colors.gems), sn, (xe, Ht) => {
                var ee = /* @__PURE__ */ L(() => ka(l(Ht), 2));
                let pe = () => l(ee)[0], Me = () => l(ee)[1];
                var Rt = Sb();
                const ve = /* @__PURE__ */ L(() => {
                  var _e;
                  return (_e = pe().match(/\d+/)) == null ? void 0 : _e[0];
                }), ne = /* @__PURE__ */ L(() => u.COLORS.GEMS.find((_e) => _e.value === Me()));
                q(() => {
                  B(Rt, "name", `properties[Gem group ${l(ve)}]`), B(Rt, "title", `Gem group ${l(ve)}`), ge(Rt, l(ne).label), B(Rt, "form", c || void 0);
                }), O(xe, Rt);
              }), O(St, It);
            };
            U(bt, (St) => {
              l(M).part1.colors.gems && St(xt);
            });
          }
          var ft = F(bt, 2);
          {
            var gt = (St) => {
              var It = _t();
              const Jt = /* @__PURE__ */ L(() => u.iframeData.src);
              var xe = rt(It);
              {
                var Ht = (ee) => {
                  var pe = Cb();
                  B(pe, "name", "properties[_3d_viewer_url]"), q(() => {
                    ge(pe, l(Jt)), B(pe, "form", c || void 0);
                  }), O(ee, pe);
                };
                U(xe, (ee) => {
                  l(Jt) && ee(Ht);
                });
              }
              O(St, It);
            };
            U(ft, (St) => {
              St(gt);
            });
          }
          var At = F(ft, 2);
          {
            var Lt = (St) => {
              var It = Ab();
              q(
                (Jt) => {
                  B(It, "name", `properties[${t.line_item_prop__price}]`), B(It, "title", `Total Price -> ${u.pricing.total}`), ge(It, Jt), B(It, "form", c || void 0);
                },
                [
                  () => (Number(u.pricing.total) * 100).toFixed(0)
                ]
              ), O(St, It);
            };
            U(At, (St) => {
              t.line_item_prop__price && Qe(u.pricing.total) > 0 && St(Lt);
            });
          }
          q(() => {
            ge(D, `${l(M).part1.part} (${l(M).part1.colors.tone1})`), B(D, "form", c || void 0), ge(J, `${l(M).part2.part} (${l(M).part2.color})`), B(J, "form", c || void 0);
          }), O($, m);
        };
        U(Ee, ($) => {
          $(Bt);
        });
      }
      q(
        ($, m, M) => {
          Br(G, y ? "" : "display: none;"), ge(pt, `${u.selectedSchool} (${u.variant.name})`), B(pt, "form", c || void 0), B(Ot, "name", `properties[${u.pendant_or_ring} Style]`), B(Ot, "title", `${u.pendant_or_ring} Style`), ge(Ot, u.part1Item ? u.part1Item.label !== u.part1Item.value ? `${u.part1Item.label} (${u.part1Item.value})` : u.part1Item.value : ""), B(Ot, "form", c || void 0), ge(Et, $), B(Et, "form", c || void 0), ge(Mt, u.metal_stone), B(Mt, "form", c || void 0), B(ue, "name", `properties[${u.pendant_or_ring ?? ""} Color]`), B(ue, "title", `${u.pendant_or_ring ?? ""} Color`), ge(ue, m), B(ue, "form", c || void 0), ge(Fe, M), B(Fe, "form", c || void 0);
        },
        [
          () => {
            var $;
            return `${Vr(($ = u.shape) == null ? void 0 : $.value) || ""}${u.twoToneSelected ? " (2-tone)" : ""}`;
          },
          () => {
            var $;
            return u.get_color_name_with_metal(($ = u.part1Color) == null ? void 0 : $.label, "base");
          },
          () => {
            var $;
            return u.get_color_name_with_metal(($ = u.part2Color) == null ? void 0 : $.label, "seal");
          }
        ]
      ), O(nt, G);
    };
    U(dn, (nt) => {
      nt(fn);
    });
  }
  var Mn = F(dn, 2);
  {
    var Jn = (nt) => {
      var G = Ob(), pt = C(G), Ot = C(pt);
      q(
        (Et) => et(Ot, `${Et ?? ""}
    `),
        [
          () => JSON.stringify(u.iframeData, null, 2)
        ]
      ), O(nt, G);
    };
    U(Mn, (nt) => {
      y && nt(Jn);
    });
  }
  var zn = F(Mn, 2);
  {
    var Dn = (nt) => {
      var G = Tb(), pt = C(G), Ot = C(pt);
      q(
        (Et) => et(Ot, `${Et ?? ""}
    `),
        [
          () => JSON.stringify({ ...u.state_values, ...u.dynamicFieldValues }, null, 2)
        ]
      ), O(nt, G);
    };
    U(zn, (nt) => {
      R && nt(Dn);
    });
  }
  q(() => qt(kt, 1, `tw:border-t tw:px-4 tw:py-4 ${b.isLast ? "" : "tw:hidden"} tw:md:block`)), O(e, E), Gt();
}
Xn(["input", "change", "click"]);
function lf(e) {
  return e === "1" || e === "2";
}
let js = new URL(window.location.href);
const Nb = js.searchParams.get("encconf");
let Ws = js;
Nb && (Ws = af.decrypt(Ws), js.searchParams.delete("encconf"), window.history.replaceState(null, "", js.href));
let _l = Ws.searchParams.get("portal_version") || "1";
lf(_l) || (_l = "1");
const Rb = ["pendant", "ring"];
function Fb(e) {
  var ut;
  let t = e;
  if (!e)
    return console.error("Missing props"), !1;
  e.update_url_params !== !0 && (e.update_url_params = !1), e.initial_query_string || (t.initial_query_string = Ws.search || ""), lf(e.portal_version) ? t.portal_version = e.portal_version : t.portal_version = _l;
  const n = e.widget_for;
  if (!Rb.includes(n))
    return console.error("Invalid widget_for", { widget_for: n }), !1;
  let r = e.schools_data;
  if (!r || !Lb(r))
    return console.error("Invalid schools_data"), !1;
  r = r.reduce((E, [V, K]) => {
    const Y = K.variants.filter((Z) => Z.supported_on[n]);
    return Y.length > 0 && E.push([
      V,
      { ...K, variants: Y }
      // Shallow copy to avoid mutations
    ]), E;
  }, []), t.schools_data = r;
  let o = e.style_codes || e.codes;
  if (!o || !Mb(o))
    return console.error("Invalid part1 codes"), !1;
  t.style_codes = o.reduce((E, V) => {
    const [K, Y] = V;
    return Y.supported_on[n] && E.push(V), E;
  }, []);
  let i = e.iframe_id;
  if (i != null && typeof i != "string")
    return console.error("Invalid iframe id"), t.iframe_id = null, !1;
  let s = e.form_id;
  s != null && typeof s != "string" && (console.error("Invalid form_id"), t.form_id = null);
  let d = e.debug;
  if (t.debug = d === "true" || d === "1" || d === !0, e.initial_school_code) {
    const E = e.initial_school_code, V = r.find(
      ([K, Y]) => Y.variants.some((Z) => K === E || Z.code === E)
    );
    V && (t.schools_data = [V]);
  }
  let a = e.metal_stone_combinations;
  if (!a || !Array.isArray(a) || a.length < 1 || !a.every((E) => typeof E == "string"))
    return console.error("Invalid stone types"), !1;
  let c = [], g = [];
  for (let E = 0, V = a.length; E < V; E++) {
    const [K, Y] = a[E].split(" / ").map((Z) => Z.trim());
    K && Y && (c.indexOf(K) === -1 && c.push(K), g.indexOf(Y) === -1 && g.push(Y));
  }
  t.all_metals = c, t.all_stones = g;
  let h = e.style_size_stone_combinations;
  if (!h || !Array.isArray(h) || h.length < 1 || !h.every(
    (E) => Array.isArray(E) && E.length === 4 && typeof E[0] == "string" && typeof E[1] == "string" && typeof E[2] == "string" && typeof E[3] == "string" && Number.isFinite(Number(E[3]))
  ))
    return console.error("Invalid style_size_stone_combinations"), !1;
  t.style_size_stone_combinations = h;
  let p = /* @__PURE__ */ new Map();
  for (let E = 0, V = t.style_size_stone_combinations.length; E < V; E++) {
    const [K, Y, Z, ot] = t.style_size_stone_combinations[E], P = `${K}_${Y}_${Z}`;
    p.set(P, { style: K, size: Y, metal_stone: Z, price: ot });
  }
  t.style_size_stone_combinations_hashmap = p;
  let _ = e.band_metal_stone_combinations;
  if (!_ || !Array.isArray(_) || !_.every(
    (E) => Array.isArray(E) && E.length === 3 && typeof E[0] == "string" && typeof E[1] == "string" && typeof E[2] == "string" && Number.isFinite(Number(E[2]))
  ))
    return console.error("Invalid band_metal_stone_combinations", _), !1;
  t.band_metal_stone_combinations = _, t.band_metal_stone_combinations_hashmap = _.reduce((E, V) => {
    const [K, Y, Z] = V, ot = `${K}_${Y}`;
    return E[ot] = { band_code: K, metal_stone: Y, price: Z }, E;
  }, {});
  const w = e.engraving_pricing || {};
  Object.prototype.toString.call(w) !== "[object Object]" && (e.engraving_pricing = {});
  let x = e.addons_pricing ?? { two_tone: "", engraving: "" };
  if (!(x && "two_tone" in x && "engraving" in x && typeof x.two_tone == "string" && typeof x.engraving == "string" && Number.isFinite(Number(x.two_tone)) && Number.isFinite(Number(x.engraving))))
    return console.error("Invalid addons_pricing", x), !1;
  const k = {
    two_tone: Number(x.two_tone),
    engraving: Number(x.engraving)
  };
  k.two_tone <= 0 && (t.addons_pricing.two_tone = ""), k.engraving <= 0 && (t.addons_pricing.engraving = "");
  let y;
  t.addons_pricing.metal_color_additional_price && Object.keys(t.addons_pricing.metal_color_additional_price).forEach((E) => {
    var K;
    const V = (K = t.addons_pricing.metal_color_additional_price) == null ? void 0 : K[E];
    V && Object.keys(V).forEach((Y) => {
      if (!t.metal_colors.some((tt) => tt.value === Y)) return;
      const ot = V[Y];
      if (!ot) return;
      const P = Number(ot);
      isNaN(P) || !Number.isFinite(P) || P <= 0 || (y || (y = {}), y[E] || (y[E] = {}), y[E][Y] || (y[E][Y] = ot));
    });
  }), t.addons_pricing.metal_color_additional_price = y;
  let R;
  t.addons_pricing.seal_color_additional_price && Object.keys(t.addons_pricing.seal_color_additional_price).forEach((E) => {
    var K;
    const V = (K = t.addons_pricing.seal_color_additional_price) == null ? void 0 : K[E];
    V && Object.keys(V).forEach((Y) => {
      if (!t.metal_colors.some((tt) => tt.value === Y)) return;
      const ot = V[Y];
      if (!ot) return;
      const P = Number(ot);
      isNaN(P) || !Number.isFinite(P) || P <= 0 || (R || (R = {}), R[E] || (R[E] = {}), R[E][Y] || (R[E][Y] = ot));
    });
  }), t.addons_pricing.seal_color_additional_price = R;
  let A = typeof e.line_item_prop__price == "string" ? e.line_item_prop__price.trim() : null;
  A || (A = "_cl_options_price"), t.line_item_prop__price = A;
  const S = e.metal_colors || [];
  if (!S || !Array.isArray(S) || !S.every(
    (E) => E.value && E.label && E.hex && typeof E.value == "string" && typeof E.label == "string" && typeof E.hex == "string" && E.hex.startsWith("#") && E.hex.length > 3
  ))
    return console.error("Invalid gemstone colors"), !1;
  t.metal_colors = S;
  const u = e.gemstone_colors || [];
  if (!u || !Array.isArray(u) || !u.every(
    (E) => E.value && E.label && E.hex && typeof E.value == "string" && typeof E.label == "string" && typeof E.hex == "string" && E.hex.startsWith("#") && E.hex.length > 3
  ))
    return console.error("Invalid gemstone colors"), !1;
  t.gemstone_colors = u;
  let T = e.chains_pricing;
  if (!T || !Array.isArray(T) || !T.every(
    (E) => Array.isArray(E) && E.length === 4 && typeof E[0] == "string" && typeof E[1] == "string" && typeof E[2] == "string" && typeof E[3] == "string" && Number.isFinite(Number(E[3]))
  ))
    return console.error("Invalid chains_pricing"), !1;
  t.chains_pricing = T;
  let I = {};
  for (const [E, V, K, Y] of T)
    I[V] ?? (I[V] = {}), (ut = I[V])[K] ?? (ut[K] = {}), I[V][K][E] = { length: E, metal: V, color: K, price: Y };
  t.chains_tree = I;
  let b = e.ring_sizes;
  if (!Array.isArray(b))
    return console.error("Invalid ring_sizes. Must be an array of strings"), !1;
  if (b = lu(b), b.length < 1)
    return console.error("Invalid ring_sizes. Must have some items"), !1;
  t.ring_sizes = b;
  let wt = e.all_bands || [];
  if (!wt || wt.some((E) => !E || !E.label || !E.code || typeof E.has_stones != "boolean"))
    return console.error("Invalid band data"), !1;
  t.all_bands = lu(wt, (E) => E.code);
  let Pt = t.all_bands.reduce((E, V) => (E[V.code] = V, E), {});
  return t.bands_hashmap = Pt, t.dynamic_fields ? Array.isArray(t.dynamic_fields) && (t.dynamic_fields = t.dynamic_fields.reduce((E, V) => {
    var K;
    return !V || !V.code || !V.id || !V.label || !V.type || (E[K = V.code] || (E[K] = []), E[V.code].push(V)), E;
  }, {})) : t.dynamic_fields = {}, !0;
}
function Lb(e) {
  return !Array.isArray(e) || e.length < 1 ? !1 : e.every((t) => {
    if (!Array.isArray(t) || t.length !== 2) return !1;
    const [n, r] = t;
    if (!n || !r) return !1;
    const o = r == null ? void 0 : r.variants;
    if (!Array.isArray(o) || o.length < 1) return !1;
    const i = o.every((s) => {
      const { name: d, code: a, shapes: c } = s;
      return typeof d == "string" && typeof a == "string" && Array.isArray(c) && c.every((g) => {
        const { value: h, twoTone: p } = g;
        return (h === "N" || h === "E" || h === "L") && (p === "none" || p === "optional" || p === "only");
      });
    });
    return typeof n == "string" && typeof r == "object" && r.name === n && i;
  });
}
function Mb(e) {
  return !Array.isArray(e) || e.length < 1 ? !1 : e.every((t) => {
    if (!Array.isArray(t) || t.length !== 2) return !1;
    const [n, r] = t;
    let o = Number(r.gemstone_groups_count || 0);
    return (typeof o != "number" || isNaN(o) || !Number.isFinite(o) || o < 0 || o >= 30) && (o = 0), typeof n == "string" && r != null && r.value === n && typeof r.label == "string" && Array.isArray(r.shapes) && r.shapes.every((i) => i === "N" || i === "E" || i === "L") && typeof o == "number" && typeof r.has_stones == "boolean";
  });
}
function lu(e, t) {
  const n = /* @__PURE__ */ new Set();
  return e.filter((r) => {
    const o = t ? t(r) : r;
    if (typeof o != "string") throw new Error("key must be a string");
    return n.has(o) ? !1 : (n.add(o), !0);
  });
}
var zb = /* @__PURE__ */ j('<div class="3d-options-picker tailwindcss"><!></div>');
function Db(e, t) {
  Kt(t, !0);
  let n = /* @__PURE__ */ Cn(t, ["$$slots", "$$events", "$$legacy"]), r, o = /* @__PURE__ */ ct(null), i = /* @__PURE__ */ ct(null);
  is(() => {
    if (z(o, r.closest("x-3d-product-options"), !0), !l(o)) throw new Error("rootElement not found");
    l(o).classList.add("tailwindcss");
    const c = l(o).getAttribute("id");
    if (!c) throw new Error("rootElement id not found");
    let g = document.querySelector(`x-3d-product-options-portals[data-widget-id="${c}"]`);
    g || (g = document.createElement("x-3d-product-options-portals"), g.setAttribute("data-widget-id", c)), g.classList = "tailwindcss x-3d-product-options-portals", document.body.append(g), z(i, g, !0), l(o).__portalsElement = l(i), lo().then(() => {
      l(o).__loaded = !0, l(o).dispatchEvent(new CustomEvent("widget:loaded", {
        detail: {
          name: "x-3d-product-options",
          element: l(o)
        },
        bubbles: !0
      }));
    });
  });
  var s = zb(), d = C(s);
  {
    var a = (c) => {
      Ib(c, Rn(() => n, {
        get rootElement() {
          return l(o);
        },
        get portalsElement() {
          return l(i);
        }
      }));
    };
    U(d, (c) => {
      l(o) && c(a);
    });
  }
  co(s, (c) => r = c, () => r), O(e, s), Gt();
}
var Sr;
const Wr = class Wr extends HTMLElement {
  constructor() {
    super();
    N(this, Sr);
    it(this, "appInstance");
    it(this, "_connected");
    vt(this, Sr, null), this.appInstance = null, this._connected = !1;
  }
  async connectedCallback() {
    this._connected = !0, await Promise.resolve(), this._connected && this.init();
  }
  async disconnectedCallback() {
    this._connected = !1, await Promise.resolve(), this._connected;
  }
  get props() {
    if (f(this, Sr)) return f(this, Sr);
    let n = null;
    const r = this.querySelector('script[data-prop="data"][type="application/json"]');
    if (!r)
      throw new Error(
        `[${Wr.tag}] Missing <script type="application/json" data-prop="data">...<\/script> element`
      );
    try {
      n = JSON.parse(r.textContent || "null");
    } catch {
      n = null;
    }
    if (!n)
      throw new Error(`[${Wr.tag}] Invalid or missing data. Error parsing`);
    if (!Fb(n))
      throw new Error(`[${Wr.tag}] Invalid props`);
    return vt(this, Sr, n), f(this, Sr);
  }
  init() {
    let n = this.getAttribute("id");
    n || (n = `${Wr.tag}-${Math.random().toString(36).substr(2, 9)}`, this.setAttribute("id", n));
    const r = this.props, o = Yu(Db, {
      target: this,
      props: r
    });
    this.appInstance = o;
  }
};
Sr = new WeakMap(), it(Wr, "tag", "x-3d-product-options");
let ei = Wr;
customElements.get(ei.tag) || customElements.define(ei.tag, ei);

})();